/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  DateTime: { input: any; output: any; }
};

/** Response returned by the announcementsAndLinks query. */
export type AlAnnouncementsAndLinksResponse = {
  __typename?: 'ALAnnouncementsAndLinksResponse';
  /** An id of the response */
  id: Scalars['ID']['output'];
  /** Indicates whether there are new announcements. */
  isAnnouncementsNew?: Maybe<Scalars['Boolean']['output']>;
  /** List of news links, present on success. */
  newsLinks?: Maybe<Array<AlNewsLink>>;
  /** List of rule errors, present on failure. */
  ruleErrors?: Maybe<Array<AlRuleError>>;
  /** Flag indicating if the request was successful. */
  wasSuccessful: Scalars['Boolean']['output'];
};

/** A single news link item. */
export type AlNewsLink = {
  __typename?: 'ALNewsLink';
  creationDate?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  newsLinkType?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
};

/** A rule error returned by the announcements and links endpoint. */
export type AlRuleError = {
  __typename?: 'ALRuleError';
  /** Unique identifier for this error. */
  id: Scalars['ID']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

export type AutAuthenticationFlow = {
  __typename?: 'AutAuthenticationFlow';
  attributes?: Maybe<Array<AutConfigAttribute>>;
  type: AutAuthenticationFlowType;
};

export enum AutAuthenticationFlowType {
  OpenidConnectPkceBackChannel = 'OPENID_CONNECT__PKCE_BACK_CHANNEL',
  OpenidConnectPkceFrontChannel = 'OPENID_CONNECT__PKCE_FRONT_CHANNEL',
  Other = 'OTHER',
  UsernamePassword = 'USERNAME_PASSWORD'
}

export type AutAuthenticationResult = {
  __typename?: 'AutAuthenticationResult';
  expiresAt: Scalars['DateTime']['output'];
  isPasswordExpired: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  wasSuccessful?: Maybe<Scalars['Boolean']['output']>;
};

export type AutConfig = {
  __typename?: 'AutConfig';
  supportedAuthenticationFlows: Array<AutAuthenticationFlow>;
  supportedLogoutFlows: Array<AutLogoutFlow>;
};

export type AutConfigAttribute = {
  __typename?: 'AutConfigAttribute';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AutIdClaim = {
  claim: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AutLogoutFlow = {
  __typename?: 'AutLogoutFlow';
  attributes?: Maybe<Array<AutConfigAttribute>>;
  type: AutLogoutFlowType;
};

export enum AutLogoutFlowType {
  BackChannel = 'BACK_CHANNEL',
  FrontChannel = 'FRONT_CHANNEL'
}

export type AutParam = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AutUserInfo = {
  __typename?: 'AutUserInfo';
  address?: Maybe<Scalars['String']['output']>;
  aud?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  family_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  given_name?: Maybe<Scalars['String']['output']>;
  iss?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  preferred_username?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['String']['output']>;
  sub: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zoneinfo?: Maybe<Scalars['String']['output']>;
};

export type BasCmsSite = {
  __typename?: 'BasCmsSite';
  cmsSiteId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Represents a language available for a specific site. */
export type BasLanguage = {
  __typename?: 'BasLanguage';
  /** Indicates whether this language is active for the specified site */
  active: Scalars['Boolean']['output'];
  /** A unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** The ISO code of the language, e.g. 'en', 'es', 'ro' */
  isocode: Scalars['String']['output'];
  /** The display name of the language */
  name: Scalars['String']['output'];
  /** The native name of the language, e.g. 'Romanian', 'Spanish' */
  nativeName: Scalars['String']['output'];
};

/** Represents a base site in the commerce system. */
export type BasSite = {
  __typename?: 'BasSite';
  /** Unique identifier for the base site. */
  baseSiteId: Scalars['String']['output'];
  defaultCurrency?: Maybe<CurCurrency>;
  defaultLanguage?: Maybe<BasLanguage>;
  /** A unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stores?: Maybe<Array<Maybe<BasStore>>>;
};

export type BasStore = {
  __typename?: 'BasStore';
  baseStoreId: Scalars['String']['output'];
  cmsSite?: Maybe<BasCmsSite>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum BsAvailabilityStatusAction {
  Error = 'ERROR',
  NoRestriction = 'NO_RESTRICTION',
  Warning = 'WARNING'
}

export enum BsAvailabilityStatusType {
  Green = 'GREEN',
  Red = 'RED',
  Yellow = 'YELLOW'
}

/** Represents a language that is available */
export type BsAvailableLanguage = {
  __typename?: 'BsAvailableLanguage';
  /** Indicates whether the language is active and available for use. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier. */
  id: Scalars['ID']['output'];
  /** Two‑letter ISO code of the language (e.g., 'en', 'de'). */
  isocode?: Maybe<Scalars['String']['output']>;
  /** Locale code associated with the language (e.g., 'en_US', 'de'). */
  localeIso?: Maybe<Scalars['String']['output']>;
  /** Display name of the language in English. */
  name?: Maybe<Scalars['String']['output']>;
  /** Native name of the language as written in its own script. */
  nativeName?: Maybe<Scalars['String']['output']>;
};

export type BsBaseSite = {
  __typename?: 'BsBaseSite';
  /** A unique identifier for the base site. */
  baseSiteId: Scalars['ID']['output'];
  /** A unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** Name of the base site. */
  name: Scalars['String']['output'];
};

/** Represents a base store in the commerce system. */
export type BsBaseStore = {
  __typename?: 'BsBaseStore';
  /** A list of all languages that are available. */
  availableLanguages?: Maybe<Array<Maybe<BsAvailableLanguage>>>;
  /** First column value in the balance section. */
  balanceSectionColumn1?: Maybe<Scalars['Int']['output']>;
  /** Second column value in the balance section. */
  balanceSectionColumn2?: Maybe<Scalars['Int']['output']>;
  /** Third column value in the balance section. */
  balanceSectionColumn3?: Maybe<Scalars['Int']['output']>;
  /** Fourth column value in the balance section. */
  balanceSectionColumn4?: Maybe<Scalars['Int']['output']>;
  /** Fifth column value in the balance section. */
  balanceSectionColumn5?: Maybe<Scalars['Int']['output']>;
  /** Base Site associated with the base store. */
  baseSite: BsBaseSite;
  /** Unique identifier for the base store. */
  baseStoreId: Scalars['String']['output'];
  /** Claim-related settings for the store. */
  claim?: Maybe<BsClaimConfiguration>;
  /** Contact information for the base store. */
  contactInformation?: Maybe<BsContactInformation>;
  /** The country code associated with the base store */
  country?: Maybe<CntCountry>;
  /** The Coveo config */
  coveoConfig?: Maybe<BsCoveoConfig>;
  /** The currencies available in the application. */
  currencies: Array<Maybe<CurCurrency>>;
  /** The currency used by default when none is selected. */
  defaultCurrency?: Maybe<CurCurrency>;
  /**
   * The language that should be used by default when no specific language
   * preference is provided.
   */
  defaultLanguage?: Maybe<BsAvailableLanguage>;
  /** Indicates if announcements and links are available for the store. */
  hasAnnouncementsAndLinks?: Maybe<Scalars['Boolean']['output']>;
  /** Boolean value that determines if the OTP button is displayed */
  hasOtpLogin?: Maybe<Scalars['Boolean']['output']>;
  /** Flag that indicates if there is a restriction on the products for the B2B unit */
  hasRestrictedProducts: Scalars['Boolean']['output'];
  /** A unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** Shows the Account Statement section on My account page. */
  isAccountStatementSection: Scalars['Boolean']['output'];
  /** Indicates if active business on behalf is enabled. */
  isActiveBusinessOnBehalf?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if b2b units are available. */
  isB2BUnitsEnabled: Scalars['Boolean']['output'];
  /** Shows the Balance section on My account page. */
  isBalanceSection: Scalars['Boolean']['output'];
  /** Indicates if batch code is enabled for the return request cart page. */
  isBatchCodeEnabledForReturn: Scalars['Boolean']['output'];
  /** Flag that indicates if the expected delivery date is shown in order details page */
  isCatalogLinkVisible: Scalars['Boolean']['output'];
  /** Flag that indicated if the confirmed quantity is shown in order details page */
  isConfirmedQuantityShown: Scalars['Boolean']['output'];
  /** Flag that indicated if the delivered quantity is shown in order details page */
  isDeliveredQuantityShown: Scalars['Boolean']['output'];
  /** Flag that indicates either delivery download is enabled in purchase history page */
  isDeliveryDownload: Scalars['Boolean']['output'];
  /** Shows the Account Details section on My account page. */
  isDetailsSection: Scalars['Boolean']['output'];
  /** Flag that indicates either billing document download is enabled in purchase history page */
  isEDocumentDownload: Scalars['Boolean']['output'];
  /** Enables the Assignment field on My account page. */
  isEnableAssignments: Scalars['Boolean']['output'];
  /** Flag that enables terms and conditions for simulation page */
  isEnabledTAndC: Scalars['Boolean']['output'];
  /** Flag that indicates if Excel download is enabled in purchase history page */
  isExcelDownload: Scalars['Boolean']['output'];
  /** Flag that indicates if Excel download is enabled in purchase history page */
  isExcelDownloadAccount: Scalars['Boolean']['output'];
  /** Flag that indicates if the expected delivery date is shown in order details page */
  isExpectedDeliveryDateShown: Scalars['Boolean']['output'];
  /** Enables the extended Account Statement and Send Payment functionality. */
  isExtendedAccountStatementEnabled: Scalars['Boolean']['output'];
  /** Indicates if external tax calculation is enabled. */
  isExternalTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Boolean value that determines if the search facets are displayed */
  isFacetSearchEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Boolean value that determines if the order options are displayed */
  isHideOrderOptions?: Maybe<Scalars['Boolean']['output']>;
  /** Hides the Sold-To and Payer fields on My account page. */
  isHideSoldToAndPayer: Scalars['Boolean']['output'];
  /** Enables Payment Advice template download and upload functionality. */
  isPaymentAdviceUploadEnabled: Scalars['Boolean']['output'];
  /** Indicates if price difference claim is enabled. */
  isPriceDiffClaimEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Flag that enables the product stock tag */
  isProductStockTagEnabled: Scalars['Boolean']['output'];
  /** Boolean value that determines if purchase order field is mandatory in the checkout page */
  isPurchaseOrderMandatory: Scalars['Boolean']['output'];
  /** Indicates if return order upload is enabled for the store. */
  isReturnOrderUploadEnabled: Scalars['Boolean']['output'];
  /** Indicates if return order request is enabled for the store. */
  isReturnRequestEnabled: Scalars['Boolean']['output'];
  /** Indicates if the shop is hidden from the selection page. */
  isShopHiddenFromSelectionPage?: Maybe<Scalars['Boolean']['output']>;
  /** Splits debit and credit documents on My account page. */
  isSplitDebitAndCredit: Scalars['Boolean']['output'];
  /** Boolean value that determines */
  isVehicleOptimization: Scalars['Boolean']['output'];
  /** Indicates if web chat is enabled for the store. */
  isWebChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum order value check setting. */
  maxOrderValueCheck?: Maybe<Scalars['String']['output']>;
  /** Minimum order quantity check setting. */
  minOrderQuantityCheck?: Maybe<Scalars['String']['output']>;
  /** Unit for minimum order quantity. */
  minOrderQuantityUnit?: Maybe<BsUnitData>;
  /** Minimum order value check setting. */
  minOrderValueCheck?: Maybe<Scalars['String']['output']>;
  /** Minimum order weight check setting. */
  minOrderWeightCheck?: Maybe<Scalars['String']['output']>;
  /** The name of the base store. */
  name: Scalars['String']['output'];
  /** Boolean value that determines if the product reviews are displayed */
  productAvailabilityActions: Array<Maybe<BsProductAvailabilityAction>>;
  /** Indicates the purchase history types. */
  purchaseHistoryTypes: Array<Maybe<PurchaseHistoryTypeEnum>>;
  /** Image associated with the shop. */
  shopImage?: Maybe<BsMedia>;
  /** Process code used for submitting orders. */
  submitOrderProcessCode?: Maybe<Scalars['String']['output']>;
  /** The type of the vehicle */
  vehicleOptimizationType?: Maybe<BsVehicleOptimizationEnum>;
  /** Base value for weight calculations. */
  weightBase?: Maybe<Scalars['String']['output']>;
  /** Unit for weight. */
  weightUnit?: Maybe<BsUnit>;
};

export type BsClaimConfiguration = {
  __typename?: 'BsClaimConfiguration';
  /** Indicates if claim type for missing discounts is available. */
  hasClaimTypeMissingDiscounts: Scalars['Boolean']['output'];
  /** Indicates if claim type for price difference is available. */
  hasClaimTypePriceDiff: Scalars['Boolean']['output'];
  /** Indicates if claim type for refusal is available. */
  hasClaimTypeRefusal: Scalars['Boolean']['output'];
  /** Indicates if claim type for return is available. */
  hasClaimTypeReturn: Scalars['Boolean']['output'];
  /** Indicates if claim type for TTS is available. */
  hasClaimTypeTTS: Scalars['Boolean']['output'];
  /** Indicates if claim type for taxes is available. */
  hasClaimTypeTaxes: Scalars['Boolean']['output'];
  /** Indicates if Nestle reference missing discounts is disabled. */
  isDisableNestleReferenceMissingDiscounts: Scalars['Boolean']['output'];
  /** Indicates if Nestle reference price difference is disabled. */
  isDisableNestleReferencePriceDiff: Scalars['Boolean']['output'];
  /** Indicates if Nestle reference refusal is disabled. */
  isDisableNestleReferenceRefusal: Scalars['Boolean']['output'];
  /** Indicates if Nestle reference return is disabled. */
  isDisableNestleReferenceReturn: Scalars['Boolean']['output'];
  /** Indicates if Nestle reference TTS is disabled. */
  isDisableNestleReferenceTTS: Scalars['Boolean']['output'];
  /** Indicates if Nestle reference taxes is disabled. */
  isDisableNestleReferenceTaxes: Scalars['Boolean']['output'];
  /** Indicates if downloadable claim detail documents is enabled. */
  isDownloadClaimDetailDocumentsEnabled: Scalars['Boolean']['output'];
  /** Indicates if downloadable claim is enabled. */
  isDownloadClaimEnabled: Scalars['Boolean']['output'];
  /** Indicates if Nestle reference validation is enabled for the store. */
  isNestleReferenceValidationEnabled: Scalars['Boolean']['output'];
  /** Indicates if notes for create claims is enabled. */
  isNotesForCreateClaimEnabled: Scalars['Boolean']['output'];
  /** Indicates if product level claim is enabled. */
  isProductLevelClaimEnabled: Scalars['Boolean']['output'];
};

/** Contact information for the base store. */
export type BsContactInformation = {
  __typename?: 'BsContactInformation';
  /** Contact address for the base store. */
  address?: Maybe<Scalars['String']['output']>;
  /** Contact email for the base store. */
  email?: Maybe<Scalars['String']['output']>;
  /** Contact name for the base store. */
  name?: Maybe<Scalars['String']['output']>;
  /** Contact telephone for the base store. */
  telephone?: Maybe<Scalars['String']['output']>;
};

/** Configuration settings for Coveo search and recommendation platform integration. */
export type BsCoveoConfig = {
  __typename?: 'BsCoveoConfig';
  /** Authentication token for document search functionality. */
  documentSearchToken?: Maybe<Scalars['String']['output']>;
  /** Flag indicating whether document search is enabled. */
  enableDocuments?: Maybe<Scalars['Boolean']['output']>;
  /** A unique identifier created for caching purposes */
  id: Scalars['ID']['output'];
  /** Unique identifier for the Coveo organization. */
  organizationID?: Maybe<Scalars['String']['output']>;
  /** Identifier for the search hub used to group search interfaces. */
  searchHub?: Maybe<Scalars['String']['output']>;
  /** Collection of slot IDs used for content targeting and placement. */
  slotIDs?: Maybe<BsSlotIds>;
  /** Unique identifier for tracking user interactions and analytics. */
  trackingId?: Maybe<Scalars['String']['output']>;
};

export type BsLanguages = {
  __typename?: 'BsLanguages';
  /** A unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** The list of available languages. */
  languages?: Maybe<Array<Maybe<BsAvailableLanguage>>>;
};

/** Represents a media item in the commerce system. */
export type BsMedia = {
  __typename?: 'BsMedia';
  /** ID of the catalog containing the media. */
  catalogId?: Maybe<Scalars['String']['output']>;
  /** Version of the catalog containing the media. */
  catalogVersion?: Maybe<Scalars['String']['output']>;
  /** Unique code identifying the media item. */
  code?: Maybe<Scalars['String']['output']>;
  /** URL to download the media file. */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** URL to access the media. */
  url?: Maybe<Scalars['String']['output']>;
};

export type BsProductAvailabilityAction = {
  __typename?: 'BsProductAvailabilityAction';
  /** Availability status action */
  availabilityStatusAction?: Maybe<BsAvailabilityStatusAction>;
  /** Availability status type applicable on the product */
  availabilityStatusType?: Maybe<BsAvailabilityStatusType>;
  /** A unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
};

/** Represents a key-value pair for Coveo slot identification. */
export type BsSlotId = {
  __typename?: 'BsSlotId';
  /** The identifier key for the slot. */
  key?: Maybe<Scalars['String']['output']>;
  /** The value associated with the slot key. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Container for Coveo slot ID entries. */
export type BsSlotIds = {
  __typename?: 'BsSlotIds';
  /** List of slot ID key-value pairs for content targeting. */
  entry?: Maybe<Array<Maybe<BsSlotId>>>;
};

/** Represents a unit of measurement in the commerce system. */
export type BsUnit = {
  __typename?: 'BsUnit';
  /** Unit code. */
  code?: Maybe<Scalars['String']['output']>;
  /** Display value for the unit. */
  displayValue?: Maybe<Scalars['String']['output']>;
  /** Localized code for the unit. */
  localizedCode?: Maybe<Scalars['String']['output']>;
  /** Name of the unit. */
  name?: Maybe<Scalars['String']['output']>;
  /** SAP code for the unit. */
  sapCode?: Maybe<Scalars['String']['output']>;
};

export type BsUnitData = {
  __typename?: 'BsUnitData';
  /** Unit code. */
  code?: Maybe<Scalars['String']['output']>;
  /** Display value for the unit. */
  displayValue?: Maybe<Scalars['String']['output']>;
  /** Localized code for the unit. */
  localizedCode?: Maybe<Scalars['String']['output']>;
  /** Name of the unit. */
  name?: Maybe<Scalars['String']['output']>;
  /** SAP code for the unit. */
  sapCode?: Maybe<Scalars['String']['output']>;
};

/** The types of vehicle optimization */
export enum BsVehicleOptimizationEnum {
  Ltt = 'LTT',
  Vu = 'VU'
}

export type BuB2bUnit = {
  __typename?: 'BuB2bUnit';
  /** B2B unit's address */
  address: Scalars['String']['output'];
  /** B2B unit's number */
  b2bNumber: Scalars['String']['output'];
  /** Unique identifier for the response */
  b2bUnitId: Scalars['String']['output'];
  /** Indicates if the B2B unit has restricted products */
  hasRestrictedProducts: Scalars['Boolean']['output'];
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** Name of the customer/b2bunit */
  name: Scalars['String']['output'];
};

export type BuB2bUnitInfo = {
  __typename?: 'BuB2bUnitInfo';
  /** Formatted address */
  address?: Maybe<Scalars['String']['output']>;
  /** Country name */
  country?: Maybe<CntCountry>;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** Company name */
  name: Scalars['String']['output'];
  /** Region name */
  region?: Maybe<Scalars['String']['output']>;
  /** Telephone number */
  telephone?: Maybe<Scalars['String']['output']>;
};

export type ByShipToParty = {
  __typename?: 'ByShipToParty';
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** The name of ship to party element */
  name: Scalars['String']['output'];
  /** The value of ship to party element */
  value: Scalars['String']['output'];
};

/** Represents the response object containing a list of payment methods. */
export type CardPaymentMethodsResponse = {
  __typename?: 'CardPaymentMethodsResponse';
  /** Unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** List of saved payment methods for the user. */
  payments: Array<PayCPaymentMethod>;
};

export type CardRemoveResponse = {
  __typename?: 'CardRemoveResponse';
  /** Unique identifier for caching purposes */
  id: Scalars['ID']['output'];
  /** Indicates if the card was successfully removed */
  wasSuccessful: Scalars['Boolean']['output'];
};

export type CardSelectResponse = {
  __typename?: 'CardSelectResponse';
  /** Unique identifier for caching purposes */
  id: Scalars['ID']['output'];
  /** Indicates if the card was successfully selected */
  wasSuccessful: Scalars['Boolean']['output'];
};

export type CartDeliveryAddressResponse = {
  __typename?: 'CartDeliveryAddressResponse';
  id: Scalars['ID']['output'];
  wasSuccessfully: Scalars['Boolean']['output'];
};

export enum CartType {
  Emptycart = 'EMPTYCART',
  None = 'NONE',
  Ordercart = 'ORDERCART',
  Pricediffcart = 'PRICEDIFFCART',
  Returncart = 'RETURNCART'
}

/** Response for validate-and-add cart flow */
export type CartValidateEntriesAndAddResponse = {
  __typename?: 'CartValidateEntriesAndAddResponse';
  /** Add to cart response, present only when validation succeeds */
  addToCartResult?: Maybe<CrtChangeCartResponse>;
  /** Validation response for the submitted entries */
  validation: CrtValidateEntriesResponse;
};

/** Represents a single category in the catalog hierarchy. */
export type CatCategory = {
  __typename?: 'CatCategory';
  /** Internal category code used for referencing this category in the catalog. */
  categoryCode: Scalars['String']['output'];
  /** List of child categories (subcategories) under this category. */
  childCategories?: Maybe<Array<CatCategory>>;
  /** Unique identifier of the category. */
  id: Scalars['ID']['output'];
  /** Primary image associated with the category. */
  image?: Maybe<CatImage>;
  /** Display name of the category. */
  name: Scalars['String']['output'];
  /** URL-friendly slug for the category (used in navigation and SEO). */
  slug: Scalars['String']['output'];
};

/** Represents the response object for retrieving categories. */
export type CatGetCategoriesResponse = {
  __typename?: 'CatGetCategoriesResponse';
  /** List of categories returned by the query. */
  categories?: Maybe<Array<Maybe<CatCategory>>>;
  /** Unique identifier for this response object (useful for caching or tracing). */
  id: Scalars['ID']['output'];
};

/** Represents an image associated with a category. */
export type CatImage = {
  __typename?: 'CatImage';
  /** Format of the category image. */
  format?: Maybe<Scalars['String']['output']>;
  /** URL of the category image. */
  url?: Maybe<Scalars['String']['output']>;
};

export type ClClaim = {
  __typename?: 'ClClaim';
  /** General reference number for the claim, internal Nestlé activity/reference number. */
  activityNumber?: Maybe<Scalars['String']['output']>;
  /** Amount claimed by the customer. This is the total amount that the customer has requested for reimbursement or settlement. */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Amount approved for the claim. This is the amount that has been approved for reimbursement or settlement. */
  approvedAmount?: Maybe<Scalars['Float']['output']>;
  /**
   * Unique identifier for the claim
   * This is the primary key for the claim in the system.
   */
  claimId: Scalars['ID']['output'];
  /** Credit memo number associated with the claim */
  creditMemo?: Maybe<Scalars['String']['output']>;
  /** Currency code for the claim amounts. This indicates the currency in which the approvedAmount and amount fields are denominated. */
  currency?: Maybe<CurCurrency>;
  /** Customer's reference number for the claim. This is an optional field that can be used by the customer to track the claim using their own reference system. */
  customerClaimReference?: Maybe<Scalars['String']['output']>;
  /** Date when the claim was created. This is the date when the claim was initially submitted to the system. */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Description of the claim type. This provides additional context about the nature of the claim */
  description?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the claim has an associated PDF file. This can be used to determine if there are supporting documents attached to the claim. */
  hasPdfFile?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the claim. */
  id: Scalars['ID']['output'];
  /**
   *       Internal notes or remarks about the claim.                                                                                                                                                                                                     │
   * │     Used for tracking additional context or administrative information.
   */
  notes?: Maybe<Scalars['String']['output']>;
  /** Status of the claim. This indicates the current state of the claim in the processing workflow */
  status?: Maybe<Scalars['String']['output']>;
};

export type ClClaimError = ClClaimRuleError & {
  __typename?: 'ClClaimError';
  /** Unique identifier for this error. */
  id: Scalars['ID']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

export type ClClaimPayer = {
  __typename?: 'ClClaimPayer';
  name?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<Scalars['String']['output']>;
};

/** Input for a payer associated with the claim. */
export type ClClaimPayerInput = {
  /** Name of the payer. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Payer identifier. */
  payer?: InputMaybe<Scalars['String']['input']>;
};

export enum ClClaimReasonCodeEnum {
  Z02 = 'Z02',
  Z04 = 'Z04',
  Z05 = 'Z05',
  Z12 = 'Z12',
  Z18 = 'Z18',
  Z22 = 'Z22'
}

export type ClClaimRuleError = {
  /** Unique identifier for this error. */
  id: Scalars['ID']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

export enum ClClaimTypeEnum {
  MissingDiscounts = 'MISSING_DISCOUNTS',
  PriceDifference = 'PRICE_DIFFERENCE',
  Rebate = 'REBATE',
  Refusal = 'REFUSAL',
  Return = 'RETURN',
  Taxes = 'TAXES'
}

export type ClClaimUploadDocumentsResponse = {
  __typename?: 'ClClaimUploadDocumentsResponse';
  /** List of errors, present on failure. */
  errors?: Maybe<Array<ClClaimUploadError>>;
  /** Unique identifier for the response. */
  id: Scalars['ID']['output'];
  /** List of claim upload items, present on success. */
  items?: Maybe<Array<ClClaimUploadItem>>;
};

/** An error returned by the claim upload list endpoint. */
export type ClClaimUploadError = {
  __typename?: 'ClClaimUploadError';
  /** Application-specific error code. */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Internal exception message for debugging. */
  exceptionMessage?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the error. */
  id: Scalars['ID']['output'];
  /** Language in which the error message is returned. */
  language?: Maybe<Scalars['String']['output']>;
  /** Human-readable error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Position reference for the error. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Reason for the error. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The subject that caused the error. */
  subject?: Maybe<Scalars['String']['output']>;
  /** The type of subject that caused the error. */
  subjectType?: Maybe<Scalars['String']['output']>;
  /** Error type classification. */
  type?: Maybe<Scalars['String']['output']>;
};

/** Input for a file uploaded as part of a claim. */
export type ClClaimUploadFileInput = {
  /** Base64-encoded image bytes. */
  bytes: Scalars['String']['input'];
  /** MIME content type of the image. */
  contentType: Scalars['String']['input'];
  /** Original file name of the image. */
  originalFileName: Scalars['String']['input'];
};

/** Image details for a claim upload item. */
export type ClClaimUploadImage = {
  __typename?: 'ClClaimUploadImage';
  /** Base64-encoded image bytes. */
  bytes?: Maybe<Scalars['String']['output']>;
  /** MIME content type of the image. */
  contentType?: Maybe<Scalars['String']['output']>;
  /** Original file name of the image. */
  originalFileName?: Maybe<Scalars['String']['output']>;
};

/** A single claim upload configuration item. */
export type ClClaimUploadItem = {
  __typename?: 'ClClaimUploadItem';
  /** Whether this upload item is active. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies if file should be displayed on claimType MISSING_DISCOUNTS */
  claimTypeMissingDiscounts?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies if file should be displayed on claimType PRICE_DIFFERENCE */
  claimTypePriceDiff?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies if file should be displayed on claimType REFUSAL */
  claimTypeRefusal?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies if file should be displayed on claimType RETURN */
  claimTypeReturn?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies if file should be displayed on claimType REBATE */
  claimTypeTTS?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies if file should be displayed on claimType TAXES */
  claimTypeTaxes?: Maybe<Scalars['Boolean']['output']>;
  /** File format specification. */
  format?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the claim upload item. */
  id: Scalars['ID']['output'];
  /** Image associated with the upload item. */
  image?: Maybe<ClClaimUploadImage>;
  /** List of supported file formats. */
  supportFormat?: Maybe<Array<Scalars['String']['output']>>;
  /** Display title of the upload item. */
  title?: Maybe<Scalars['String']['output']>;
  /** Tooltip text for the upload item. */
  tooltip?: Maybe<Scalars['String']['output']>;
  /** Specifies if file is mandatory */
  zmandatory?: Maybe<Scalars['Boolean']['output']>;
};

export type ClClaimValidationResponse = {
  __typename?: 'ClClaimValidationResponse';
  /** Unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** Indicates whether the claim is valid or not. */
  isValid: Scalars['Boolean']['output'];
  /** Nestle reference for the claim validation. */
  nestleReference?: Maybe<Scalars['String']['output']>;
  /** List of payers associated with the claim. */
  payerList: Array<ClClaimPayer>;
  /** List of claim validation errors. */
  ruleErrors: Array<ClClaimError>;
};

/** An error returned by the create claim endpoint. */
export type ClCreateClaimError = {
  __typename?: 'ClCreateClaimError';
  /** Application-specific error code. */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Internal exception message for debugging. */
  exceptionMessage?: Maybe<Scalars['String']['output']>;
  /** Language in which the error message is returned. */
  language?: Maybe<Scalars['String']['output']>;
  /** Human-readable error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Position reference for the error. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Reason for the error. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The subject that caused the error. */
  subject?: Maybe<Scalars['String']['output']>;
  /** The type of subject that caused the error. */
  subjectType?: Maybe<Scalars['String']['output']>;
  /** Error type classification. */
  type?: Maybe<Scalars['String']['output']>;
};

/** Input for creating a new claim. */
export type ClCreateClaimInput = {
  /** Description of the activity. */
  activityDescription: Scalars['String']['input'];
  /**
   * Filter by internal Nestlé activity/reference number.
   * This is the supplier-side tracking identifier.
   * In UI it refers to the <<Nestle Reference>>
   */
  activityNumber: Scalars['String']['input'];
  /** Total claim amount. */
  claimAmount: Scalars['String']['input'];
  /** Claim Reason Code */
  claimReasonCode?: InputMaybe<ClClaimReasonCodeEnum>;
  /** This gets populated with the activityNumber when ClaimType is Rebate  */
  claimRebate?: InputMaybe<Scalars['String']['input']>;
  /** Type of the claim. */
  claimType: ClClaimTypeEnum;
  /** List of claim line items. */
  createClaimItem?: InputMaybe<Array<ClCreateClaimItemInput>>;
  /** Customer reference identifier. */
  customerClaimReference?: InputMaybe<Scalars['String']['input']>;
  /** Customer Reference */
  customerReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Additional notes for the claim.
   * maximum 100 characters
   */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** List of payers associated with the claim. */
  payerList?: InputMaybe<Array<ClClaimPayerInput>>;
  /** List of uploaded files associated with the claim. */
  uploadFiles?: InputMaybe<Array<ClClaimUploadFileInput>>;
};

/** Input for a single claim line item. */
export type ClCreateClaimItemInput = {
  /** Amount for this line item. */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** Material identifier. */
  material: Scalars['String']['input'];
  /** Quantity for this line item. */
  qty?: InputMaybe<Scalars['String']['input']>;
};

/** Response returned after attempting to create a claim. */
export type ClCreateClaimResponse = {
  __typename?: 'ClCreateClaimResponse';
  /** List of errors, present on failure. */
  errors?: Maybe<Array<ClCreateClaimError>>;
  /** An id of the response */
  id: Scalars['ID']['output'];
  /** Flag indicating if the request was successful. */
  wasSuccessful: Scalars['Boolean']['output'];
};

/** Date range options for filtering claims by creation date. */
export enum ClCreationEnum {
  /** Claims created in the last calendar month. */
  LastMonth = 'LAST_MONTH',
  /** Claims created in the last 7 days. */
  LastWeek = 'LAST_WEEK',
  /** Claims created in the last calendar year. */
  LastYear = 'LAST_YEAR',
  /** Claims created within a custom date range. */
  Period = 'PERIOD',
  /** Claims created since yesterday (last 24-48 hours). */
  SinceYesterday = 'SINCE_YESTERDAY',
  /** Claims created on a specific date. */
  SpecificDate = 'SPECIFIC_DATE',
  /** Claims created today. */
  Today = 'TODAY'
}

export type ClDocumentsDownloadResponse = {
  __typename?: 'ClDocumentsDownloadResponse';
  /** Base64 encoded Excel data for download, returned when the search is successful and contains results. */
  base64Data: Scalars['String']['output'];
  /** The filename of the downloaded Excel file. */
  filename: Scalars['String']['output'];
  /** Unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
};

/**
 * Filter criteria for searching claims.
 * All filters are optional except creationDate.
 */
export type ClSearchFilters = {
  /**
   * Filter by internal Nestlé activity/reference number.
   * This is the supplier-side tracking identifier.
   * In UI it refers to the <<Nestle Reference>>
   */
  activityNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by one or more B2B unit identifiers.
   * Useful for multi-organization searches.
   */
  b2bUnitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by specific claim number. */
  claimNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Important: do NOT use this field to filter by claim type. This is not a supported filter in the SAP Commerce search API and may lead to unbounded queries.
   * Filter by claim type.
   */
  claimType?: InputMaybe<ClClaimTypeEnum>;
  /**
   * Filter claims by creation date range.
   * Required field to prevent unbounded queries.
   */
  creationDate: ClCreationEnum;
  /**
   * Filter by customer's claim reference number.
   * This is the buyer-side tracking identifier.
   */
  customerClaimReference?: InputMaybe<Scalars['String']['input']>;
  /** Filter by custom date range. Required if creationDate is PERIOD */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by custom date range. Required if creationDate is SPECIFIC_DATE */
  specificDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by custom date range. Required if creationDate is PERIOD */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Important: do NOT use this field to filter by claim status. This is not a supported filter in the SAP Commerce search API and may lead to unbounded queries.
   * Filter by claim status.
   */
  status?: InputMaybe<ClStatusEnum>;
};

export type ClSearchResponse = {
  __typename?: 'ClSearchResponse';
  /** Base64 encoded Excel data for download, returned when the search is successful and contains results. */
  base64Data?: Maybe<Scalars['String']['output']>;
  /** List of claims. */
  claims: Array<ClClaim>;
  /** Unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
};

/** Status values for filtering claims by their current state in the claim search. */
export enum ClStatusEnum {
  Approved = 'APPROVED'
}

export enum CmmDistanceUom {
  Kilometer = 'KILOMETER',
  Mile = 'MILE'
}

/** ISO 639-1 two-letter language codes for ISO 639 macrolanguages */
export enum CmmLanguageCode {
  /** Afar */
  Aa = 'AA',
  /** Abkhazian */
  Ab = 'AB',
  /** Avestan */
  Ae = 'AE',
  /** Afrikaans */
  Af = 'AF',
  /** Akan */
  Ak = 'AK',
  /** Amharic */
  Am = 'AM',
  /** Aragonese */
  An = 'AN',
  /** Arabic */
  Ar = 'AR',
  /** Assamese */
  As = 'AS',
  /** Avaric */
  Av = 'AV',
  /** Aymara */
  Ay = 'AY',
  /** Azerbaijani */
  Az = 'AZ',
  /** Bashkir */
  Ba = 'BA',
  /** Belarusian */
  Be = 'BE',
  /** Bulgarian */
  Bg = 'BG',
  /** Bislama */
  Bi = 'BI',
  /** Bambara */
  Bm = 'BM',
  /** Bengali */
  Bn = 'BN',
  /** Tibetan */
  Bo = 'BO',
  /** Breton */
  Br = 'BR',
  /** Bosnian */
  Bs = 'BS',
  /** Catalan, Valencian */
  Ca = 'CA',
  /** Chechen */
  Ce = 'CE',
  /** Chamorro */
  Ch = 'CH',
  /** Corsican */
  Co = 'CO',
  /** Cree */
  Cr = 'CR',
  /** Czech */
  Cs = 'CS',
  /** Church Slavic, Old Slavonic, Church Slavonic, Old Bulgarian, Old Church Slavonic */
  Cu = 'CU',
  /** Chuvash */
  Cv = 'CV',
  /** Welsh */
  Cy = 'CY',
  /** Danish */
  Da = 'DA',
  /** German */
  De = 'DE',
  /** Divehi, Dhivehi, Maldivian */
  Dv = 'DV',
  /** Dzongkha */
  Dz = 'DZ',
  /** Ewe */
  Ee = 'EE',
  /** Greek, Modern (1453–) */
  El = 'EL',
  /** English */
  En = 'EN',
  /** Esperanto */
  Eo = 'EO',
  /** Spanish, Castilian */
  Es = 'ES',
  /** Estonian */
  Et = 'ET',
  /** Basque */
  Eu = 'EU',
  /** Persian */
  Fa = 'FA',
  /** Fulah */
  Ff = 'FF',
  /** Finnish */
  Fi = 'FI',
  /** Fijian */
  Fj = 'FJ',
  /** Faroese */
  Fo = 'FO',
  /** French */
  Fr = 'FR',
  /** Western Frisian */
  Fy = 'FY',
  /** Irish */
  Ga = 'GA',
  /** Gaelic, Scottish Gaelic */
  Gd = 'GD',
  /** Galician */
  Gl = 'GL',
  /** Guarani */
  Gn = 'GN',
  /** Gujarati */
  Gu = 'GU',
  /** Manx */
  Gv = 'GV',
  /** Hausa */
  Ha = 'HA',
  /** Hebrew */
  He = 'HE',
  /** Hindi */
  Hi = 'HI',
  /** Hiri Motu */
  Ho = 'HO',
  /** Croatian */
  Hr = 'HR',
  /** Haitian, Haitian Creole */
  Ht = 'HT',
  /** Hungarian */
  Hu = 'HU',
  /** Armenian */
  Hy = 'HY',
  /** Herero */
  Hz = 'HZ',
  /** Interlingua (International Auxiliary Language Association) */
  Ia = 'IA',
  /** Indonesian */
  Id = 'ID',
  /** Interlingue, Occidental */
  Ie = 'IE',
  /** Igbo */
  Ig = 'IG',
  /** Sichuan Yi, Nuosu */
  Ii = 'II',
  /** Inupiaq */
  Ik = 'IK',
  /** Ido */
  Io = 'IO',
  /** Icelandic */
  Is = 'IS',
  /** Italian */
  It = 'IT',
  /** Inuktitut */
  Iu = 'IU',
  /** Japanese */
  Ja = 'JA',
  /** Javanese */
  Jv = 'JV',
  /** Georgian */
  Ka = 'KA',
  /** Kongo */
  Kg = 'KG',
  /** Kikuyu, Gikuyu */
  Ki = 'KI',
  /** Kuanyama, Kwanyama */
  Kj = 'KJ',
  /** Kazakh */
  Kk = 'KK',
  /** Kalaallisut, Greenlandic */
  Kl = 'KL',
  /** Central Khmer */
  Km = 'KM',
  /** Kannada */
  Kn = 'KN',
  /** Korean */
  Ko = 'KO',
  /** Kanuri */
  Kr = 'KR',
  /** Kashmiri */
  Ks = 'KS',
  /** Kurdish */
  Ku = 'KU',
  /** Komi */
  Kv = 'KV',
  /** Cornish */
  Kw = 'KW',
  /** Kirghiz, Kyrgyz */
  Ky = 'KY',
  /** Latin */
  La = 'LA',
  /** Luxembourgish, Letzeburgesch */
  Lb = 'LB',
  /** Ganda */
  Lg = 'LG',
  /** Limburgan, Limburger, Limburgish */
  Li = 'LI',
  /** Lingala */
  Ln = 'LN',
  /** Lao */
  Lo = 'LO',
  /** Lithuanian */
  Lt = 'LT',
  /** Luba-Katanga */
  Lu = 'LU',
  /** Latvian */
  Lv = 'LV',
  /** Malagasy */
  Mg = 'MG',
  /** Marshallese */
  Mh = 'MH',
  /** Maori */
  Mi = 'MI',
  /** Macedonian */
  Mk = 'MK',
  /** Malayalam */
  Ml = 'ML',
  /** Mongolian */
  Mn = 'MN',
  /** Marathi */
  Mr = 'MR',
  /** Malay */
  Ms = 'MS',
  /** Maltese */
  Mt = 'MT',
  /** Burmese */
  My = 'MY',
  /** Nauru */
  Na = 'NA',
  /** Norwegian Bokmål */
  Nb = 'NB',
  /** North Ndebele */
  Nd = 'ND',
  /** Nepali */
  Ne = 'NE',
  /** Ndonga */
  Ng = 'NG',
  /** Dutch, Flemish */
  Nl = 'NL',
  /** Norwegian Nynorsk */
  Nn = 'NN',
  /** Norwegian */
  No = 'NO',
  /** South Ndebele */
  Nr = 'NR',
  /** Navajo, Navaho */
  Nv = 'NV',
  /** Chichewa, Chewa, Nyanja */
  Ny = 'NY',
  /** Occitan */
  Oc = 'OC',
  /** Ojibwa */
  Oj = 'OJ',
  /** Oromo */
  Om = 'OM',
  /** Oriya */
  Or = 'OR',
  /** Ossetian, Ossetic */
  Os = 'OS',
  /** Punjabi, Panjabi */
  Pa = 'PA',
  /** Pali */
  Pi = 'PI',
  /** Polish */
  Pl = 'PL',
  /** Pashto, Pushto */
  Ps = 'PS',
  /** Portuguese */
  Pt = 'PT',
  /** Quechua */
  Qu = 'QU',
  /** Romansh */
  Rm = 'RM',
  /** Rundi */
  Rn = 'RN',
  /** Romanian, Moldavian, Moldovan */
  Ro = 'RO',
  /** Russian */
  Ru = 'RU',
  /** Kinyarwanda */
  Rw = 'RW',
  /** Sanskrit */
  Sa = 'SA',
  /** Sardinian */
  Sc = 'SC',
  /** Sindhi */
  Sd = 'SD',
  /** Northern Sami */
  Se = 'SE',
  /** Sango */
  Sg = 'SG',
  /** Sinhala, Sinhalese */
  Si = 'SI',
  /** Slovak */
  Sk = 'SK',
  /** Slovenian */
  Sl = 'SL',
  /** Samoan */
  Sm = 'SM',
  /** Shona */
  Sn = 'SN',
  /** Somali */
  So = 'SO',
  /** Albanian */
  Sq = 'SQ',
  /** Serbian */
  Sr = 'SR',
  /** Swati */
  Ss = 'SS',
  /** Southern Sotho */
  St = 'ST',
  /** Sundanese */
  Su = 'SU',
  /** Swedish */
  Sv = 'SV',
  /** Swahili */
  Sw = 'SW',
  /** Tamil */
  Ta = 'TA',
  /** Telugu */
  Te = 'TE',
  /** Tajik */
  Tg = 'TG',
  /** Thai */
  Th = 'TH',
  /** Tigrinya */
  Ti = 'TI',
  /** Turkmen */
  Tk = 'TK',
  /** Tagalog */
  Tl = 'TL',
  /** Tswana */
  Tn = 'TN',
  /** Tonga (Tonga Islands) */
  To = 'TO',
  /** Turkish */
  Tr = 'TR',
  /** Tsonga */
  Ts = 'TS',
  /** Tatar */
  Tt = 'TT',
  /** Twi */
  Tw = 'TW',
  /** Tahitian */
  Ty = 'TY',
  /** Uighur, Uyghur */
  Ug = 'UG',
  /** Ukrainian */
  Uk = 'UK',
  /** Urdu */
  Ur = 'UR',
  /** Uzbek */
  Uz = 'UZ',
  /** Venda */
  Ve = 'VE',
  /** Vietnamese */
  Vi = 'VI',
  /** Volapük */
  Vo = 'VO',
  /** Walloon */
  Wa = 'WA',
  /** Wolof */
  Wo = 'WO',
  /** Xhosa */
  Xh = 'XH',
  /** Yiddish */
  Yi = 'YI',
  /** Yoruba */
  Yo = 'YO',
  /** Zhuang, Chuang */
  Za = 'ZA',
  /** Chinese */
  Zh = 'ZH',
  /** Zulu */
  Zu = 'ZU'
}

export type CmmMoney = {
  __typename?: 'CmmMoney';
  currency?: Maybe<Scalars['String']['output']>;
  /** Formatted currency and value. */
  formattedValue?: Maybe<Scalars['String']['output']>;
  /** Price type */
  priceType?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type CmmMoneyInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type CmsComponent = {
  __typename?: 'CmsComponent';
  children?: Maybe<Array<CmsComponent>>;
  name: Scalars['String']['output'];
  props?: Maybe<Array<CmsKeyValuePair>>;
};

export type CmsKeyValuePair = {
  __typename?: 'CmsKeyValuePair';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CmsKeyValuePairInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CmsResponse = {
  __typename?: 'CmsResponse';
  content?: Maybe<Array<Maybe<CmsComponent>>>;
};

export type CntCountry = {
  __typename?: 'CntCountry';
  currencies?: Maybe<Array<CurCurrency>>;
  flag?: Maybe<Scalars['String']['output']>;
  isoCode: Scalars['ID']['output'];
  languages?: Maybe<Array<LangLanguage>>;
  name: Scalars['String']['output'];
  native?: Maybe<Scalars['String']['output']>;
  phonePrefix?: Maybe<Scalars['String']['output']>;
  regions?: Maybe<Array<CntRegion>>;
  translations?: Maybe<Array<XltnTranslatedString>>;
};

export type CntCountryInput = {
  isoCode: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CntRegion = {
  __typename?: 'CntRegion';
  code?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum CntUsage {
  Billing = 'BILLING',
  Navigation = 'NAVIGATION',
  Profile = 'PROFILE',
  Shipping = 'SHIPPING'
}

export type CoutCheckoutResponse = {
  __typename?: 'CoutCheckoutResponse';
  /** The unique identifier for the response. */
  id: Scalars['ID']['output'];
  /** Flag that indicates if the request was successful */
  wasSuccessful: Scalars['Boolean']['output'];
};

export enum CoutDaysEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type CoutDeliveryDatesResponse = {
  __typename?: 'CoutDeliveryDatesResponse';
  /** The first delivery date available */
  date: Scalars['String']['output'];
  /** List of days when delivery is not available */
  noDeliveryDays: Array<Maybe<CoutDaysEnum>>;
};

/**
 * Represents the response returned after fetching available delivery vehicles, a list of all
 * available delivery vehicles
 */
export type CoutDeliveryVehicle = {
  __typename?: 'CoutDeliveryVehicle';
  /** A unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** Information about the delivery vehicle (weight, volume, number of selected vehicle). */
  vehicleOptimization?: Maybe<CoutDeliveryVehicleOptimization>;
  /** A list of vehicles */
  vehicles: Array<Maybe<CoutVehicle>>;
};

/** Represents loading and capacity metrics for the selected delivery vehicle */
export type CoutDeliveryVehicleOptimization = {
  __typename?: 'CoutDeliveryVehicleOptimization';
  /** A unique identifier for the selected vehicle */
  activeVehicleCode?: Maybe<Scalars['ID']['output']>;
  /** The footprint of products in the vehicle. */
  footprint?: Maybe<CoutVehicleAvailableUom>;
  /** The amount of cases that can be loaded in the vehicle. */
  fullCase?: Maybe<CoutVehicleAvailableUom>;
  /** The amount of layers that can be loaded in the vehicle. */
  fullLayer?: Maybe<CoutVehicleAvailableUom>;
  /** The amount of pallets that can be loaded in the vehicle. */
  fullPallet?: Maybe<CoutVehicleAvailableUom>;
  /** A unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** The number of the vehicle */
  vehicleNumber?: Maybe<Scalars['Float']['output']>;
  /** The type of the vehicle */
  vehicleType?: Maybe<Scalars['String']['output']>;
  /** The volume of products in the vehicle. */
  volume?: Maybe<CoutVehicleAvailableUom>;
  /** The weight of products in the vehicle. */
  weight?: Maybe<CoutVehicleAvailableUom>;
};

export enum CoutLoadLeadEnum {
  GreenCircle = 'GREEN_CIRCLE',
  GreyCircle = 'GREY_CIRCLE',
  GreyVehicleLead = 'GREY_VEHICLE_LEAD',
  RedCircle = 'RED_CIRCLE',
  YellowCircle = 'YELLOW_CIRCLE'
}

export type CoutUpdateResponse = {
  __typename?: 'CoutUpdateResponse';
  /** Indicates if the checkout operation was successful */
  wasSuccessful: Scalars['Boolean']['output'];
};

/**
 * Represents an individual delivery vehicle option, including identifiers and descriptive
 * details used for selection and optimization.
 */
export type CoutVehicle = {
  __typename?: 'CoutVehicle';
  /** The description of the vehicle. */
  description?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** A unique identifier for a vehicle. */
  vehicleId: Scalars['ID']['output'];
};

/**
 * Represents a measurable value and its corresponding unit of measure used for
 * vehicle optimization calculations such as weight, volume, or load counts.
 */
export type CoutVehicleAvailableUom = {
  __typename?: 'CoutVehicleAvailableUOM';
  /** A unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** The load lead information */
  loadLead?: Maybe<CoutLoadLeadEnum>;
  /** Represents the percentage of car that has been completed. */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Unit of measure */
  uom?: Maybe<Scalars['String']['output']>;
  /** The weight / layers / cases / pallets loaded. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Base interface for errors returned during add to cart. */
export type CrtAddToCartError = {
  /** Unique identifier for this error. */
  id: Scalars['ID']['output'];
  /** Error message to the developer or backup user message if none found in CMS */
  message: Scalars['String']['output'];
};

/** Union of all add to cart error types. */
export type CrtAddToCartErrors = CrtDuplicateLineItemError;

export type CrtAddToCartInput = {
  /** The identifier of a product */
  productCode: Scalars['String']['input'];
  /** Quantity of a product */
  quantity: Scalars['Int']['input'];
  /** Unit of a product */
  uom: Scalars['String']['input'];
};

/** Base interface for warnings returned during add to cart */
export type CrtAddToCartWarning = {
  /** Unique identifier for this warning. */
  id: Scalars['ID']['output'];
  /** Warning message to the developer or backup user message if none found in CMS */
  message: Scalars['String']['output'];
};

/** Union of all add to cart warning types. */
export type CrtAddToCartWarnings = CrtDuplicateLineItemWarning;

/** Represents a shopping cart containing items and their totals. */
export type CrtCart = {
  __typename?: 'CrtCart';
  /** The unique identifier of the cart */
  cartId: Scalars['ID']['output'];
  /** The type of the cart */
  cartType?: Maybe<CartType>;
  /** The delivery address assigned to the cart */
  deliveryAddress: Scalars['String']['output'];
  /** The delivery date selected by user */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  /** The quantity of products from cart */
  deliveryItemsQuantity?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** Flag that indicates if a cart is calculated */
  isCalculated?: Maybe<Scalars['Boolean']['output']>;
  /** Flag that indicates if the cart price is net */
  isNet?: Maybe<Scalars['Boolean']['output']>;
  /** Array of items in the cart. */
  items: Array<Maybe<CrtCartEntry>>;
  /** The type of the payment */
  paymentType?: Maybe<Scalars['String']['output']>;
  /** The purchaseOrderNumber introduced by user */
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  /** List of cart errors triggered during OMER validation. */
  ruleErrors?: Maybe<Array<CrtErrors>>;
  /** List of cart warnings triggered during OMER validation. */
  ruleWarnings?: Maybe<Array<CrtWarnings>>;
  /** Totals information for the cart. */
  totals?: Maybe<CrtCartTotals>;
};

/** Represents the items in the cart */
export type CrtCartEntry = {
  __typename?: 'CrtCartEntry';
  /** The base price */
  basePrice?: Maybe<CmmMoney>;
  /** The price which is specific to a user */
  customerPrice?: Maybe<PrdPrice>;
  /** The index of an entry in the cart */
  entryNumber: Scalars['Int']['output'];
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The list price */
  listPrice?: Maybe<PrdPrice>;
  /** One of the items in the cart. */
  product: PrdItem;
  /** Qunatity of an item in the cart */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** The unit of measure of the product added to cart */
  selectedUom?: Maybe<PrdUom>;
  /** The price which is the quantity multiplied by list price or customer price */
  totalPrice?: Maybe<CmmMoney>;
  /** The total weight of an entry in the cart */
  totalWeight?: Maybe<Scalars['String']['output']>;
};

/** Totals information for the cart. */
export type CrtCartTotals = {
  __typename?: 'CrtCartTotals';
  /** The currency used for the cart totals. */
  currency: CurCurrency;
  /** Unique identifier for the cart totals. */
  id: Scalars['ID']['output'];
  /** Subtotal amount for the cart before taxes and discounts. */
  subtotal: CmmMoney;
  /** Total amount for the cart after taxes and discounts. */
  total: CmmMoney;
  /** The total weight of all items in the cart, including units. */
  totalWeight?: Maybe<CrtTotalWeight>;
};

export type CrtChangeCartResponse = {
  __typename?: 'CrtChangeCartResponse';
  /** List of errors triggered during the add to cart action. */
  addToCartErrors: Array<CrtAddToCartErrors>;
  /** List of warnings triggered during the add to cart action. */
  addToCartWarnings: Array<CrtAddToCartWarnings>;
  /** The cart from the response. */
  cart?: Maybe<CrtCart>;
  /** The unique identifier for the response. */
  id: Scalars['ID']['output'];
  /** Flag that indicates if the request was successful */
  wasSuccessful: Scalars['Boolean']['output'];
};

/** Response for delete cart action or delete cart entry */
export type CrtDeleteResponse = {
  __typename?: 'CrtDeleteResponse';
  /** Unique identifier for the response. */
  id: Scalars['ID']['output'];
  /** Array of the references */
  wasSuccessful: Scalars['Boolean']['output'];
};

/** Duplicate line item error returned during add to cart. */
export type CrtDuplicateLineItemError = CrtAddToCartError & {
  __typename?: 'CrtDuplicateLineItemError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

/** Duplicate line item warning returned during add to cart. */
export type CrtDuplicateLineItemWarning = CrtAddToCartWarning & {
  __typename?: 'CrtDuplicateLineItemWarning';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

/** Union of all cart error types. */
export type CrtErrors = CrtMaxValueError | CrtMinQtyError | CrtMinValueError | CrtMinWeightError;

/** Maximum value error. */
export type CrtMaxValueError = CrtRuleError & {
  __typename?: 'CrtMaxValueError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  threshold: Scalars['String']['output'];
};

/** Maximum value warning. */
export type CrtMaxValueWarning = CrtRuleWarning & {
  __typename?: 'CrtMaxValueWarning';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  /** The maximum allowed order value before failing this rule (including currency). */
  threshold: Scalars['String']['output'];
};

/** Minimum quantity error. */
export type CrtMinQtyError = CrtRuleError & {
  __typename?: 'CrtMinQtyError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  threshold: Scalars['String']['output'];
};

/** Minimum quantity warning. */
export type CrtMinQtyWarning = CrtRuleWarning & {
  __typename?: 'CrtMinQtyWarning';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  /** The minimum quantity required to pass this rule (including unit). */
  threshold: Scalars['String']['output'];
};

/** Minimum value error. */
export type CrtMinValueError = CrtRuleError & {
  __typename?: 'CrtMinValueError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  threshold: Scalars['String']['output'];
};

/** Minimum value warning. */
export type CrtMinValueWarning = CrtRuleWarning & {
  __typename?: 'CrtMinValueWarning';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  /** The minimum order value required to pass this rule (including currency). */
  threshold: Scalars['String']['output'];
};

/** Minimum weight error. */
export type CrtMinWeightError = CrtRuleError & {
  __typename?: 'CrtMinWeightError';
  /** Unique identifier for this error. */
  id: Scalars['ID']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
  /** The minimum threshold required to pass this rule (including unit). */
  threshold: Scalars['String']['output'];
};

/** Minimum weight warning. */
export type CrtMinWeightWarning = CrtRuleWarning & {
  __typename?: 'CrtMinWeightWarning';
  /** Unique identifier for this warning. */
  id: Scalars['ID']['output'];
  /** Warning message. */
  message: Scalars['String']['output'];
  /** The minimum threshold required to pass this rule (including unit). */
  threshold: Scalars['String']['output'];
};

/** Image details of a product. */
export type CrtProductImage = {
  __typename?: 'CrtProductImage';
  /** Alternative text description of the image. */
  altText?: Maybe<Scalars['String']['output']>;
  /** The URL of the image. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Properties related to adding a product to the cart. */
export type CrtProductProps = {
  __typename?: 'CrtProductProps';
  /** Source section or collection of the product */
  catalog?: Maybe<Scalars['String']['output']>;
  /** Unique identifier or parameters for adding the product to the cart. */
  code?: Maybe<Scalars['String']['output']>;
  /** Specific variant or edition of the product. */
  version?: Maybe<Scalars['String']['output']>;
};

export type CrtProductReference = {
  __typename?: 'CrtProductReference';
  /** Unique identifier. */
  id: Scalars['ID']['output'];
  /** The type of reference */
  referenceType?: Maybe<Scalars['String']['output']>;
  /** The product from the reference */
  target?: Maybe<PrdItem>;
};

export type CrtRemoveCartEntryInput = {
  /** The identifier of a product */
  productCode: Scalars['String']['input'];
  /** Unit of a product */
  uom: Scalars['String']['input'];
};

/** Base interface for rule errors returned during checkout validation. */
export type CrtRuleError = {
  /** Unique identifier for this error. */
  id: Scalars['ID']['output'];
  /** Error message to the developer or backup user message if none found in CMS */
  message: Scalars['String']['output'];
};

/** Base interface for rule warnings returned during checkout validation. */
export type CrtRuleWarning = {
  /** Unique identifier for this warning. */
  id: Scalars['ID']['output'];
  /** Warning message to the developer or backup user message if none found in CMS */
  message: Scalars['String']['output'];
};

export type CrtTotalWeight = {
  __typename?: 'CrtTotalWeight';
  /** Unique identifier. */
  id: Scalars['ID']['output'];
  /** The Unit of the items in the cart. */
  uom?: Maybe<PrdUom>;
  /** The total weight of all items in the cart, including units. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type CrtUpdateCartEntryInput = {
  /** Index of an entry in the cart */
  entryNumber: Scalars['Int']['input'];
  /** The identifier of a product */
  productCode: Scalars['String']['input'];
  /** Quantity of a product */
  quantity: Scalars['Int']['input'];
  /** Unit of a product */
  uom: Scalars['String']['input'];
};

/** Response for cart entries validation */
export type CrtValidateEntriesResponse = {
  __typename?: 'CrtValidateEntriesResponse';
  /** List of validation errors (if any) */
  errors?: Maybe<Array<CrtValidationError>>;
  /** Unique identifier for the response */
  id: Scalars['ID']['output'];
  /** Result message */
  result: Scalars['String']['output'];
};

/** Input for validating cart entries */
export type CrtValidateEntryInput = {
  /** Product code */
  productCode: Scalars['String']['input'];
  /** Quantity of the product */
  quantity: Scalars['Int']['input'];
  /** Sales unit (optional) */
  uom?: InputMaybe<Scalars['String']['input']>;
};

/** Validation error for a specific entry */
export type CrtValidationError = {
  __typename?: 'CrtValidationError';
  /** Error code */
  errorCode: Scalars['String']['output'];
  /** Unique identifier for the error */
  id: Scalars['ID']['output'];
  /** Product ID that caused the error */
  productId: Scalars['String']['output'];
  /** Row number of the entry with error */
  row: Scalars['Int']['output'];
};

/** Union of all cart warning types. */
export type CrtWarnings = CrtMaxValueWarning | CrtMinQtyWarning | CrtMinValueWarning | CrtMinWeightWarning;

export enum CrudOperation {
  Create = 'Create',
  Delete = 'Delete',
  List = 'List',
  Read = 'Read',
  Update = 'Update'
}

export type CuAttachmentInput = {
  /** The file data encoded as a Base64 string. */
  base64Data: Scalars['String']['input'];
  /** The MIME type of the file being attached. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Name of the file being attached, including the file extension. */
  filename: Scalars['String']['input'];
};

export type CuError = CuRuleError & {
  __typename?: 'CuError';
  /** Unique identifier for this error. */
  id: Scalars['ID']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

export type CuRuleError = {
  /** Unique identifier for this error. */
  id: Scalars['ID']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

export type CuSupportFormInput = {
  /** The comment or message from the person submitting the support request. */
  comment: Scalars['String']['input'];
  /** The name of the person submitting the support request. */
  name: Scalars['String']['input'];
  /** The telephone number of the person submitting the support request. */
  telephone: Scalars['String']['input'];
};

export type CuSupportResponse = {
  __typename?: 'CuSupportResponse';
  /** Unique identifier for the response. */
  id: Scalars['ID']['output'];
  /** Message providing additional information about the submission result. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of contact us submission errors. */
  ruleErrors: Array<CuError>;
  /** Indicates whether the submission was successful or not. */
  wasSuccessful: Scalars['Boolean']['output'];
};

export type CurCurrency = {
  __typename?: 'CurCurrency';
  active?: Maybe<Scalars['Boolean']['output']>;
  isoCode: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

/**
 * CusAccountLockedExceptionPayload
 * This exception is thrown when the user account is locked, e.g. due to too many
 * failed login attempts.
 */
export type CusAccountLockedExceptionPayload = {
  __typename?: 'CusAccountLockedExceptionPayload';
  code?: Maybe<Scalars['String']['output']>;
};

/** The address of a customer */
export type CusAddress = {
  __typename?: 'CusAddress';
  addressId: Scalars['ID']['output'];
  country?: Maybe<CntCountry>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  formattedAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAddressBook: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isShippingAddress: Scalars['Boolean']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type CusAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CntCountryInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  titleCode?: InputMaybe<CusTitleCode>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CusCustomer = {
  __typename?: 'CusCustomer';
  addresses?: Maybe<Array<CusAddress>>;
  companyName?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  defaultAddress?: Maybe<CusAddress>;
  /** The customer's unique email address */
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  /** The ID of the customer */
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** The customer's loyalty identifier(s) */
  loyaltyIds?: Maybe<Array<Scalars['String']['output']>>;
  middleName?: Maybe<Scalars['String']['output']>;
  /** The customer's profile picture */
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /** The customer's personalised preferences */
  preferences?: Maybe<CusPreferences>;
  registrationStatus?: Maybe<CusRegistrationStatus>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  type: CusType;
  username: Scalars['String']['output'];
};

export type CusCustomerInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CusInvalidClientExceptionPayload = {
  __typename?: 'CusInvalidClientExceptionPayload';
  code?: Maybe<Scalars['String']['output']>;
};

/**
 * CusInvalidPasswordExceptionPayload
 * This exception is thrown when the user provides an invalid username or password
 */
export type CusInvalidPasswordExceptionPayload = {
  __typename?: 'CusInvalidPasswordExceptionPayload';
  code?: Maybe<Scalars['String']['output']>;
};

export type CusLoginNotPossibleExceptionPayload = {
  __typename?: 'CusLoginNotPossibleExceptionPayload';
  code?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<CusLoginNotPossibleExceptionPayloadReason>;
};

export enum CusLoginNotPossibleExceptionPayloadReason {
  Disabled = 'DISABLED',
  Locked = 'LOCKED',
  Unknown = 'UNKNOWN'
}

export type CusMe = {
  __typename?: 'CusMe';
  baseStore?: Maybe<BsBaseStore>;
  /** The unique identifier of the cart associated with the customer. */
  cartId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** the unique identifier for caching purposes */
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum CusNotificationMethods {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS'
}

export type CusNotificationMethodsInput = {
  /** If true, the customer is accepting to receive push notifications to mobile or web app */
  appNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the customer is accepting to receive email notification messages */
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the customer is accepting to receive SMS notification messages */
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CusPasswordExpiredExceptionPayload = {
  __typename?: 'CusPasswordExpiredExceptionPayload';
  code?: Maybe<Scalars['String']['output']>;
};

export type CusPasswordResetRequiredExceptionPayload = {
  __typename?: 'CusPasswordResetRequiredExceptionPayload';
  code?: Maybe<Scalars['String']['output']>;
};

export type CusPreferences = {
  __typename?: 'CusPreferences';
  /** The methods of communication that a customer has allowed */
  notificationMethods?: Maybe<Array<CusNotificationMethods>>;
  /** The preferred and often default store of the customer */
  preferredStore?: Maybe<Scalars['String']['output']>;
};

export type CusPreferencesInput = {
  /** The specified modes of communcation that a customer is willing to be contacted by */
  notificationMethods?: InputMaybe<CusNotificationMethodsInput>;
  /** The preferred store identifier of the customer */
  preferredStoreId?: InputMaybe<Scalars['String']['input']>;
};

export enum CusProfileTitleCode {
  Company = 'company',
  Dr = 'dr',
  Family = 'family',
  Gentlemen = 'gentlemen',
  Ladies = 'ladies',
  Miss = 'miss',
  Mr = 'mr',
  Mrs = 'mrs',
  Ms = 'ms',
  Prof = 'prof'
}

export enum CusRegistrationStatus {
  Active = 'ACTIVE',
  PasswordExpired = 'PASSWORD_EXPIRED',
  Pending = 'PENDING'
}

export enum CusTitleCode {
  Dr = 'dr',
  Miss = 'miss',
  Mr = 'mr',
  Mrs = 'mrs',
  Ms = 'ms',
  Rev = 'rev'
}

export enum CusType {
  Guest = 'GUEST',
  RegisteredUser = 'REGISTERED_USER'
}

export type CusUpdateProfileInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  titleCode?: InputMaybe<CusProfileTitleCode>;
};

export type LangLanguage = {
  __typename?: 'LangLanguage';
  isoCode: Scalars['ID']['output'];
};

/** Represents a language available for a specific site. */
export type Language = {
  __typename?: 'Language';
  /** Indicates whether this language is active for the specified site */
  active: Scalars['Boolean']['output'];
  /** The ISO code of the language, e.g. 'en', 'es', 'ro' */
  isocode: Scalars['String']['output'];
  /** The display name of the language */
  name: Scalars['String']['output'];
  /** The native name of the language, e.g. 'Romanian', 'Spanish' */
  nativeName: Scalars['String']['output'];
};

/** Response containing the list of available languages. */
export type LanguageResponse = {
  __typename?: 'LanguageResponse';
  /** The list of languages available for the site */
  languages: Array<Language>;
};

export type MaAccountBalance = {
  __typename?: 'MaAccountBalance';
  /** The currency of the balance */
  currency?: Maybe<Scalars['String']['output']>;
  /** Formatted currency and value for balance due. */
  formattedValue?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Price type */
  priceType?: Maybe<Scalars['String']['output']>;
  /** The text used for balance due overview */
  text?: Maybe<Scalars['String']['output']>;
  /** The value of he balance */
  value?: Maybe<Scalars['String']['output']>;
};

export type MaAccountDetails = {
  __typename?: 'MaAccountDetails';
  /** Account number displayed on My account page. */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** The name of the bank on My account page. */
  bankName?: Maybe<Scalars['String']['output']>;
  /** Indicates whether a credit block is placed on the customer account. */
  creditBlock?: Maybe<Scalars['Boolean']['output']>;
  /** Current credit exposure amount for the customer displayed on My account page. */
  creditExposure?: Maybe<CmmMoney>;
  /** Credit limit assigned to the customer  displayed on My account page. */
  creditLimit?: Maybe<CmmMoney>;
  /** Credit currently utilized displayed on My account page. */
  creditUtilized?: Maybe<Scalars['String']['output']>;
  /** Remaining usable credit after considering exposure displayed on My account page. */
  effectiveCreditLimit?: Maybe<CmmMoney>;
  /** Unique identifier for the account details section */
  id: Scalars['ID']['output'];
  /** Last payment date displayed on My account page. */
  lastPayment?: Maybe<Scalars['String']['output']>;
  /** Last payment received amount displayed on My account page. */
  lastPaymentReceived?: Maybe<CmmMoney>;
  /** Payment terms applicable to the customer displayed on My account page. */
  paymentTerms?: Maybe<Scalars['String']['output']>;
};

export type MaAccountDocument = {
  __typename?: 'MaAccountDocument';
  /** Monetary amount associated with the document. */
  amount?: Maybe<CmmMoney>;
  /** Assignment or reference number for the document. */
  assignment?: Maybe<Scalars['String']['output']>;
  /** Clearing document number used when the document has been settled. */
  clearingDocument?: Maybe<Scalars['String']['output']>;
  /** Customer-provided reference associated with this document. */
  customerReference?: Maybe<Scalars['String']['output']>;
  /** The date the financial document was created (invoice, debit memo, etc.). */
  documentDate?: Maybe<Scalars['String']['output']>;
  /** Unique document number (invoice number, debit memo number, etc.). */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** Type of financial document (e.g., F2 = Invoice, DR = Debit Memo). */
  documentType?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this account document. */
  id: Scalars['ID']['output'];
  /** Name of the payer associated with this document. */
  payer?: Maybe<Scalars['String']['output']>;
  /** Payment due date for this document. */
  paymentDueDate?: Maybe<Scalars['String']['output']>;
  /** Sold-to party for the document, if applicable. */
  soldTo?: Maybe<Scalars['String']['output']>;
  /** Current status of the document (e.g., Open, Paid). */
  status?: Maybe<Scalars['String']['output']>;
  /** Description of the document type (e.g., Invoice, Customer invoice). */
  type?: Maybe<Scalars['String']['output']>;
};

export type MaMyAccountFilters = {
  /** List of B2B unit filter. */
  b2bUnitDataList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The number of the document used for filter. */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** Starting date for search filter. */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only documents filter. */
  onlyOpenDocs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Predefined period option used to automatically derive date ranges for filtering. */
  period?: InputMaybe<MaSearchPeriodEnum>;
  /** Reference number filter. */
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Ending date for search filter. */
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MaMyAccountResponse = {
  __typename?: 'MaMyAccountResponse';
  /** Summary of balance-related financial information. */
  accountBalance?: Maybe<Array<Maybe<MaAccountBalance>>>;
  /** Credit and payment terms information for the customer. */
  accountDetails?: Maybe<MaAccountDetails>;
  /** List of customer account documents such as invoices, debits, and credits. */
  accountDocuments?: Maybe<Array<Maybe<MaAccountDocument>>>;
  /** base 64 encoded excel file of the order history */
  excelFile?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the response. */
  id: Scalars['ID']['output'];
};

export enum MaSearchPeriodEnum {
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK',
  LastYear = 'LAST_YEAR',
  Period = 'PERIOD',
  SinceYesterday = 'SINCE_YESTERDAY',
  SpecificDate = 'SPECIFIC_DATE',
  Today = 'TODAY'
}

export type MrGetReportResponse = {
  __typename?: 'MrGetReportResponse';
  /** Unique identifier for the response. */
  id: Scalars['ID']['output'];
  /** The report returned by the API. */
  report?: Maybe<MrReportType>;
  /** List of errors returned by the API, if any. */
  ruleErrors?: Maybe<Array<Maybe<MrReportError>>>;
  /** Whether the request was successful. */
  wasSuccessful: Scalars['Boolean']['output'];
};

export type MrMyReportsResponse = {
  __typename?: 'MrMyReportsResponse';
  /** Unique identifier for the response. */
  id: Scalars['ID']['output'];
  /** List of reports of the base store */
  reports?: Maybe<Array<Maybe<MrReportType>>>;
  /** List of errors returned by the API, if any. */
  ruleErrors?: Maybe<Array<Maybe<MrReportError>>>;
  /** Whether the request was successful. */
  wasSuccessful: Scalars['Boolean']['output'];
};

export type MrReportError = RuleError & {
  __typename?: 'MrReportError';
  /** Error code returned by the API. */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Internal exception message, if available. */
  exceptionMessage?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this error. */
  id: Scalars['ID']['output'];
  /** Language of the error message. */
  language?: Maybe<Scalars['String']['output']>;
  /** Human-readable error message. */
  message: Scalars['String']['output'];
  /** Position reference for the error. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Short reason code for the error. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The subject that caused the error. */
  subject?: Maybe<Scalars['String']['output']>;
  /** Subject type that caused the error. */
  subjectType?: Maybe<Scalars['String']['output']>;
  /** Error type classification. */
  type?: Maybe<Scalars['String']['output']>;
};

export type MrReportType = {
  __typename?: 'MrReportType';
  /** Power BI dataset identifier. */
  datasetId?: Maybe<Scalars['String']['output']>;
  /** Embed URL for the Power BI report. */
  embedurl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the report type. */
  id: Scalars['ID']['output'];
  /** Identity associated with the report. */
  identity?: Maybe<Scalars['String']['output']>;
  /** Display name of the report. */
  name: Scalars['String']['output'];
  /** Power BI role for row-level security. */
  powerbiRole?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the report. */
  reportId: Scalars['ID']['output'];
  /** Embed token value. */
  token?: Maybe<Scalars['String']['output']>;
  /** Expiry timestamp of the embed token. */
  tokenExpiry?: Maybe<Scalars['DateTime']['output']>;
  /** Token identifier used for embedding. */
  tokenId?: Maybe<Scalars['String']['output']>;
  /** Power BI workspace identifier. */
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  authCallback: AutAuthenticationResult;
  authGuest: AutAuthenticationResult;
  /**
   * Logs in user based on username and password, or OTP token and code
   *
   * Throws:
   * 1. CusPasswordExpiredException - in case password is expired
   * 2. CusInvalidPasswordException - in case invalid username and/or password
   * 3. CusLoginNotPossibleException - in case account is locked or similar
   * 4. CusPasswordResetRequiredException - in case password reset is required
   */
  authLogin: AutAuthenticationResult;
  authLogout: Scalars['Boolean']['output'];
  authRefresh: AutAuthenticationResult;
  authRequestAuthorizationUrl: Scalars['String']['output'];
  authRequestLogoutUrl: Scalars['String']['output'];
  cardRemove: CardRemoveResponse;
  cardSelect: CardSelectResponse;
  /** Saves a new payment card for checkout in a specific cart and base store. */
  cardSet: PayCPaymentMethod;
  cartAdd: CrtChangeCartResponse;
  /** Deletes all entries from the cart. */
  cartDelete: CrtDeleteResponse;
  /** Removes one ore more entries from the cart. */
  cartDeleteEntry: CrtChangeCartResponse;
  /** Sets the delivery address a cart */
  cartDeliveryAddress: CrtChangeCartResponse;
  /** Updates quantity/unit of one or multiple cart entries from the cart. */
  cartUpdate: CrtChangeCartResponse;
  /** Validates cart entries before adding them to the cart. */
  cartValidateEntriesAndAdd: CartValidateEntriesAndAddResponse;
  /** Sets the customer message on a specific cart */
  coutCustomerMessage: CoutCheckoutResponse;
  /** Set the vehicle chosen by the user */
  coutSaveDeliveryVehicle: CoutDeliveryVehicle;
  /** Saves a purchase order number for a specific cart */
  coutSavePurchaseOrderNumber: CoutUpdateResponse;
  /** Updates the delivery date for a specific cart */
  coutUpdateDeliveryDate: CoutUpdateResponse;
  /** Retrieves the search token */
  coveoToken: ShCoveoTokenResponse;
  /** Creates a new claim for a B2B unit */
  createClaim: ClCreateClaimResponse;
  createExternalPayment: PayExCreatePaymentResponse;
  /** Generate OTP code when login using OTP */
  createOTPToken: OtpTokenResponse;
  /** Creates an order template from a cart or order. */
  createOrderTemplate: OtCreateOrderTemplateResponse;
  /** Deletes an order template. */
  deleteOrderTemplate: OtDeleteOrderTemplateResponse;
  eventCart: Scalars['Boolean']['output'];
  eventDocumentPagination: Scalars['Boolean']['output'];
  eventDocumentSearch: Scalars['Boolean']['output'];
  eventProductClick: Scalars['Boolean']['output'];
  eventProductView: Scalars['Boolean']['output'];
  eventPurchase: Scalars['Boolean']['output'];
  /** Initiates an order template download and returns a download job ID for tracking */
  initiateOrderTemplateDownload: OhDownloadJob;
  /** Performs an order confirmation. */
  orderConfirmation?: Maybe<OcConfirmationResponse>;
  payCapturePayment: PayPaymentResponse;
  payInitiate: PayInitiateResponse;
  payInitiate3DS: PayInitiate3DsResponse;
  /**
   * Downloads a pre-filled payment advice Excel template.
   * If docDetails is omitted, returns an empty template.
   */
  paymentAdviceExcelDownload?: Maybe<PayExPaymentAdviceExcelResponse>;
  paymentTypeUpdate: PayPaymentInfoResponse;
  ping?: Maybe<Scalars['String']['output']>;
  quickOrderAdd: CrtChangeCartResponse;
  /** Resets the password */
  resetPassword: ResetPasswordResponse;
  /** Send an email to the user to reset their password */
  sendForgotPasswordEmail: SendForgotPasswordResponse;
  /** Submit a support form with optional attachments */
  submitContactUsSupport: CuSupportResponse;
  /** Updates an order template. */
  updateOrderTemplate: OtUpdateOrderTemplateResponse;
  /** Updates the password */
  updatePassword: ResetPasswordResponse;
  /** Updates user profile information (title, first name, last name) */
  updateUserProfile?: Maybe<CusMe>;
  uploadExternalPaymentTemplate: PayExInitiatePaymentResponse;
  /** Validates the provided entries and updates the order template if validation passes. */
  validateEntriesAndUpdateOrderTemplate: OtValidateEntriesAndUpdateOrderTemplateResponse;
};


export type MutationAuthCallbackArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  idClaims?: InputMaybe<Array<AutIdClaim>>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Array<AutParam>>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthLoginArgs = {
  isOTP?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationAuthRequestAuthorizationUrlArgs = {
  callbackUri?: InputMaybe<Scalars['String']['input']>;
  flow?: InputMaybe<AutAuthenticationFlowType>;
};


export type MutationAuthRequestLogoutUrlArgs = {
  callbackUri?: InputMaybe<Scalars['String']['input']>;
  flow?: InputMaybe<AutLogoutFlowType>;
};


export type MutationCardRemoveArgs = {
  baseSiteId: Scalars['ID']['input'];
  cardId: Scalars['ID']['input'];
};


export type MutationCardSelectArgs = {
  baseSiteId: Scalars['ID']['input'];
  cardId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
};


export type MutationCardSetArgs = {
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  input: PayCSaveCardInput;
  shouldSave: Scalars['Boolean']['input'];
};


export type MutationCartAddArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  clearCart?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  input: Array<CrtAddToCartInput>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCartDeleteArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCartDeleteEntryArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  input: Array<CrtRemoveCartEntryInput>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCartDeliveryAddressArgs = {
  addressId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCartUpdateArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  entries: Array<CrtUpdateCartEntryInput>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCartValidateEntriesAndAddArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  orderEntries: Array<CrtValidateEntryInput>;
};


export type MutationCoutCustomerMessageArgs = {
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type MutationCoutSaveDeliveryVehicleArgs = {
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  vehicleCode: Scalars['String']['input'];
};


export type MutationCoutSavePurchaseOrderNumberArgs = {
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
};


export type MutationCoutUpdateDeliveryDateArgs = {
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  deliveryDate: Scalars['String']['input'];
};


export type MutationCoveoTokenArgs = {
  b2bUnitId: Scalars['ID']['input'];
  hasB2BUnitRestrictedProducts: Scalars['Boolean']['input'];
  hasBaseStoreRestrictedProducts: Scalars['Boolean']['input'];
};


export type MutationCreateClaimArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  input: ClCreateClaimInput;
};


export type MutationCreateExternalPaymentArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  input: PayExCreatePaymentInput;
};


export type MutationCreateOtpTokenArgs = {
  baseSiteId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};


export type MutationCreateOrderTemplateArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  input: OtCreateOrderTemplateInput;
};


export type MutationDeleteOrderTemplateArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  orderTemplateCode: Scalars['ID']['input'];
};


export type MutationEventCartArgs = {
  cartAction: TrCartActionEnum;
  coveoToken: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  product: TrProductInput;
  quantity: Scalars['Int']['input'];
  trackingId: Scalars['String']['input'];
};


export type MutationEventDocumentPaginationArgs = {
  baseSiteId: Scalars['String']['input'];
  baseStoreId: Scalars['String']['input'];
  docSearchQueryId: Scalars['String']['input'];
  language: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
};


export type MutationEventDocumentSearchArgs = {
  actionCause: TrSearchDocumentsEnum;
  baseSiteId: Scalars['String']['input'];
  baseStoreId: Scalars['String']['input'];
  docSearchQueryId: Scalars['String']['input'];
  language: Scalars['String']['input'];
  queryText: Scalars['String']['input'];
  responseTime: Scalars['Int']['input'];
};


export type MutationEventProductClickArgs = {
  coveoToken: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  product: TrProductInput;
  responseId: Scalars['ID']['input'];
  trackingId: Scalars['String']['input'];
};


export type MutationEventProductViewArgs = {
  coveoToken: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  product: TrProductInput;
  trackingId: Scalars['String']['input'];
};


export type MutationEventPurchaseArgs = {
  coveoToken: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  products: Array<TrBuyedProductInput>;
  trackingId: Scalars['String']['input'];
  transaction: TrTransactionInput;
};


export type MutationInitiateOrderTemplateDownloadArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
};


export type MutationOrderConfirmationArgs = {
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  paymentDetails?: InputMaybe<OcPaymentDetailsInput>;
};


export type MutationPayCapturePaymentArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationPayInitiateArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
};


export type MutationPayInitiate3DsArgs = {
  amount: Scalars['Float']['input'];
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  billingAddress: PayBillingAddressInput;
  cardData: PayCardDataInput;
  clientDevice: PayClientDeviceInput;
  currency: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  shippingAddress: PayShippingAddressInput;
};


export type MutationPaymentAdviceExcelDownloadArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  docDetails?: InputMaybe<Array<InputMaybe<PayExDocDetailsInput>>>;
};


export type MutationPaymentTypeUpdateArgs = {
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  paymentType: PayPaymentTypeEnum;
};


export type MutationQuickOrderAddArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  input: Array<CrtAddToCartInput>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordArgs = {
  baseSiteId: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSendForgotPasswordEmailArgs = {
  baseSiteId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSubmitContactUsSupportArgs = {
  attachments?: InputMaybe<Array<CuAttachmentInput>>;
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  supportForm: CuSupportFormInput;
};


export type MutationUpdateOrderTemplateArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  input: OtUpdateOrderTemplateRequestBody;
};


export type MutationUpdatePasswordArgs = {
  baseSiteId: Scalars['ID']['input'];
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationUpdateUserProfileArgs = {
  baseSiteId: Scalars['ID']['input'];
  input: CusUpdateProfileInput;
};


export type MutationUploadExternalPaymentTemplateArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  input: PayExUploadPaymentFileInput;
};


export type MutationValidateEntriesAndUpdateOrderTemplateArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  input: OtUpdateOrderTemplateRequestBody;
};

export type OtpTokenError = {
  __typename?: 'OTPTokenError';
  errorCode?: Maybe<Scalars['String']['output']>;
  exceptionMessage?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OtpTokenResponse = {
  __typename?: 'OTPTokenResponse';
  /** The access token generated for the user, which can be used for authentication. This field is only populated if wasSuccessful is true. */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** List of validation errors if the request failed */
  errors?: Maybe<Array<OtpTokenError>>;
  /** Unique identifier for the response */
  id: Scalars['ID']['output'];
  /** Flag that indicates if the request was successful */
  wasSuccessful: Scalars['Boolean']['output'];
};

/** Response returned after an order confirmation attempt. */
export type OcConfirmationResponse = {
  __typename?: 'OcConfirmationResponse';
  /** Identifier of the confirmed order. */
  id: Scalars['ID']['output'];
  /** The order number generated after a successful confirmation. */
  orderId?: Maybe<Scalars['String']['output']>;
  /** List of business rule validation errors encountered during confirmation. */
  ruleErrors?: Maybe<Array<Maybe<OcErrorMessage>>>;
  /** Indicates whether the order confirmation was successful. */
  wasSuccessful: Scalars['Boolean']['output'];
};

/** Represents a validation error returned by the order confirmation process. */
export type OcErrorMessage = {
  __typename?: 'OcErrorMessage';
  /** Identifier for the error message */
  id: Scalars['ID']['output'];
  /** The error message describing what went wrong. */
  message: Scalars['String']['output'];
};

/** Input type for payment details including card and 3D Secure information. */
export type OcPaymentDetailsInput = {
  /** The subscription id of the card number for payment. */
  cardSubscriptionId: Scalars['String']['input'];
  /** The card verification value (CVV). */
  cvv: Scalars['String']['input'];
  /** 3D Secure authentication response data. */
  threeDSResponse?: InputMaybe<OcThreeDsResponseInput>;
};

/** Input type for 3D Secure authentication response. */
export type OcThreeDsResponseInput = {
  /** Cardholder Authentication Verification Value. */
  cavv: Scalars['String']['input'];
  /** Directory Server Transaction ID. */
  dstTransactionId: Scalars['String']['input'];
  /** Electronic Commerce Indicator flag. */
  eciFlag: Scalars['String']['input'];
  /** Payer Authentication Response Status. */
  paresStatus: Scalars['String']['input'];
  /** The version of 3D Secure protocol used. */
  threeDSVersion: Scalars['String']['input'];
};

export type OhAddress = {
  __typename?: 'OhAddress';
  addressId?: Maybe<Scalars['ID']['output']>;
  addressType?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CntCountry>;
  description?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Billing document type */
export type OhBillingDocument = {
  __typename?: 'OhBillingDocument';
  /** The B2B customer id associated with the billing document */
  customerId?: Maybe<Scalars['String']['output']>;
  /** The date when the billing document was created */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for identifying the billing document */
  documentId: Scalars['ID']['output'];
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** The date when the billing document is due */
  paymentDueDate?: Maybe<Scalars['DateTime']['output']>;
  /** The reference number of the billing document */
  referenceNumber?: Maybe<Scalars['String']['output']>;
  /** The status of the billing document */
  status?: Maybe<Scalars['String']['output']>;
  /** The status code of the order */
  statusCode?: Maybe<Scalars['String']['output']>;
  /** The total amount of the billing document without tax */
  total?: Maybe<CmmMoney>;
};

/** Filters for billing documents query */
export type OhBillingDocumentFilters = {
  /** The b2b units to filter billing documents */
  b2bUnits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The creation date filter type */
  creationDate?: InputMaybe<OhCreationEnum>;
  /** The type of the billing document */
  documentType: OhBillingDocumentTypeEnum;
  /** The end date to filter billing documents */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The reference number to filter billing documents */
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** The specific date to filter billing documents */
  specificDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The start date to filter billing documents */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The transaction number to filter billing documents */
  transaction?: InputMaybe<Scalars['String']['input']>;
};

/** The billing document types */
export enum OhBillingDocumentTypeEnum {
  CreditMemo = 'CREDIT_MEMO',
  DownPayment = 'DOWN_PAYMENT',
  Invoice = 'INVOICE'
}

/** The creation date filter types */
export enum OhCreationEnum {
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK',
  LastYear = 'LAST_YEAR',
  Period = 'PERIOD',
  SinceYesterday = 'SINCE_YESTERDAY',
  SpecificDate = 'SPECIFIC_DATE',
  Today = 'TODAY'
}

/** Delivery type */
export type OhDelivery = {
  __typename?: 'OhDelivery';
  /** The unique identifier for identifying the delivery */
  deliveryId: Scalars['ID']['output'];
  /** The type of the document */
  documentType?: Maybe<Scalars['String']['output']>;
  /** Estimated Time of Arrival */
  eta?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /**
   * Post goods issue - its an official date where the goods are issued to the customer from Nestle.
   * In simple terms goods are allocated to the customer on that date
   */
  pgiDate?: Maybe<Scalars['DateTime']['output']>;
  /** The purchase order number of the delivery */
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  /** The sales order associated with the delivery */
  salesOrder?: Maybe<Scalars['String']['output']>;
  /** The ship to customer of the delivery */
  shipToCustomer?: Maybe<Scalars['String']['output']>;
  /** The shipment number of the delivery */
  shipment?: Maybe<Scalars['String']['output']>;
  /** The status of the delivery */
  status?: Maybe<Scalars['String']['output']>;
};

/** Delivery details type */
export type OhDeliveryDetails = {
  __typename?: 'OhDeliveryDetails';
  /** The unique identifier for identifying the delivery */
  deliveryId: Scalars['ID']['output'];
  /** Additional information or notes about the delivery */
  deliveryMessage?: Maybe<Scalars['String']['output']>;
  /** The status of the delivery */
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** Items associated with the delivery */
  items: Array<Maybe<OhDeliveryItem>>;
  /**
   * Post Goods Receipt - its an official date where the goods are issued to the customer from Nestle.
   * The date the goods are physically received at the destination
   */
  pgaDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ship to customer of the delivery */
  shipToCustomer?: Maybe<OhDeliveryShipToCustomer>;
  /** The status of the delivery */
  shipmentStatus?: Maybe<Scalars['String']['output']>;
  /** Total volume of an item */
  totalVolume?: Maybe<Scalars['Float']['output']>;
  /** Unit of measure for the total volume */
  totalVolumeUnit?: Maybe<Scalars['String']['output']>;
  /** Total weight of an item */
  totalWeight?: Maybe<Scalars['Float']['output']>;
  /** Unit of measure for the total weight */
  totalWeightUnit?: Maybe<Scalars['String']['output']>;
};

/** Delivery details ship to customer type */
export type OhDeliveryItem = {
  __typename?: 'OhDeliveryItem';
  /** Actual delivered quantity */
  actualDeliveryQuantity?: Maybe<Scalars['String']['output']>;
  /** batch number */
  batch?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** The images associated with the product */
  images: PrdImagesByFormat;
  /** The id of the invoice containing this product */
  invoiceId?: Maybe<Scalars['String']['output']>;
  /** Invoice id details URL */
  invoiceIdDetailsUrl?: Maybe<Scalars['String']['output']>;
  /** Boolean value reprezenting if the items exists in Hybris */
  isExistsInB2BHybris?: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if the product is available for adding to cart */
  isProductAvailable: Scalars['Boolean']['output'];
  /** The name of the product */
  name: Scalars['String']['output'];
  /** The id of the order containing this product */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Order id details URL */
  orderIdDetailsUrl?: Maybe<Scalars['String']['output']>;
  /** Purchase order number */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for identifying the product */
  productId: Scalars['ID']['output'];
  /** Status of the item */
  status?: Maybe<Scalars['String']['output']>;
  /** Status message */
  statusMessage?: Maybe<Scalars['String']['output']>;
  /** The unit of measure for the product */
  uom: PrdUom;
};

/** Delivery details ship to customer type */
export type OhDeliveryShipToCustomer = {
  __typename?: 'OhDeliveryShipToCustomer';
  /** Address of the customer */
  address?: Maybe<OhAddress>;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** Name of the customer */
  name?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the customer */
  number: Scalars['ID']['output'];
};

/** Union type representing any document: order, delivery, or billing document */
export type OhDocument = OhBillingDocument | OhDelivery | OhOrder;

/** Response type for document download */
export type OhDocumentDownloadResponse = {
  __typename?: 'OhDocumentDownloadResponse';
  base64Data: Scalars['String']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
};

/** The type of the document */
export enum OhDocumentType {
  Billing = 'BILLING',
  Delivery = 'DELIVERY',
  Order = 'ORDER'
}

/** The document types available for download */
export enum OhDocumentTypeDownloadEnum {
  CreditMemo = 'CREDIT_MEMO',
  Delivery = 'DELIVERY',
  DownPayment = 'DOWN_PAYMENT',
  Invoice = 'INVOICE',
  Order = 'ORDER',
  ReturnRequest = 'RETURN_REQUEST'
}

/** Completed download file */
export type OhDownloadFile = {
  __typename?: 'OhDownloadFile';
  /** Base64 encoded file content */
  base64Data: Scalars['String']['output'];
  /** MIME type of the file */
  contentType: Scalars['String']['output'];
  /** The download job ID */
  downloadId: Scalars['ID']['output'];
  /** Name of the file */
  fileName: Scalars['String']['output'];
};

/** Download job response when initiating a download */
export type OhDownloadJob = {
  __typename?: 'OhDownloadJob';
  /** Timestamp when the download was initiated */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the download job */
  id: Scalars['ID']['output'];
  /** Current status of the download */
  status: OhDownloadStatus;
};

/** Real-time progress update for a download */
export type OhDownloadProgress = {
  __typename?: 'OhDownloadProgress';
  /** The download job ID */
  downloadId: Scalars['ID']['output'];
  /** Error message if status is FAILED */
  error?: Maybe<Scalars['String']['output']>;
  /** Optional message describing current state */
  message?: Maybe<Scalars['String']['output']>;
  /** Progress percentage (0-100) */
  progress: Scalars['Int']['output'];
  /** Current status of the download */
  status: OhDownloadStatus;
};

/** Download job status */
export enum OhDownloadStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  InProgress = 'IN_PROGRESS'
}

/** Invoice details type */
export type OhInvoiceDetails = {
  __typename?: 'OhInvoiceDetails';
  /** The gross total amount of the invoice */
  grossTotal?: Maybe<CmmMoney>;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** The unique identifier for identifying the invoice */
  invoiceId: Scalars['ID']['output'];
  /** The items included in the invoice */
  items: Array<Maybe<OhInvoiceItem>>;
  /** The net total amount of the invoice */
  netTotal?: Maybe<CmmMoney>;
  /** The payer information of the invoice */
  payer?: Maybe<OhInvoicePayer>;
  /** The payment information of the invoice */
  payment?: Maybe<OhInvoicePayment>;
  /** The total amount of tax for the invoice */
  taxTotal?: Maybe<CmmMoney>;
};

/** The invoice item type */
export type OhInvoiceItem = {
  __typename?: 'OhInvoiceItem';
  /** The quantity delivered for the product */
  deliveredQuantity?: Maybe<Scalars['String']['output']>;
  /** The associated delivery ID */
  deliveryId?: Maybe<Scalars['ID']['output']>;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** The images associated with the product */
  images: PrdImagesByFormat;
  /** Flag indicating if the product is available for adding to cart */
  isProductAvailable: Scalars['Boolean']['output'];
  /** The name of the product */
  name: Scalars['String']['output'];
  /** The associated order ID */
  orderId?: Maybe<Scalars['ID']['output']>;
  /** The unique identifier for identifying the product */
  productId: Scalars['ID']['output'];
  /** The quantity billed for the product */
  quantity?: Maybe<Scalars['String']['output']>;
  /** The total price for the invoice item */
  totalPrice?: Maybe<CmmMoney>;
  /** The unit price of the product */
  unitPrice?: Maybe<CmmMoney>;
  /** The unit of measure for the product */
  uom: PrdUom;
};

/** The payer information for an invoice */
export type OhInvoicePayer = {
  __typename?: 'OhInvoicePayer';
  /** The address of the payer */
  address: OhAddress;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** The name of the payer */
  name?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for identifying the payer */
  payerId?: Maybe<Scalars['ID']['output']>;
};

/** The payment information for an invoice */
export type OhInvoicePayment = {
  __typename?: 'OhInvoicePayment';
  /** The payment due date of the invoice */
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** The payment terms of the invoice */
  terms?: Maybe<Scalars['String']['output']>;
};

/** Order type */
export type OhOrder = {
  __typename?: 'OhOrder';
  /** The B2B customer id associated with the order */
  b2bCustomer?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** The date when the order was placed */
  orderDate?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for identifying the order */
  orderId: Scalars['ID']['output'];
  /** The type of the order */
  orderType?: Maybe<Scalars['String']['output']>;
  /** The purchase order number of the order */
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  /** The requested delivery date of the order */
  rddDate?: Maybe<Scalars['DateTime']['output']>;
  /** The translated status of the order */
  status?: Maybe<Scalars['String']['output']>;
  /** The status code of the order */
  statusCode?: Maybe<Scalars['String']['output']>;
  /** The total amount of the order */
  total?: Maybe<CmmMoney>;
};

export type OhOrderDetails = {
  __typename?: 'OhOrderDetails';
  /** Additional customer message associated with the order */
  customerMessage?: Maybe<Scalars['String']['output']>;
  /** The delivery address associated with the order */
  deliveryAddress: OhAddress;
  /** The URLs for tracking the delivery */
  deliveryTrackingUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The gross total amount of the order */
  grossTotal?: Maybe<CmmMoney>;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** The items included in the order */
  items: Array<Maybe<OhOrderItem>>;
  /** The net total amount of the order */
  netTotal?: Maybe<CmmMoney>;
  /** The unique identifier for identifying the order */
  orderId: Scalars['ID']['output'];
  /** The purchase order number associated with the order */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** The reason for rejection if the order was rejected */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /** The requested delivery date of the order */
  requestedDeliveryDate: Scalars['DateTime']['output'];
  /** The status of the order */
  status?: Maybe<Scalars['String']['output']>;
  /** The status code of the order */
  statusCode?: Maybe<Scalars['String']['output']>;
  /** The amount of tax for the order */
  taxTotal?: Maybe<CmmMoney>;
};

/** The order filter status types */
export enum OhOrderFilterStatusEnum {
  All = 'ALL',
  Canc = 'CANC',
  Crco = 'CRCO',
  Crip = 'CRIP',
  Inpe = 'INPE',
  Inva = 'INVA',
  Ordl = 'ORDL',
  Orip = 'ORIP',
  Oriv = 'ORIV',
  Orrf = 'ORRF',
  Orsh = 'ORSH',
  Whco = 'WHCO'
}

/** Filters for order history query */
export type OhOrderHistoryFilters = {
  /** The b2b units to filter orders */
  b2bUnits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The creation date filter type */
  creationDate: OhCreationEnum;
  /** The ean to filter orders */
  ean?: InputMaybe<Scalars['String']['input']>;
  /** The end date to filter orders */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The limit of orders you want to receive */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The order number to filter orders */
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  /** The type of the order */
  orderType: OhOrderType;
  /** The product ID to filter orders */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** The purchase order number to filter orders */
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  /** The ship to parties to filter orders */
  shipToParties?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The direction to sort the results by creation date */
  sort?: InputMaybe<OhOrderHistoryFiltersEnum>;
  /** The specific date to filter orders */
  specificDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The start date to filter orders */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The order status to filter orders */
  status?: InputMaybe<OhStatusEnum>;
};

/** Determines the sort direction for the order history */
export enum OhOrderHistoryFiltersEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Response type for order history and billing documents */
export type OhOrderHistoryResponse = {
  __typename?: 'OhOrderHistoryResponse';
  /** List of documents */
  documents: Array<Maybe<OhDocument>>;
  /** base 64 encoded excel file of the order history */
  excelFile?: Maybe<Scalars['String']['output']>;
};

/** The order item type */
export type OhOrderItem = {
  __typename?: 'OhOrderItem';
  /** The confirmed quantity for the product */
  confirmedQuantity?: Maybe<Scalars['String']['output']>;
  /** The customer material number for the product */
  customerMaterialNumber?: Maybe<Scalars['String']['output']>;
  /** The quantity delivered for the product */
  deliveredQuantity?: Maybe<Scalars['String']['output']>;
  /** The associated delivery ID */
  deliveryId?: Maybe<Scalars['ID']['output']>;
  /** The expected delivery date for the product */
  expDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for caching purpose */
  id: Scalars['ID']['output'];
  /** The images associated with the product */
  images: PrdImagesByFormat;
  /** The associated invoice ID */
  invoiceId?: Maybe<Scalars['ID']['output']>;
  /** Flag indicating if the product is available for adding to cart */
  isProductAvailable: Scalars['Boolean']['output'];
  /** The name of the product */
  name: Scalars['String']['output'];
  /** The quantity ordered for the product */
  orderedQuantity?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for identifying the product */
  productId: Scalars['ID']['output'];
  /** The status of the order item */
  status: OhOrderItemStatusEnum;
  /** The total price for the order item */
  totalPrice?: Maybe<CmmMoney>;
  /** The unit price of the product */
  unitPrice?: Maybe<CmmMoney>;
  /** The unit of measure for the product */
  uom: PrdUom;
};

/** The status of the order */
export enum OhOrderItemStatusEnum {
  Accepted = 'ACCEPTED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  CompletedWithRejections = 'COMPLETED_WITH_REJECTIONS',
  Confirmed = 'CONFIRMED',
  Denied = 'DENIED',
  Expired = 'EXPIRED',
  ForPickup = 'FOR_PICKUP',
  InProcess = 'IN_PROCESS',
  Open = 'OPEN',
  PartDelivered = 'PART_DELIVERED',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

/** The type of the order */
export enum OhOrderType {
  Delivery = 'DELIVERY',
  Order = 'ORDER',
  ReturnRequest = 'RETURN_REQUEST'
}

/** The status filter types */
export enum OhStatusEnum {
  All = 'ALL',
  Canc = 'CANC',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Crco = 'CRCO',
  Crip = 'CRIP',
  Inpe = 'INPE',
  Inva = 'INVA',
  Open = 'OPEN',
  Ordl = 'ORDL',
  Orip = 'ORIP',
  Oriv = 'ORIV',
  Orrf = 'ORRF',
  Orsh = 'ORSH',
  Processing = 'PROCESSING',
  Whco = 'WHCO'
}

export type OsError = {
  __typename?: 'OsError';
  /** A unique identifier for this error message. */
  id: Scalars['ID']['output'];
  /** System-specific identifier for a message. */
  messageId?: Maybe<Scalars['String']['output']>;
  /** Number code of a message */
  messageNumber?: Maybe<Scalars['String']['output']>;
  /** The text of the error. */
  messageText?: Maybe<Scalars['String']['output']>;
};

/** The response of the order simulation */
export type OsSimulationResponse = {
  __typename?: 'OsSimulationResponse';
  /** A customer message from checkout page */
  customerMessage?: Maybe<Scalars['String']['output']>;
  /** The delivery address used for the simulation. */
  deliveryAddress?: Maybe<CusAddress>;
  /** The list of entries included in the simulation result. */
  entries?: Maybe<Array<Maybe<CrtCartEntry>>>;
  /** The unique identifier of the simulation result. */
  id: Scalars['ID']['output'];
  /** The unique identifier of the order simulation. */
  orderId: Scalars['ID']['output'];
  /** The payment information for the simulated order. */
  paymentInfo?: Maybe<PayCPaymentMethod>;
  /** The payment type used or selected for the simulated order. */
  paymentType?: Maybe<PaymentTypeEnum>;
  /** The purchase order number provided for the simulation. */
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  /** The requested delivery date for the simulated order. */
  requestedDeliveryDate?: Maybe<Scalars['String']['output']>;
  /** A list of error messages generated during the order simulation process. */
  ruleErrors: Array<Maybe<OsError>>;
  /** A list of warning messages generated during the order simulation process. */
  ruleWarning: Array<Maybe<OsWarning>>;
  /** The total price of the simulated order before tax. */
  totalPrice: CmmMoney;
  /** The total price of the simulated order including tax. */
  totalPriceWithTax?: Maybe<CmmMoney>;
  /** The total tax amount applied to the simulated order. */
  totalTax?: Maybe<CmmMoney>;
  /** The vehicle result of the simulation. */
  vehicleResult?: Maybe<OsVehicleOptimizationResult>;
};

/** The vehicle optimization result of the simulation. */
export type OsVehicleOptimizationResult = {
  __typename?: 'OsVehicleOptimizationResult';
  /** The footprint of products in the vehicle. */
  footprint?: Maybe<CoutVehicleAvailableUom>;
  /** The amount of cases that can be loaded in the vehicle. */
  fullCase?: Maybe<CoutVehicleAvailableUom>;
  /** The amount of layers that can be loaded in the vehicle. */
  fullLayer?: Maybe<CoutVehicleAvailableUom>;
  /** The amount of pallets that can be loaded in the vehicle. */
  fullPallet?: Maybe<CoutVehicleAvailableUom>;
  /** The unique identifier of the vehicle result. */
  id: Scalars['ID']['output'];
  /** The number of the vehicle */
  vehicleNumber?: Maybe<CoutVehicleAvailableUom>;
  /** The type of the vehicle */
  vehicleType?: Maybe<Scalars['String']['output']>;
  /** The volume of products in the vehicle. */
  volume?: Maybe<CoutVehicleAvailableUom>;
  /** The weight of products in the vehicle. */
  weight?: Maybe<CoutVehicleAvailableUom>;
};

export type OsWarning = {
  __typename?: 'OsWarning';
  /** A unique identifier for this warning message. */
  id: Scalars['ID']['output'];
  /** System-specific identifier for warning message. */
  messageId?: Maybe<Scalars['String']['output']>;
  /** Number code of a message */
  messageNumber?: Maybe<Scalars['String']['output']>;
  /** The text of the  warning. */
  messageText?: Maybe<Scalars['String']['output']>;
};

/** Input for creating an order template. */
export type OtCreateOrderTemplateInput = {
  /** Cart ID for cart-based creation. */
  cartId?: InputMaybe<Scalars['ID']['input']>;
  /** Order ID for order-based creation. */
  orderId?: InputMaybe<Scalars['ID']['input']>;
  /** Order template name. */
  orderTemplateName: Scalars['String']['input'];
};

/** Response for order template creation. */
export type OtCreateOrderTemplateResponse = {
  __typename?: 'OtCreateOrderTemplateResponse';
  /** Unique identifier for caching. */
  id: Scalars['ID']['output'];
  /** Order template code from API. */
  orderTemplateCode: Scalars['ID']['output'];
  /** Order template name. */
  orderTemplateName: Scalars['String']['output'];
  /** Validation errors. */
  ruleErrors?: Maybe<Array<OtRuleError>>;
  /** Success indicator. */
  wasSuccessful: Scalars['Boolean']['output'];
};

/** Response for order template deletion. */
export type OtDeleteOrderTemplateResponse = {
  __typename?: 'OtDeleteOrderTemplateResponse';
  /** Unique identifier for caching. */
  id: Scalars['ID']['output'];
  /** Validation errors. */
  ruleErrors?: Maybe<Array<OtRuleError>>;
  /** Success indicator. */
  wasSuccessful: Scalars['Boolean']['output'];
};

/** Order template entry input. */
export type OtEntryInput = {
  /** The index number of the product from the list. (Used for update or remove operations) */
  entryNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Product information. */
  product: OtProductInput;
  /** Quantity of the product. */
  quantity: Scalars['Int']['input'];
  /** Sales unit information. */
  zsalesUnit: OtSalesUnitInput;
};

/** Order template type. */
export type OtOrderTemplate = {
  __typename?: 'OtOrderTemplate';
  /** List of order template entries. */
  entries: Array<OtOrderTemplateEntry>;
  /** Unique identifier for caching. */
  id: Scalars['ID']['output'];
  /** Date when the order was created. */
  orderCreatedDate?: Maybe<Scalars['String']['output']>;
  /** Order template code from API. */
  orderTemplateCode: Scalars['ID']['output'];
  /** Order template name (optional, falls back to orderTemplateCode if not provided). */
  orderTemplateName?: Maybe<Scalars['String']['output']>;
};

/** Order template entry type. */
export type OtOrderTemplateEntry = {
  __typename?: 'OtOrderTemplateEntry';
  /** Entry number/index. */
  entryNumber: Scalars['Int']['output'];
  /** Product information. */
  product: OtProduct;
  /** Quantity of the product. */
  quantity: Scalars['Int']['output'];
  /** Sales unit information. */
  zsalesUnit: OtSalesUnit;
};

/** Product type for order template entries. */
export type OtProduct = {
  __typename?: 'OtProduct';
  /** Product code. */
  code: Scalars['String']['output'];
  /** Product images. */
  images?: Maybe<Array<Maybe<OtProductImage>>>;
  /** Product name. */
  name: Scalars['String']['output'];
  /** Product url. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Product images. */
export type OtProductImage = {
  __typename?: 'OtProductImage';
  /** Alt text. */
  altText: Scalars['String']['output'];
  /** Format (e.g. zoom, product, thumbnail, cartIcon) */
  format: Scalars['String']['output'];
  /** Image type (e.g. PRIMARY) */
  imageType: Scalars['String']['output'];
  /** Image url */
  url: Scalars['String']['output'];
};

/** Product reference for order template entry. */
export type OtProductInput = {
  /** Product code. */
  code: Scalars['String']['input'];
};

/** Validation error interface. */
export type OtRuleError = {
  /** Error identifier. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Error message. */
  message: Scalars['String']['output'];
};

/** Sales unit type for order template entries. */
export type OtSalesUnit = {
  __typename?: 'OtSalesUnit';
  /** Sales unit code (e.g., "EA", "CS"). */
  code: Scalars['String']['output'];
  /** Ean */
  ean?: Maybe<Scalars['String']['output']>;
  /** Sales unit name (e.g., "Case"). */
  name: Scalars['String']['output'];
};

/** Sales unit reference for order template entry. */
export type OtSalesUnitInput = {
  /** Sales unit code (e.g., "EA", "CS"). */
  code: Scalars['String']['input'];
};

/** Response for searching order templates. */
export type OtSearchOrderTemplatesResponse = {
  __typename?: 'OtSearchOrderTemplatesResponse';
  /** Unique identifier for caching. */
  id: Scalars['ID']['output'];
  /** List of order templates. */
  orderTemplates: Array<OtOrderTemplate>;
};

/** Standard rule error implementation. */
export type OtStandardRuleError = OtRuleError & {
  __typename?: 'OtStandardRuleError';
  /** Error identifier. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Error message. */
  message: Scalars['String']['output'];
};

/** Input for updating an order template. */
export type OtUpdateOrderTemplateRequestBody = {
  /** Direct entries for the order template. */
  entries?: InputMaybe<Array<OtEntryInput>>;
  /** Order template code to update. */
  orderTemplateCode: Scalars['ID']['input'];
};

/** Response for order template update. */
export type OtUpdateOrderTemplateResponse = {
  __typename?: 'OtUpdateOrderTemplateResponse';
  /** Unique identifier for caching. */
  id: Scalars['ID']['output'];
  /** Validation errors. */
  ruleErrors?: Maybe<Array<OtRuleError>>;
  /** Success indicator. */
  wasSuccessful: Scalars['Boolean']['output'];
};

/** Response for validating entries and updating an order template. */
export type OtValidateEntriesAndUpdateOrderTemplateResponse = {
  __typename?: 'OtValidateEntriesAndUpdateOrderTemplateResponse';
  /** Order template update response, typically populated when validation succeeds. */
  updateOrderTemplateResult?: Maybe<OtUpdateOrderTemplateResponse>;
  /** Validation response for the submitted entries. */
  validation: CrtValidateEntriesResponse;
};

export type PrProductItemInput = {
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type PrProductRecommendationsResponse = {
  __typename?: 'PRProductRecommendationsResponse';
  id: Scalars['ID']['output'];
  items: Array<Maybe<PrdItem>>;
  responseId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export enum PrRecommendationSlotType {
  Cart = 'CART',
  ProductDetail = 'PRODUCT_DETAIL',
  Search = 'SEARCH'
}

export enum PrRecommendationStrategy {
  MostPurchased = 'MOST_PURCHASED',
  PurchasedTogether = 'PURCHASED_TOGETHER',
  RecentlyPurchased = 'RECENTLY_PURCHASED',
  ViewedTogether = 'VIEWED_TOGETHER'
}

export type PayAccessDatabaseError = RuleError & {
  __typename?: 'PayAccessDatabaseError';
  /** Error code 140: Error accessing database */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayBillingAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Enum representing available checkout payment types. */
export enum PayCCheckoutPaymentType {
  /** Card payment type (credit/debit cards). */
  Card = 'CARD',
  /** Invoice payment type (pay later). */
  Invoice = 'INVOICE'
}

/** Represents the billing address associated with a payment method. */
export type PayCPaymentBillingAddress = {
  __typename?: 'PayCPaymentBillingAddress';
  /** Country information for the billing address. */
  country: CntCountry;
  /** Indicates whether this is the default address for the user. */
  defaultAddress: Scalars['Boolean']['output'];
  /** Email address associated with the billing information. */
  email: Scalars['String']['output'];
  /** Fully formatted address string for display purposes. */
  formattedAddress: Scalars['String']['output'];
  /** Unique identifier for the billing address. */
  id: Scalars['ID']['output'];
  /** First line of the street address. */
  line1: Scalars['String']['output'];
  /** Second line of the street address (e.g., apartment, suite). */
  line2?: Maybe<Scalars['String']['output']>;
  /** Phone number associated with the billing address. */
  phone: Scalars['String']['output'];
  /** Postal or ZIP code for the billing address. */
  postalCode: Scalars['String']['output'];
  /** Indicates whether this address can also be used as a shipping address. */
  shippingAddress: Scalars['Boolean']['output'];
  /** Indicates whether this address is visible in the user's address book. */
  visibleInAddressBook: Scalars['Boolean']['output'];
};

/** Represents the type of payment card (e.g., Visa, Mastercard). */
export type PayCPaymentCardType = {
  __typename?: 'PayCPaymentCardType';
  /** Internal code representing the card type (e.g., "24000"). */
  code: Scalars['String']['output'];
  /** Unique identifier for the card type. */
  id: Scalars['ID']['output'];
  /** Display name of the card type (e.g., "Visa"). */
  name: Scalars['String']['output'];
};

/** Represents the payment configuration response for a base store. */
export type PayCPaymentConfigResponse = {
  __typename?: 'PayCPaymentConfigResponse';
  /** List of available checkout payment types for the store. */
  checkoutPaymentTypes: Array<PayCCheckoutPaymentType>;
  /** Unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** Indicates whether 3D Secure is enabled for Paymetric payments. */
  paymetric3DSEnabled: Scalars['Boolean']['output'];
  /** Paymetric base url used to display the iframe on frontend. */
  paymetricBaseUrl: Scalars['String']['output'];
  /** Paymetric merchant GUID identifier for payment processing. */
  paymetricMerchantGUID: Scalars['String']['output'];
};

/** Represents a saved payment method with card and billing information. */
export type PayCPaymentMethod = {
  __typename?: 'PayCPaymentMethod';
  /** Name of the account holder as it appears on the card. */
  accountHolderName: Scalars['String']['output'];
  /** Billing address associated with this payment method. */
  billingAddress?: Maybe<CusAddress>;
  /** Identifier used for payment card operations such as selection and removal. */
  cardId: Scalars['ID']['output'];
  /** Masked card number for security (e.g., ************9038). */
  cardNumber: Scalars['String']['output'];
  /** Type of card used for this payment method. */
  cardType: PayCPaymentCardType;
  /** Indicates whether this is the default payment method for the user. */
  defaultPayment: Scalars['Boolean']['output'];
  /** Expiry month of the card (e.g., "06"). */
  expiryMonth: Scalars['String']['output'];
  /** Expiry year of the card (e.g., "2029"). */
  expiryYear: Scalars['String']['output'];
  /** Unique identifier for the payment method. */
  id: Scalars['ID']['output'];
  /** Indicates whether this payment method has been saved for future use. */
  saved: Scalars['Boolean']['output'];
  /** Subscription identifier for recurring payments or tokenization. */
  subscriptionId: Scalars['String']['output'];
};

/** Input type for saving a new payment card for checkout. */
export type PayCSaveCardInput = {
  /** Card expiration month (e.g., "07"). */
  expMonth: Scalars['String']['input'];
  /** Card expiration year (e.g., "2027"). */
  expYear: Scalars['String']['input'];
  /** Name of the cardholder as it appears on the card. */
  nameOnCard: Scalars['String']['input'];
  /** Tokenized card information from payment provider. */
  token: Scalars['String']['input'];
  /** Type of card (e.g., "visa", "mastercard"). */
  type: Scalars['String']['input'];
};

export type PayCardDataInput = {
  cardToken: Scalars['String']['input'];
  expiryMonth: Scalars['String']['input'];
  expiryYear: Scalars['String']['input'];
};

export type PayCardPaymentResponse = {
  __typename?: 'PayCardPaymentResponse';
  cardExpiryMonth?: Maybe<Scalars['String']['output']>;
  cardExpiryYear?: Maybe<Scalars['String']['output']>;
  cardHolderName?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  cardTypeCode?: Maybe<Scalars['String']['output']>;
};

export type PayClientDeviceInput = {
  colorDepth: Scalars['String']['input'];
  language: Scalars['String']['input'];
  screenHeight: Scalars['String']['input'];
  screenWidth: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
};

export type PayCreateRequestError = RuleError & {
  __typename?: 'PayCreateRequestError';
  /** Error code -101: Indicates the web request could not be created */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayDecryptDataError = RuleError & {
  __typename?: 'PayDecryptDataError';
  /** Error code 106: Error decrypting data */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayDeserializeResponsePacketError = RuleError & {
  __typename?: 'PayDeserializeResponsePacketError';
  /** Error code -104: Indicates the response packet was invalid and could not be deserialized */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

/** A bank account available as a destination for an external payment. */
export type PayExBankAccounts = {
  __typename?: 'PayExBankAccounts';
  /** SAP account number identifying the bank account. */
  accountNumber: Scalars['String']['output'];
  /** Human-readable name or label for the bank account (e.g. 'Banco Nacion'). */
  description: Scalars['String']['output'];
  /** Unique identifier for this bank account record. */
  id: Scalars['ID']['output'];
};

/** Input representing the bank account details associated with a payment deposit entry. */
export type PayExBankAccountsInput = {
  /** SAP account number identifying the bank account. */
  accountNumber: Scalars['String']['input'];
  /** Human-readable name or label for the bank account (e.g. 'Banco Nacion'). */
  description: Scalars['String']['input'];
};

/** Input representing a single document (invoice or credit note) being settled as part of a payment. */
export type PayExCreatePaymentDocInput = {
  /** Original document amount. */
  amount: PayExDocAmountInput;
  /** Additional comments associated with this document entry. */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** SAP document number identifying the invoice or credit note. */
  docNumbers: Scalars['String']['input'];
  /** SAP document date. */
  documentDate: Scalars['String']['input'];
  /** Running balance after applying all difference reasons. */
  multipleReasonBalance?: InputMaybe<PayExDocAmountInput>;
  /** Net difference amount across all reasons. */
  multipleReasonDifference?: InputMaybe<PayExDocAmountInput>;
  /** List of payment-difference reasons associated with this document. */
  multipleReasons?: InputMaybe<Array<InputMaybe<PayExCreatePaymentReasonInput>>>;
  /** Amount the customer is paying towards this document. */
  paidAmt: PayExDocAmountInput;
  /** Whether the document is being paid in full. */
  payInFull: Scalars['Boolean']['input'];
  /** Customer reference or PO number associated with the document. */
  reference: Scalars['String']['input'];
};

/** Root input for creating an external payment, grouping document and payment-method details. */
export type PayExCreatePaymentInput = {
  /** List of document entries being settled in this payment. */
  docDetails: Array<PayExCreatePaymentDocInput>;
  /** List of payment-method (deposit) entries funding this payment. */
  pmtDetails: Array<PayExCreatePaymentPmtInput>;
};

/** Input representing a single payment-method (deposit) entry used to fund the payment. */
export type PayExCreatePaymentPmtInput = {
  /** Remaining balance after applying this deposit entry. */
  balance: PayExDocAmountInput;
  /** Bank account details associated with this deposit entry. */
  bankData: Array<PayExBankAccountsInput>;
  /** Additional comments associated with this payment entry. */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** ISO currency code for this payment entry (e.g. USD, EUR). */
  currency: Scalars['String']['input'];
  /** Date on which the deposit was made. */
  depositDate: Scalars['String']['input'];
  /** Deposit slip or cheque number identifying this payment entry. */
  depositNo: Scalars['String']['input'];
  /** Amount paid via this deposit entry. */
  paidAmt: PayExDocAmountInput;
  /** Optional payment slip file attached to this deposit entry. */
  pmtSlip?: InputMaybe<PayExUploadPaymentFileInput>;
};

/** Input representing a single payment-difference reason applied to a document. */
export type PayExCreatePaymentReasonInput = {
  /** Remaining balance after applying this difference reason. */
  balance?: InputMaybe<PayExDocAmountInput>;
  /** Description or justification for this difference reason. */
  comments: Scalars['String']['input'];
  /** ISO currency code for this difference entry. */
  currency: Scalars['String']['input'];
  /** Amount deducted from the document payment for this reason. */
  dedAmt?: InputMaybe<PayExDocAmountInput>;
  /** Net difference amount for this reason entry. */
  diffAmt?: InputMaybe<PayExDocAmountInput>;
  /** The invoice number */
  invoicNum?: InputMaybe<Scalars['String']['input']>;
  /** Primary reason code identifying the nature of the difference. */
  mReasonCode: Scalars['String']['input'];
  /** List of reason codes associated with this difference entry. */
  multipleReasons: Array<Scalars['String']['input']>;
  /** Amount paid after applying this difference reason. */
  paidAmt?: InputMaybe<PayExDocAmountInput>;
  /** Cumulative total amount across all difference reasons. */
  total?: InputMaybe<PayExDocAmountInput>;
};

/** Response returned after successfully creating an external payment. */
export type PayExCreatePaymentResponse = {
  __typename?: 'PayExCreatePaymentResponse';
  /** Unique identifier for the created payment response. */
  id: Scalars['ID']['output'];
  /** Localisation key describing the outcome of the payment creation. */
  messageKey: Scalars['String']['output'];
  /** HTTP-style status code indicating the result of the payment creation. */
  statusCode: Scalars['String']['output'];
};

export enum PayExCreationDateEnum {
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK',
  LastYear = 'LAST_YEAR',
  Period = 'PERIOD',
  SinceYesterday = 'SINCE_YESTERDAY',
  SpecificDate = 'SPECIFIC_DATE',
  Today = 'TODAY'
}

/** Classifies the direction of a payment difference relative to the expected amount. */
export enum PayExDiffCategoryReasons {
  /** The payment is greater than the expected document amount (over-payment). */
  Greater = 'GREATER',
  /** The payment is less than the expected document amount (under-payment). */
  Lesser = 'LESSER',
  /** The difference falls within a configured tolerance range (neither over nor under). */
  Range = 'RANGE'
}

/** A reason code explaining why the payment amount differs from the expected document total. */
export type PayExDifferenceReasons = {
  __typename?: 'PayExDifferenceReasons';
  /** Broad category that classifies the direction or nature of the difference. */
  category?: Maybe<PayExDiffCategoryReasons>;
  /** Short alphanumeric code used to identify the reason in SAP (e.g. 'LP1', '055'). */
  code?: Maybe<Scalars['String']['output']>;
  /** Human-readable description of the difference reason (e.g. 'Pago Parcial/Saldo de FC'). */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this difference-reason record. */
  id: Scalars['ID']['output'];
};

/** Monetary amount input for a document detail row. */
export type PayExDocAmountInput = {
  /** ISO currency code (e.g. USD, EUR). */
  currencyIso?: InputMaybe<Scalars['String']['input']>;
  /** Numeric value of the amount. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** Detail record for a single open document (invoice or credit note) included in the payment. */
export type PayExDocDetails = {
  __typename?: 'PayExDocDetails';
  /** Original document amount expressed as a monetary value. */
  amount?: Maybe<CmmMoney>;
  /** Price type associated with the document amount (e.g. 'BUY'). */
  amountPriceType?: Maybe<Scalars['String']['output']>;
  /** Date the document was issued, formatted as MM/DD/YYYY. */
  docDate?: Maybe<Scalars['String']['output']>;
  /** SAP document number identifying the invoice or credit note. */
  docNumber?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this document detail record. */
  id: Scalars['ID']['output'];
  /** List of payment-difference reasons associated with this document. */
  multipleReasons: Array<Maybe<PayExMultipleReason>>;
  /** Amount the customer is paying towards this document. */
  paidAmount?: Maybe<CmmMoney>;
  /** Price type associated with the paid amount (e.g. 'BUY'). */
  paidAmountPriceType?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the document is being settled in full. */
  payInFull?: Maybe<Scalars['Boolean']['output']>;
  /** SAP reference string used to match the payment to the source document. */
  reference?: Maybe<Scalars['String']['output']>;
};

/** Input representing a single document row to pre-fill in the payment advice template. */
export type PayExDocDetailsInput = {
  /** Amount to pay for this document. */
  amount?: InputMaybe<PayExDocAmountInput>;
  /** Document number (e.g. invoice number). */
  docNumbers?: InputMaybe<Scalars['String']['input']>;
  /** Customer reference / PO number. */
  reference?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Root response returned when initiating an external payment or uploading a
 * payment template.
 */
export type PayExInitiatePaymentResponse = {
  __typename?: 'PayExInitiatePaymentResponse';
  /** List of bank accounts available as payment destinations. */
  bankAccounts: Array<Maybe<PayExBankAccounts>>;
  /** List of reason codes that explain why a payment amount differs from the invoice total. */
  differenceReasons: Array<Maybe<PayExDifferenceReasons>>;
  /** List of open documents (invoices, credit notes, etc.) included in this payment. */
  docDetails: Array<PayExDocDetails>;
  /** Lower bound of the acceptable payment-difference tolerance range. */
  fromRange?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for this payment initiation response. */
  id: Scalars['ID']['output'];
  /** Payment details extracted from the uploaded template. */
  paymentDetails: Array<PayExPaymentDetails>;
  /** Blocking validation messages returned when no valid documents are available. */
  ruleErrors: Array<Maybe<PayExUploadError>>;
  /**
   * Non-blocking validation messages returned when at least one valid document
   * is available.
   */
  ruleWarnings: Array<Maybe<PayExUploadWarning>>;
  /** Upper bound of the acceptable payment-difference tolerance range. */
  toRange?: Maybe<Scalars['Int']['output']>;
  /**
   * Indicates whether the response contains at least one valid document and
   * the user can continue to the Send Payment page.
   */
  wasSuccessful: Scalars['Boolean']['output'];
};

/** A payment-difference reason associated with a document. */
export type PayExMultipleReason = {
  __typename?: 'PayExMultipleReason';
  /** Additional comments associated with the difference reason. */
  comments?: Maybe<Scalars['String']['output']>;
  /** Amount deducted from the document payment. */
  deductedAmount?: Maybe<CmmMoney>;
  /** Price type associated with the deducted amount. */
  deductedAmountPriceType?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this difference-reason entry. */
  id: Scalars['ID']['output'];
  /** Reason associated with the deducted amount. */
  reason?: Maybe<PayExDifferenceReasons>;
};

export type PayExPaymentAdvice = {
  __typename?: 'PayExPaymentAdvice';
  /** Amount associated with the payment advice. */
  amount?: Maybe<CmmMoney>;
  /** Date the payment advice was closed (e.g., "10/04/2022"). */
  closeureDate?: Maybe<Scalars['DateTime']['output']>;
  /** Time the payment advice was closed (e.g., "16:32:00"). */
  closeureTime?: Maybe<Scalars['String']['output']>;
  /** Date the payment advice was received (e.g., "10/03/2022"). */
  dateReceived?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** Payment advice number identifier. */
  paymentAdviceNumber: Scalars['String']['output'];
  /** Current status of the payment advice (e.g., "Open", "In Progress"). */
  status?: Maybe<Scalars['String']['output']>;
  /** Time the payment advice was received (e.g., "12:11:45"). */
  timeReceived?: Maybe<Scalars['String']['output']>;
};

/** Response containing the payment advice Excel file as a base64-encoded string. */
export type PayExPaymentAdviceExcelResponse = {
  __typename?: 'PayExPaymentAdviceExcelResponse';
  /** Base64-encoded content of the Excel file. */
  base64Data: Scalars['String']['output'];
  /** MIME type of the file. */
  contentType?: Maybe<Scalars['String']['output']>;
  /** Suggested file name for download (e.g. pmtadvice.xlsx). */
  filename: Scalars['String']['output'];
  /** Unique identifier for the response, used for cache normalization. */
  id: Scalars['ID']['output'];
};

/** Payment information extracted from the uploaded template. */
export type PayExPaymentDetails = {
  __typename?: 'PayExPaymentDetails';
  /** Bank accounts associated with the payment. */
  bankData: Array<Maybe<PayExBankAccounts>>;
  /** Additional comments associated with the payment. */
  comments?: Maybe<Scalars['String']['output']>;
  /** Currency used for the payment. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Date on which the payment was deposited. */
  depositDate?: Maybe<Scalars['String']['output']>;
  /** Deposit number associated with the payment. */
  depositNo?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this payment detail record. */
  id: Scalars['ID']['output'];
  /** Total amount paid. */
  paidAmount?: Maybe<CmmMoney>;
  /** Price type associated with the paid amount. */
  paidAmountPriceType?: Maybe<Scalars['String']['output']>;
};

export type PayExPaymentDetailsResponse = {
  __typename?: 'PayExPaymentDetailsResponse';
  /** List of open documents (invoices, credit notes, etc.) included in this payment. */
  documentsDetails: Array<Maybe<PayExDocDetails>>;
  /** Unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** Payment details extracted from the uploaded template. */
  paymentsDetails: Array<Maybe<PayExPaymentDetails>>;
};

export type PayExPaymentDocumentsFilters = {
  /** Filter results based on the creation date */
  creationDate: PayExCreationDateEnum;
  /** The document number. */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** Filters results to only include records up to and including this date. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The number of the payment advice. */
  paymentAdviceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Filters results to only include records based on this date. */
  specificDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters results to only include records from this date. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayExPaymentDocumentsList = {
  __typename?: 'PayExPaymentDocumentsList';
  /** Unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  paymentAdviceList: Array<Maybe<PayExPaymentAdvice>>;
};

/** Blocking validation error generated while processing an uploaded payment template. */
export type PayExUploadError = RuleError & {
  __typename?: 'PayExUploadError';
  /** Code identifying the validation error. */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this validation error. */
  id: Scalars['ID']['output'];
  /** Human-readable validation error. */
  message?: Maybe<Scalars['String']['output']>;
  /** Subject associated with the validation error. */
  subject?: Maybe<Scalars['String']['output']>;
};

/** Input containing the payment template file details. */
export type PayExUploadPaymentFileInput = {
  /** The Base64-encoded file content. */
  bytes: Scalars['String']['input'];
  /** The MIME type of the uploaded file. */
  contentType: Scalars['String']['input'];
  /** The original name of the uploaded file. */
  originalFileName: Scalars['String']['input'];
};

/** Non-blocking validation warning generated while processing an uploaded payment template. */
export type PayExUploadWarning = RuleWarning & {
  __typename?: 'PayExUploadWarning';
  /** Code identifying the validation warning. */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this validation warning. */
  id: Scalars['ID']['output'];
  /** Human-readable validation warning. */
  message: Scalars['String']['output'];
  /** Subject associated with the validation warning. */
  subject?: Maybe<Scalars['String']['output']>;
};

export type PayExpireSessionError = RuleError & {
  __typename?: 'PayExpireSessionError';
  /** Error code 104: Intercept eComm session has expired */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayExpireXiSecureCertificateError = RuleError & {
  __typename?: 'PayExpireXiSecureCertificateError';
  /** Error code 122: XiSecure certificate expired UID: {0}, Expiration Date {1} */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayGetAccessTokenError = RuleError & {
  __typename?: 'PayGetAccessTokenError';
  /** Error code 107: Get AccessToken error */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayGetXiSecureTokenError = RuleError & {
  __typename?: 'PayGetXiSecureTokenError';
  /** Error code 121: XiSecure no token */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayHandleCardinalResponseError = RuleError & {
  __typename?: 'PayHandleCardinalResponseError';
  /** Error code 300: Cardinal Commerce response: {message provided by Cardinal} */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayHandleSessionError = RuleError & {
  __typename?: 'PayHandleSessionError';
  /** Error code 105: Intercept eComm session error */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayInitiate3DsResponse = {
  __typename?: 'PayInitiate3DSResponse';
  ruleErrors?: Maybe<Array<Maybe<PayPaymentError>>>;
  token?: Maybe<Scalars['String']['output']>;
  wasSuccessful: Scalars['Boolean']['output'];
};

export type PayInitiateResponse = {
  __typename?: 'PayInitiateResponse';
  ruleErrors?: Maybe<Array<Maybe<PayPaymentError>>>;
  token?: Maybe<Scalars['String']['output']>;
  wasSuccessful: Scalars['Boolean']['output'];
};

export type PayInterceptEcommError = RuleError & {
  __typename?: 'PayInterceptEcommError';
  /** Error code 100: Internal Intercept eComm error */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayLoadCardinalConfigurationError = RuleError & {
  __typename?: 'PayLoadCardinalConfigurationError';
  /** Error code 301: No Cardinal Commerce configuration */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayLoadPaymentPageIframeError = RuleError & {
  __typename?: 'PayLoadPaymentPageIframeError';
  /** Error code 401: Attempt was made to load the payment page in an Iframe */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayMissingResponsePacketError = RuleError & {
  __typename?: 'PayMissingResponsePacketError';
  /** Error code -103: Indicates no response packet was returned from the server */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayPaymentConfigError = RuleError & {
  __typename?: 'PayPaymentConfigError';
  /** Error code returned by adapter */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by adapter */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayPaymentError = PayAccessDatabaseError | PayCreateRequestError | PayDecryptDataError | PayDeserializeResponsePacketError | PayExpireSessionError | PayExpireXiSecureCertificateError | PayGetAccessTokenError | PayGetXiSecureTokenError | PayHandleCardinalResponseError | PayHandleSessionError | PayInterceptEcommError | PayLoadCardinalConfigurationError | PayLoadPaymentPageIframeError | PayMissingResponsePacketError | PayPaymentConfigError | PayPaymentGenericError | PayPreventDuplicateSubmissionError | PayProcessRequestError | PayRequestPurchasedTypeError | PayRetrieveResponseError | PayValidateCardinalConfigurationError | PayValidateMerchantGuidError | PayValidateRequestPacketError | PayValidateSignatureError | PayXiSecureError;

export type PayPaymentGenericError = RuleError & {
  __typename?: 'PayPaymentGenericError';
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

/** Represents an error that occurred during a payment operation. */
export type PayPaymentInfoResponse = {
  __typename?: 'PayPaymentInfoResponse';
  payment?: Maybe<PayCPaymentMethod>;
  wasSuccessful: Scalars['Boolean']['output'];
};

export type PayPaymentResponse = {
  __typename?: 'PayPaymentResponse';
  cardDetails?: Maybe<PayCardPaymentResponse>;
  ruleErrors?: Maybe<Array<Maybe<PayPaymentError>>>;
  transaction?: Maybe<PayTransactionPaymentResponse>;
  wasSuccessful: Scalars['Boolean']['output'];
};

export enum PayPaymentTypeEnum {
  Card = 'CARD',
  Invoice = 'INVOICE'
}

export type PayPreventDuplicateSubmissionError = RuleError & {
  __typename?: 'PayPreventDuplicateSubmissionError';
  /** Error code 150: The payment form has been submitted multiple times with the same access token. For example, a user clicks submit payment twice */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayProcessRequestError = RuleError & {
  __typename?: 'PayProcessRequestError';
  /** Error code -100: Indicates an unexpected error occurred processing the server request */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayRequestPurchasedTypeError = RuleError & {
  __typename?: 'PayRequestPurchasedTypeError';
  /** Error code 108: Requested type hasn't been purchased */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayRetrieveResponseError = RuleError & {
  __typename?: 'PayRetrieveResponseError';
  /** Error code -102: Indicates the attempt to retrieve the response failed */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayShippingAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type PayTransactionPaymentResponse = {
  __typename?: 'PayTransactionPaymentResponse';
  cavv?: Maybe<Scalars['String']['output']>;
  dsTransactionId?: Maybe<Scalars['String']['output']>;
  eciFlag?: Maybe<Scalars['Int']['output']>;
  errorDesc?: Maybe<Scalars['String']['output']>;
  errorNo?: Maybe<Scalars['Int']['output']>;
  paResStatus?: Maybe<Scalars['String']['output']>;
  threeDSVersion?: Maybe<Scalars['String']['output']>;
  warning?: Maybe<Scalars['String']['output']>;
};

export type PayValidateCardinalConfigurationError = RuleError & {
  __typename?: 'PayValidateCardinalConfigurationError';
  /** Error code 302: The Cardinal Commerce configuration is missing information */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayValidateMerchantGuidError = RuleError & {
  __typename?: 'PayValidateMerchantGuidError';
  /** Error code 101: Merchant GUID is invalid */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayValidateRequestPacketError = RuleError & {
  __typename?: 'PayValidateRequestPacketError';
  /** Error code 103: Request packet is invalid */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayValidateSignatureError = RuleError & {
  __typename?: 'PayValidateSignatureError';
  /** Error code 102: Signature validation failed */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export type PayXiSecureError = RuleError & {
  __typename?: 'PayXiSecureError';
  /** Error code 120: XiSecure error */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique identifier generated from object */
  id: Scalars['ID']['output'];
  /** Error message returned by Paymetric */
  message?: Maybe<Scalars['String']['output']>;
};

export enum PaymentTypeEnum {
  Card = 'CARD',
  Invoice = 'INVOICE'
}

/** Represents a breadcrumb navigation item in a product list or detail page. */
export type PrdBreadcrumb = {
  __typename?: 'PrdBreadcrumb';
  /** Code of the facet represented by this breadcrumb. */
  facetCode?: Maybe<Scalars['String']['output']>;
  /** Code value of the facet selection. */
  facetCodeValue?: Maybe<Scalars['String']['output']>;
  /** Name of the facet represented by this breadcrumb. */
  facetName?: Maybe<Scalars['String']['output']>;
  /** Name value of the facet selection. */
  facetNameValue?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the breadcrumb. */
  id: Scalars['ID']['output'];
};

/** Represents a product category. */
export type PrdCategories = {
  __typename?: 'PrdCategories';
  /** Category code used internally. */
  categoryCode?: Maybe<Scalars['String']['output']>;
  /** Images associated with the category. */
  categoryImage?: Maybe<PrdImages>;
  /** Unique identifier of the category. */
  id: Scalars['ID']['output'];
  /** Display name of the category. */
  name?: Maybe<Scalars['String']['output']>;
  /** URL of the category page. */
  url?: Maybe<Scalars['String']['output']>;
};

export enum PrdColorStatus {
  Green = 'GREEN',
  Red = 'RED',
  Yellow = 'YELLOW'
}

/** Represents the applied filters (sort, facets, search) */
export type PrdCurrentFilters = {
  __typename?: 'PrdCurrentFilters';
  /** Current applied filters */
  filters: Array<Maybe<PrdFacetsParam>>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Current applied full-text search text or keywords to filter the product list. */
  searchText: Scalars['String']['output'];
  /** Current applied sorting method */
  sort: Scalars['String']['output'];
};

export type PrdFacetRange = {
  __typename?: 'PrdFacetRange';
  /** Slider code */
  code?: Maybe<Scalars['String']['output']>;
  /** Symbol of the currency */
  currencySymbol?: Maybe<Scalars['String']['output']>;
  /** The lower bound value of the slider */
  fromValue?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** The upper bound value of the slider */
  toValue?: Maybe<Scalars['Int']['output']>;
  /** Symbol of the unit */
  unitSymbol?: Maybe<Scalars['String']['output']>;
};

export type PrdFacetSubcategories = {
  __typename?: 'PrdFacetSubcategories';
  /** Products count under this subcategory */
  count?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Flag that determine if a subcategory is selected */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** Subcategory name */
  name?: Maybe<Scalars['String']['output']>;
  /** Used to update URL */
  queryUrl?: Maybe<Scalars['String']['output']>;
  /** Used for next search after clicking on a facet */
  queryValue?: Maybe<Scalars['String']['output']>;
};

/** Represents a filter facet for products. */
export type PrdFacets = {
  __typename?: 'PrdFacets';
  /** Indicates whether this facet represents a category. */
  category?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the facet. */
  id: Scalars['ID']['output'];
  /** Indicates whether multiple selections are allowed for this facet. */
  multiSelect?: Maybe<Scalars['Boolean']['output']>;
  /** Display name of the facet (e.g., Color, Size). */
  name?: Maybe<Scalars['String']['output']>;
  /** Priority of the facet for sorting/display purposes. */
  priority?: Maybe<Scalars['String']['output']>;
  range?: Maybe<PrdFacetRange>;
  subCategories?: Maybe<Array<Maybe<PrdFacetSubcategories>>>;
  /** Indicates whether the facet is visible on the frontend. */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Input parameters used to filter products by facets. */
export type PrdFacetsParam = {
  __typename?: 'PrdFacetsParam';
  /** Value to be displayed in case we do not have a pretty value (e.g., red, large). */
  displayValue?: Maybe<Scalars['String']['output']>;
  /** Name of the facet (e.g., color, size). */
  facetName?: Maybe<Scalars['String']['output']>;
  /** Value of the facet (e.g., red, large). */
  facetValue?: Maybe<Scalars['String']['output']>;
  /** Value that says whether the facet is selected from facets or some other place (e.g. carousel). */
  isSelectedFromFacets?: Maybe<Scalars['Boolean']['output']>;
};

/** Input parameters used to filter products by facets. */
export type PrdFacetsParamInput = {
  /** Name of the facet (e.g., color, size). */
  facetName?: InputMaybe<Scalars['String']['input']>;
  /** Value of the facet (e.g., red, large). */
  facetValue?: InputMaybe<Scalars['String']['input']>;
  /** Value that says whether the facet is selected from facets or some other place (e.g. carousel). */
  isSelectedFromFacets?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Free-goods promotion type */
export type PrdFreeGoodsPromotion = {
  __typename?: 'PrdFreeGoodsPromotion';
  /** Number of the products you need to buy in order to get the promotion */
  buyQuantity?: Maybe<Scalars['Int']['output']>;
  /** Number of the product you get */
  getQuantity?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Flag to see if we have a promotion enabled */
  isPromotionAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Unit of the product you get from promotion */
  unitOfFreeProduct?: Maybe<Scalars['String']['output']>;
};

/** Represents a product image and its attributes. */
export type PrdImages = {
  __typename?: 'PrdImages';
  /** Alternative text for accessibility and SEO. */
  altText?: Maybe<Scalars['String']['output']>;
  /** Image format (e.g., jpg, png). */
  format?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the image. */
  id: Scalars['ID']['output'];
  /** Type of image (e.g., thumbnail, gallery). */
  imageType?: Maybe<Scalars['String']['output']>;
  /** Index representing the order of the image in the list. */
  index?: Maybe<Scalars['Int']['output']>;
  /** URL where the image is hosted. */
  url?: Maybe<Scalars['String']['output']>;
};

export type PrdImagesByFormat = {
  __typename?: 'PrdImagesByFormat';
  product?: Maybe<Array<Maybe<PrdImages>>>;
  thumbnail?: Maybe<Array<Maybe<PrdImages>>>;
  zoom?: Maybe<Array<Maybe<PrdImages>>>;
};

/** Represents a single product in the catalog. */
export type PrdItem = {
  __typename?: 'PrdItem';
  /** International EAN (European Article Number) barcode for the product. */
  EAN?: Maybe<Scalars['String']['output']>;
  /** GTIN (Global Trade Item Number) for the product, which may include EAN or UPC formats. */
  GTIN?: Maybe<Scalars['String']['output']>;
  /** NDC (National Drug Code) identifier for pharmaceutical products. */
  NDC?: Maybe<Scalars['String']['output']>;
  /** Any additional information about the product. */
  additionalInformation?: Maybe<Scalars['String']['output']>;
  /** Indicates the availability status of the product. */
  availabilityStatus?: Maybe<PrdColorStatus>;
  breadcrumbs?: Maybe<Array<Maybe<PrdBreadcrumb>>>;
  /** Categories to which the product belongs. */
  categories?: Maybe<Array<Maybe<PrdCategories>>>;
  /** Detailed description of the product. */
  description?: Maybe<Scalars['String']['output']>;
  /** Free-goods style promotions */
  freeGoods?: Maybe<Array<Maybe<PrdFreeGoodsPromotion>>>;
  /** List of future stock availability details for the product. */
  futureStocks?: Maybe<Array<Maybe<PrdStock>>>;
  /** Unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** List of images associated with the product. */
  images?: Maybe<PrdImagesByFormat>;
  /** Flag that tells if a product is new */
  isNewProduct?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the product is currently purchasable. */
  isPurchasable?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the product's manufacturer. */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** Display name of the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** Product code or SKU used for identification. */
  productCode?: Maybe<Scalars['String']['output']>;
  /** Simple monetary promotions (percentage or absolute value) */
  promotions?: Maybe<Array<Maybe<PrdPromotion>>>;
  /** Current stock information for the product. */
  stock?: Maybe<PrdStock>;
  /** A brief summary of the product. */
  summary?: Maybe<Scalars['String']['output']>;
  /** Available units of measurement for a product */
  uoms: Array<Maybe<PrdSalesUom>>;
  /** The URL where information about the product can be found. */
  url?: Maybe<Scalars['String']['output']>;
  /** All prices available for a product */
  volumePrices?: Maybe<Array<Maybe<PrdPrice>>>;
};

/** Pagination details for product listings. */
export type PrdPaginationDetails = {
  __typename?: 'PrdPaginationDetails';
  /** Current page number. */
  currentPage: Scalars['Int']['output'];
  /** Unique identifier for the pagination object. */
  id: Scalars['ID']['output'];
  /** Number of results per page. */
  pageSize: Scalars['Int']['output'];
  /** Total number of pages available. */
  totalPages: Scalars['Int']['output'];
  /** Total number of results available. */
  totalResults: Scalars['Int']['output'];
};

/** Represents pricing information for a product. */
export type PrdPrice = {
  __typename?: 'PrdPrice';
  /** User friendly formatted price */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Flag that shows if a price is a special price for customer */
  isCustomerPrice?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum quantity for this price to apply. */
  maxQuantity?: Maybe<Scalars['String']['output']>;
  /** Minimum quantity for this price to apply. */
  minQuantity?: Maybe<Scalars['String']['output']>;
  /** Price value and currency. */
  price?: Maybe<CmmMoney>;
  /** Unit of measure for current price */
  uom?: Maybe<Scalars['String']['output']>;
};

/** Simple monetized promotion */
export type PrdPromotion = {
  __typename?: 'PrdPromotion';
  id: Scalars['ID']['output'];
  type: PrdPromotionTypeEnum;
  value: CmmMoney;
};

export enum PrdPromotionTypeEnum {
  PromoPercentage = 'PROMO_PERCENTAGE',
  PromoValue = 'PROMO_VALUE'
}

/** Details of a measurement unit of a product */
export type PrdSalesUom = {
  __typename?: 'PrdSalesUOM';
  /** A value containing the gross weight of a unit */
  grossWeight?: Maybe<Scalars['Float']['output']>;
  /** A value containing the gross weight of displaya unit */
  grossWeightUnit?: Maybe<PrdUom>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** A value containing the net weight of a unit */
  netWeight?: Maybe<Scalars['Float']['output']>;
  /** A value containing the net weight of a unit */
  netWeightUnit?: Maybe<PrdUom>;
  /** An object containing information about a specific unit of measure */
  unit?: Maybe<PrdUom>;
};

/** Enum containing all sort codes available */
export enum PrdSortCodes {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  Relevance = 'RELEVANCE'
}

/** Represents available sorting options for product lists. */
export type PrdSortOptions = {
  __typename?: 'PrdSortOptions';
  /** Unique identifier of the sort option. */
  id: Scalars['ID']['output'];
  /** Display name of the sort option. */
  name: Scalars['String']['output'];
  /** Internal code representing the sort option. */
  optionCode?: Maybe<PrdSortCodes>;
  /** Whether this sort option is currently selected. */
  selected: Scalars['Boolean']['output'];
};

/** Represents the stock information of a product. */
export type PrdStock = {
  __typename?: 'PrdStock';
  /** Date from which this stock record is valid. */
  fromData?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the stock record. */
  id: Scalars['ID']['output'];
  /** Quantity of the product available in stock. */
  quantity?: Maybe<Scalars['String']['output']>;
  /** Availability status of the product (e.g., in stock, out of stock). */
  status?: Maybe<Scalars['String']['output']>;
  /** Stock color to help FE on mapping */
  stockColor?: Maybe<PrdColorStatus>;
};

/** Unit of the measurement */
export type PrdUom = {
  __typename?: 'PrdUOM';
  /** Code of a unit */
  code?: Maybe<Scalars['String']['output']>;
  /** Value of a unit to be displayed */
  displayValue?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Name of a unit */
  name?: Maybe<Scalars['String']['output']>;
};

/** Response for queried previously purchased */
export type PreviousPurchasedProductsResponse = {
  __typename?: 'PreviousPurchasedProductsResponse';
  /** Unique identifier for the response. */
  id: Scalars['ID']['output'];
  /** Array of previously purchased products. */
  items?: Maybe<Array<Maybe<PrdItem>>>;
};

/** Represents the response object for a product catalog page query. */
export type ProductCatalogPageDetailsResponse = {
  __typename?: 'ProductCatalogPageDetailsResponse';
  /** List of breadcrumb navigation items to represent the product hierarchy. */
  breadcrumbs?: Maybe<Array<Maybe<PrdBreadcrumb>>>;
  /** Current applied filter (sort, facets, search) */
  currentFilters?: Maybe<PrdCurrentFilters>;
  /** List of facets available for filtering products on this page. */
  facets?: Maybe<Array<Maybe<PrdFacets>>>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Pagination details */
  pagination?: Maybe<PrdPaginationDetails>;
  /** List of available  products */
  products?: Maybe<Array<Maybe<PrdItem>>>;
  /** Available sort options for products on this page. */
  sort?: Maybe<Array<Maybe<PrdSortOptions>>>;
};

/** Response for queried product references */
export type ProductReferencesResponse = {
  __typename?: 'ProductReferencesResponse';
  /** Unique identifier for the response. */
  id: Scalars['ID']['output'];
  /** Array of the references */
  items?: Maybe<Array<Maybe<CrtProductReference>>>;
};

export enum PurchaseHistoryTypeEnum {
  CreditMemo = 'CREDIT_MEMO',
  Delivery = 'DELIVERY',
  DownPayment = 'DOWN_PAYMENT',
  Invoice = 'INVOICE',
  Order = 'ORDER',
  ReturnRequest = 'RETURN_REQUEST'
}

export type Query = {
  __typename?: 'Query';
  allB2bUnits: Array<Maybe<BuB2bUnit>>;
  /** Query for receiving announcements and links */
  announcementsAndLinks: AlAnnouncementsAndLinksResponse;
  appVersionQuery?: Maybe<Scalars['String']['output']>;
  authConfig?: Maybe<AutConfig>;
  authUserInfo?: Maybe<AutUserInfo>;
  /** Retrieves the list of available languages for a given base site. */
  availableLanguages: LanguageResponse;
  b2bUnitInfo?: Maybe<BuB2bUnitInfo>;
  b2bUnits: Array<Maybe<BuB2bUnit>>;
  /** Retrieves a base store data based on baseStoreId */
  baseStore?: Maybe<BsBaseStore>;
  /** Retrieves the list of available base stores for a user in a specific base site. */
  baseStores: Array<Maybe<BsBaseStore>>;
  /** Retrieves billing documents based on provided filters. */
  billingDocs: OhOrderHistoryResponse;
  /** Retrieves all saved payment methods for a user in a specific base site. */
  cards: CardPaymentMethodsResponse;
  /** Creates or restore a cart for the user. */
  cart?: Maybe<CrtCart>;
  /** Retrieves the list of cart recommended products */
  cartRecommendedProducts: ProductReferencesResponse;
  clSearch: ClSearchResponse;
  claimDocumentsZip: ClDocumentsDownloadResponse;
  /** Query for receiving the account details of an user */
  claimUploadDocuments: ClClaimUploadDocumentsResponse;
  /** Query for receiving the claim validation of a user */
  claimValidation: ClClaimValidationResponse;
  cmsAEMComponent?: Maybe<CmsComponent>;
  cmsContainer?: Maybe<Array<Maybe<CmsComponent>>>;
  cmsDrupalComponent?: Maybe<Array<Maybe<CmsComponent>>>;
  cmsDrupalSpot?: Maybe<CmsComponent>;
  cmsSpot?: Maybe<Array<Maybe<CmsComponent>>>;
  countries?: Maybe<Array<Maybe<CntCountry>>>;
  country?: Maybe<CntCountry>;
  /** Retrieves available delivery dates for a specific cart */
  coutDeliveryDates: CoutDeliveryDatesResponse;
  /** Retrieve an object containing a list of available vehicles, selected vehicle's id and information of the selected vehicle (if any) */
  coutDeliveryVehicles: CoutDeliveryVehicle;
  currencies?: Maybe<Array<CurCurrency>>;
  currency?: Maybe<CurCurrency>;
  /** Gets the addresses from a B2B unit */
  cusAddresses?: Maybe<Array<Maybe<CusAddress>>>;
  delivery?: Maybe<OhDeliveryDetails>;
  /** Downloads documents such as invoices, credit memos, orders, etc. */
  downloadDocument?: Maybe<OhDocumentDownloadResponse>;
  /** Retrieves categories under a given catalog and version, starting from a specific category ID. */
  getCategories?: Maybe<CatGetCategoriesResponse>;
  /** Returns the current status and progress of a download job (for polling) */
  getOrderTemplateDownloadStatus?: Maybe<OhDownloadProgress>;
  /** Retrieves a completed order template file by download ID */
  getOrderTemplateFile?: Maybe<OhDownloadFile>;
  /** Query a Power Bi report from a base store based on the reportId */
  getReport: MrGetReportResponse;
  initiateExternalPayment?: Maybe<PayExInitiatePaymentResponse>;
  invoice?: Maybe<OhInvoiceDetails>;
  /** Retrieves available languages for a specific base site for login and shop selection pages. */
  languages?: Maybe<BsLanguages>;
  me?: Maybe<CusMe>;
  order?: Maybe<OhOrderDetails>;
  /**
   * Retrieves the order history for the user.
   * @deprecated Use new orderHistoryV2 query instead
   */
  orderHistory?: Maybe<Array<Maybe<OhOrder>>>;
  /** Retrieves order history and billing documents based on provided filters. */
  orderHistoryV2: OhOrderHistoryResponse;
  /** Performs an order simulation */
  orderSimulation?: Maybe<OsSimulationResponse>;
  /** Retrieves payment configuration settings for a specific base site and base store. */
  paymentConfig: PayCPaymentConfigResponse;
  paymentDetails: PayExPaymentDetailsResponse;
  /** Retrieves detailed product catalog data, including products, facets, sorting options, and pagination. */
  productCatalogPageDetails?: Maybe<ProductCatalogPageDetailsResponse>;
  /** Retrieves detailed information about a specific product. */
  productDetails: PrdItem;
  productRecommendations: PrProductRecommendationsResponse;
  /** Retrieves the list of product references */
  productReferences: ProductReferencesResponse;
  /** Retrieves the list of previous purchased products */
  purchaseHistoryProducts: PreviousPurchasedProductsResponse;
  /** Query a list of available Power Bi reports for a base store */
  reports: MrMyReportsResponse;
  /**
   * Returns a tree structure representing the navigation
   *
   * Parameters:
   *   - baseSiteId: the identifier of the base site to retrieve navigation for.
   *   - context: variant of navigation depending on context, e.g. logged_in, admin etc. Defaults to undefined
   */
  scNavRoot: Array<ScNavNode>;
  /** Returns the store configuration for the given base site id and language */
  scStoreConfig: ScStoreConfig;
  search: ShSearchResults;
  /**
   * Searches for documents (help articles, guides, etc.) based on a query string.
   * Returns a list of relevant documents with metadata.
   */
  searchDocuments: ShDocumentsSearchResponse;
  /** Search for order templates. */
  searchOrderTemplates: OtSearchOrderTemplatesResponse;
  searchPaymentDocuments: PayExPaymentDocumentsList;
  servicesHealthCheck?: Maybe<ServiceHealthResponse>;
  /** Retrieves the keywords suggested for a search query */
  shKeywordSuggestions: ShKeywordSuggestResponse;
  /** Returns product suggestions for a given query string */
  shProductSuggest: ShProductSuggestResponse;
  shipToParty: Array<Maybe<ByShipToParty>>;
  /** Retrieves a base site data based on baseSiteId */
  site?: Maybe<BasSite>;
  stores?: Maybe<Array<StStore>>;
  translations: Array<Maybe<TranslationsResponse>>;
  /** Query for receiving the account details of an user */
  userAccount: MaMyAccountResponse;
};


export type QueryAllB2bUnitsArgs = {
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
};


export type QueryAnnouncementsAndLinksArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
};


export type QueryAvailableLanguagesArgs = {
  baseSiteId: Scalars['String']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
};


export type QueryB2bUnitInfoArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
};


export type QueryB2bUnitsArgs = {
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
};


export type QueryBaseStoreArgs = {
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBaseStoresArgs = {
  baseSiteId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBillingDocsArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  filters?: InputMaybe<OhBillingDocumentFilters>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCardsArgs = {
  baseSiteId: Scalars['ID']['input'];
};


export type QueryCartArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCartRecommendedProductsArgs = {
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['String']['input']>;
  referenceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClSearchArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  filters: ClSearchFilters;
};


export type QueryClaimDocumentsZipArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  claimId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClaimUploadDocumentsArgs = {
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
};


export type QueryClaimValidationArgs = {
  activityNumber?: InputMaybe<Scalars['String']['input']>;
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  claimType: ClClaimTypeEnum;
  customerReference: Scalars['String']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCmsAemComponentArgs = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type QueryCmsContainerArgs = {
  baseSiteId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  specs?: InputMaybe<Array<InputMaybe<CmsKeyValuePairInput>>>;
  url: Scalars['String']['input'];
};


export type QueryCmsDrupalComponentArgs = {
  baseSiteId: Scalars['String']['input'];
  defaultLanguage: Scalars['String']['input'];
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
  specs?: InputMaybe<Array<InputMaybe<CmsKeyValuePairInput>>>;
  url: Scalars['String']['input'];
};


export type QueryCmsDrupalSpotArgs = {
  baseSiteId: Scalars['String']['input'];
  containerName: Scalars['String']['input'];
  defaultLanguage: Scalars['String']['input'];
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
  specs?: InputMaybe<Array<InputMaybe<CmsKeyValuePairInput>>>;
  url: Scalars['String']['input'];
};


export type QueryCmsSpotArgs = {
  baseSiteId: Scalars['String']['input'];
  containerName: Scalars['String']['input'];
  defaultLanguage: Scalars['String']['input'];
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
  specs?: InputMaybe<Array<InputMaybe<CmsKeyValuePairInput>>>;
  url: Scalars['String']['input'];
};


export type QueryCountriesArgs = {
  usage?: InputMaybe<CntUsage>;
};


export type QueryCountryArgs = {
  isoCode: Scalars['String']['input'];
};


export type QueryCoutDeliveryDatesArgs = {
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
};


export type QueryCoutDeliveryVehiclesArgs = {
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCurrencyArgs = {
  isoCode: Scalars['String']['input'];
};


export type QueryCusAddressesArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
};


export type QueryDeliveryArgs = {
  b2bCustomerId?: InputMaybe<Scalars['ID']['input']>;
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  deliveryId: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadDocumentArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  documentIds: Array<Scalars['ID']['input']>;
  type: OhDocumentTypeDownloadEnum;
};


export type QueryGetCategoriesArgs = {
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  catalogId?: InputMaybe<Scalars['ID']['input']>;
  catalogVersionId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrderTemplateDownloadStatusArgs = {
  downloadId: Scalars['ID']['input'];
};


export type QueryGetOrderTemplateFileArgs = {
  downloadId: Scalars['ID']['input'];
};


export type QueryGetReportArgs = {
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};


export type QueryInitiateExternalPaymentArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  docNumbers: Array<Scalars['String']['input']>;
};


export type QueryInvoiceArgs = {
  b2bCustomerId?: InputMaybe<Scalars['ID']['input']>;
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLanguagesArgs = {
  baseSiteId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMeArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type QueryOrderHistoryArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderHistoryV2Args = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  filters?: InputMaybe<OhOrderHistoryFilters>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderSimulationArgs = {
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentConfigArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
};


export type QueryPaymentDetailsArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PayExPaymentDocumentsFilters>;
  language?: InputMaybe<Scalars['String']['input']>;
  paymentAdviceId: Scalars['ID']['input'];
};


export type QueryProductCatalogPageDetailsArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  facets?: InputMaybe<Array<InputMaybe<PrdFacetsParamInput>>>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQueryContext?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<PrdSortCodes>;
};


export type QueryProductDetailsArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  productCode: Scalars['ID']['input'];
};


export type QueryProductRecommendationsArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  cartProducts?: InputMaybe<Array<PrProductItemInput>>;
  country: Scalars['String']['input'];
  coveoToken: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  language: Scalars['String']['input'];
  page?: InputMaybe<PrRecommendationSlotType>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  purchasedProducts?: InputMaybe<Array<PrProductItemInput>>;
  slotId?: InputMaybe<Scalars['ID']['input']>;
  strategy?: InputMaybe<PrRecommendationStrategy>;
  trackingId: Scalars['String']['input'];
};


export type QueryProductReferencesArgs = {
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['String']['input']>;
  productCode: Scalars['ID']['input'];
  referenceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPurchaseHistoryProductsArgs = {
  baseSiteId: Scalars['String']['input'];
  cartId: Scalars['String']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReportsArgs = {
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
};


export type QueryScNavRootArgs = {
  baseSiteId: Scalars['String']['input'];
  defaultLanguage: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type QueryScStoreConfigArgs = {
  baseSiteId: Scalars['String']['input'];
  defaultLanguage: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type QuerySearchArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  country: Scalars['String']['input'];
  coveoToken: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  facets?: InputMaybe<Array<ShFacetInput>>;
  fields?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQueryContext?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ShSortOptionInput>;
  trackingId: Scalars['String']['input'];
};


export type QuerySearchDocumentsArgs = {
  baseSiteId: Scalars['String']['input'];
  baseStoreId: Scalars['String']['input'];
  numberOfResults?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySearchOrderTemplatesArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  fromDate?: InputMaybe<Scalars['String']['input']>;
  orderTemplateCode?: InputMaybe<Scalars['String']['input']>;
  orderTemplateName?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPaymentDocumentsArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PayExPaymentDocumentsFilters>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShKeywordSuggestionsArgs = {
  country: Scalars['String']['input'];
  coveoToken: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  language: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  q: Scalars['String']['input'];
  trackingId: Scalars['String']['input'];
};


export type QueryShProductSuggestArgs = {
  country: Scalars['String']['input'];
  coveoToken: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  language: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  q: Scalars['String']['input'];
  trackingId: Scalars['String']['input'];
};


export type QueryShipToPartyArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySiteArgs = {
  baseSiteId: Scalars['ID']['input'];
};


export type QueryStoresArgs = {
  filter: StStoreFilter;
};


export type QueryTranslationsArgs = {
  defaultLanguage: Scalars['String']['input'];
  language: Scalars['String']['input'];
  page: Scalars['String']['input'];
};


export type QueryUserAccountArgs = {
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MaMyAccountFilters>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordError = {
  __typename?: 'ResetPasswordError';
  /** The Hybris error code (e.g., password.field.old.value.noRepeat) */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** The error message from Hybris */
  message?: Maybe<Scalars['String']['output']>;
  /** Additional error details */
  reason?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  /** The translation key for frontend i18n (e.g., password.error.history) */
  translationKey?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  /** List of validation errors if the request failed */
  errors?: Maybe<Array<Maybe<ResetPasswordError>>>;
  /** Unique identifier for the response */
  id: Scalars['ID']['output'];
  /** Flag that indicates if the request was successful */
  wasSuccessful: Scalars['Boolean']['output'];
};

export type RuleError = {
  /** Unique id for rule error gql interface */
  id: Scalars['ID']['output'];
  /** Error message to the developer or backup user message if none found in CMS */
  message?: Maybe<Scalars['String']['output']>;
};

export type RuleWarning = {
  /** Unique id for rule warning gql interface */
  id: Scalars['ID']['output'];
  /** Warning message to the developer or backup user message if none found in CMS */
  message: Scalars['String']['output'];
};

/** A content node can have child nodes (either link nodes or other content nodes) and an optional link */
export type ScNavContentNode = {
  __typename?: 'ScNavContentNode';
  children?: Maybe<Array<ScNavLinkNode>>;
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<ScNavLink>;
};

export type ScNavControlNode = {
  __typename?: 'ScNavControlNode';
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** A navigation link can be either an internal or external url */
export type ScNavLink = {
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

/** A link node represents a leaf in the navigation tree and has an associated link */
export type ScNavLinkNode = {
  __typename?: 'ScNavLinkNode';
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<ScNavLink>;
  title: Scalars['String']['output'];
};

/** The navigation consists of NavNode instances. A NavNode is either a delimiter or a content node */
export type ScNavNode = ScNavContentNode | ScNavControlNode | ScNavLinkNode;

/** An internal URL link */
export type ScNavUrlLink = ScNavLink & {
  __typename?: 'ScNavUrlLink';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** An external URL link */
export type ScNavUrlLinkExternal = ScNavLink & {
  __typename?: 'ScNavUrlLinkExternal';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Store Configuration type */
export type ScStoreConfig = {
  __typename?: 'ScStoreConfig';
  colorTheme?: Maybe<Scalars['String']['output']>;
  feedbackReasons: Array<Scalars['String']['output']>;
  feedbackType: Array<Scalars['String']['output']>;
  /**
   * Footer links maintained in Drupal
   * Flattened list (children are included as links).
   */
  footerMenu: Array<ScNavLinkNode>;
  hasOtpLogin: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  siteLogoUrl?: Maybe<Scalars['String']['output']>;
  useCoveoSearch: Scalars['Boolean']['output'];
};

export type SendForgotPasswordResponse = {
  __typename?: 'SendForgotPasswordResponse';
  /** Unique identifier for the response */
  id: Scalars['ID']['output'];
  /** Flag that indicates if the request was successful */
  wasSuccessful: Scalars['Boolean']['output'];
};

/**
 * Response object containing the health status of all services and the application version.
 * Used to monitor the overall health of the application and its dependencies.
 */
export type ServiceHealthResponse = {
  __typename?: 'ServiceHealthResponse';
  /**
   * Current version of the application.
   * Follows semantic versioning format (e.g., "1.2.3").
   */
  appVersion: Scalars['String']['output'];
  /**
   * List of individual service health statuses.
   * Each entry represents a specific service or dependency being monitored.
   */
  services?: Maybe<Array<ServiceHealthStatus>>;
};

/**
 * Represents the health status of an individual service or dependency.
 * Provides detailed information about service availability and any issues.
 */
export type ServiceHealthStatus = {
  __typename?: 'ServiceHealthStatus';
  /**
   * Indicates whether the service is currently healthy and operational.
   * true = service is healthy, false = service has issues
   */
  isHealthy: Scalars['Boolean']['output'];
  /**
   * Optional human-readable message providing additional context about the service status.
   * May include error details, warnings, or informational messages.
   */
  message?: Maybe<Scalars['String']['output']>;
  /** Unique identifier or name of the service being monitored. */
  serviceName: Scalars['String']['output'];
  /**
   * HTTP status code or custom status code representing the service state.
   * Common values: 200 (OK), 503 (Service Unavailable), etc.
   */
  statusCode?: Maybe<Scalars['Int']['output']>;
};

/** Response returned by the Coveo token endpoint. */
export type ShCoveoTokenResponse = {
  __typename?: 'ShCoveoTokenResponse';
  /** Unique identifier of the suggest response (used for caching). */
  id: Scalars['ID']['output'];
  /** Generated token used for coveo apis */
  token: Scalars['String']['output'];
};

/**
 * Represents a single document item returned in search results.
 * Contains metadata about documents such as help articles, guides, or other content.
 */
export type ShDocumentItem = {
  __typename?: 'ShDocumentItem';
  /** A brief description or summary of the document content. */
  description?: Maybe<Scalars['String']['output']>;
  /** The URL of an image or thumbnail representing the document. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The URL where the document can be accessed or viewed. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** The title or heading of the document. */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * Response returned by the Documents Search endpoint.
 * Contains a list of document items matching the search criteria.
 */
export type ShDocumentsSearchResponse = {
  __typename?: 'ShDocumentsSearchResponse';
  /** List of document items returned in the search results. */
  documents: Array<ShDocumentItem>;
  /** Unique identifier of the documents search response (used for caching). */
  id: Scalars['ID']['output'];
  /** Query response time */
  responseTime: Scalars['Int']['output'];
  /** Search query id */
  searchQueryId: Scalars['String']['output'];
};

/** Represents a standard facet in search results. */
export type ShFacet = {
  __typename?: 'ShFacet';
  /** Indicates if more facet values are available beyond those returned in the current response. */
  delimitingCharacter?: Maybe<Scalars['String']['output']>;
  /** Display name of the facet. */
  displayName: Scalars['String']['output'];
  /** Unique identifier of the facet. */
  facetId: Scalars['ID']['output'];
  /** The field associated with the facet. */
  field: Scalars['String']['output'];
  /** Indicates if more facet values are available beyond those returned in the current response. */
  hasMoreValuesAvailable: Scalars['Boolean']['output'];
  /** Indicates if the facet values are currently expanded in the UI. */
  isFieldExpanded: Scalars['Boolean']['output'];
  /** Number of values for the facet. */
  numberOfValues?: Maybe<Scalars['Int']['output']>;
  /** The type of the facet (e.g., category, brand). */
  type: Scalars['String']['output'];
  /** List of values for the facet. */
  values: Array<Maybe<ShFacetValue>>;
};

/** Union type for facets in search results. */
export type ShFacetBase = ShFacet | ShFacetRange;

/** Input type for facets in search queries. */
export type ShFacetInput = {
  /** The unique identifier of the facet (e.g., category, brand). */
  field: Scalars['String']['input'];
  /** The type of the facet (e.g., category, brand). */
  type: Scalars['String']['input'];
  /** List of values for the facet. */
  values: Array<InputMaybe<ShFacetValueInput>>;
};

/** Represents a standard facet in search results. */
export type ShFacetRange = {
  __typename?: 'ShFacetRange';
  displayName: Scalars['String']['output'];
  facetId: Scalars['ID']['output'];
  field: Scalars['String']['output'];
  max: Scalars['String']['output'];
  min: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<Maybe<ShFacetRangeValue>>;
};

/** Represents a range facet in search results. */
export type ShFacetRangeValue = {
  __typename?: 'ShFacetRangeValue';
  end?: Maybe<Scalars['String']['output']>;
  endInclusive: Scalars['Boolean']['output'];
  numberOfResults: Scalars['Int']['output'];
  start?: Maybe<Scalars['String']['output']>;
  state: ShFacetValueStateEnum;
};

/** Represents a facet value in search results. */
export type ShFacetValue = {
  __typename?: 'ShFacetValue';
  children?: Maybe<Array<Maybe<ShFacetValue>>>;
  isLeafValue?: Maybe<Scalars['Boolean']['output']>;
  numberOfResults: Scalars['Int']['output'];
  path: Array<Maybe<Scalars['String']['output']>>;
  state: ShFacetValueStateEnum;
  value?: Maybe<Scalars['String']['output']>;
};

/** Input type for facet values in search queries. */
export type ShFacetValueInput = {
  /** List of child facet values. */
  children?: InputMaybe<Array<InputMaybe<ShFacetValueInput>>>;
  /** End value for range facets. */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Start value for range facets. */
  start?: InputMaybe<Scalars['String']['input']>;
  /** State of the facet value (e.g., selected, idle). */
  state: ShFacetValueStateEnum;
  /** Value of the facet. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Enum for the state of facet values. */
export enum ShFacetValueStateEnum {
  Idle = 'IDLE',
  Selected = 'SELECTED'
}

/** Represents the response object for keywords suggested after a search query */
export type ShKeywordSuggestResponse = {
  __typename?: 'ShKeywordSuggestResponse';
  /** Unique identifier used for caching */
  id: Scalars['ID']['output'];
  /** Unique identifier of the api response. */
  responseId: Scalars['ID']['output'];
  /** List of suggested keywords */
  texts: Array<Maybe<Scalars['String']['output']>>;
};

/**
 * Response returned by the Product Suggest endpoint.
 * Used for autocomplete product suggestions.
 */
export type ShProductSuggestResponse = {
  __typename?: 'ShProductSuggestResponse';
  /** Unique identifier of the suggest response (used for caching). */
  id: Scalars['ID']['output'];
  /** List of suggested products. */
  products: Array<Maybe<PrdItem>>;
  /** Unique identifier of the api response. */
  responseId: Scalars['ID']['output'];
};

/** Represents the response object for search results returned by the Coveo Search API. */
export type ShSearchResults = {
  __typename?: 'ShSearchResults';
  /** List of breadcrumb navigation items to represent the product hierarchy. */
  breadcrumbs?: Maybe<Array<Maybe<PrdBreadcrumb>>>;
  /** Current applied filter (sort, facets, search) */
  currentFilters?: Maybe<PrdCurrentFilters>;
  /** List of facets available for filtering products on this page. */
  facets: Array<Maybe<ShFacetBase>>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Pagination details */
  pagination?: Maybe<PrdPaginationDetails>;
  /** List of available  products */
  products?: Maybe<Array<Maybe<PrdItem>>>;
  /** Unique identifier of the api response. */
  responseId?: Maybe<Scalars['ID']['output']>;
  /** Available sort options for products on this page. */
  sort?: Maybe<Array<Maybe<ShSortOption>>>;
};

/** Input type for facet values in search queries. */
export type ShSortFieldInput = {
  direction: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

/** Represents the sort option in search results. */
export type ShSortOption = {
  __typename?: 'ShSortOption';
  direction?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  optionCode: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
};

/** Input type for sort options in search queries. */
export type ShSortOptionInput = {
  fields: Array<InputMaybe<ShSortFieldInput>>;
  sortCriteria: Scalars['String']['input'];
};

export type StStore = {
  __typename?: 'StStore';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CntCountry>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  openHours?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type StStoreFilter = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CntCountryInput>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  maxDistance?: InputMaybe<Scalars['Float']['input']>;
  maxDistanceUom?: InputMaybe<CmmDistanceUom>;
  storeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  ping?: Maybe<Scalars['String']['output']>;
};

/**
 * Input type representing a product that has been purchased.
 * Contains all relevant product information for purchase tracking events.
 */
export type TrBuyedProductInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Enum representing the type of cart action being performed.
 * Used in cart tracking events to distinguish between adding and removing items.
 */
export enum TrCartActionEnum {
  Add = 'ADD',
  Remove = 'REMOVE'
}

/**
 * Input type representing a product involved in a tracking event.
 * Used for click, view, and cart action events.
 */
export type TrProductInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
};

/**
 * Enum representing different types of document search actions.
 * Used to categorize the user's search behavior for analytics purposes.
 */
export enum TrSearchDocumentsEnum {
  DocumentOpen = 'DOCUMENT_OPEN',
  InterfaceChange = 'INTERFACE_CHANGE',
  SearchAsYouType = 'SEARCH_AS_YOU_TYPE',
  SearchBoxClear = 'SEARCH_BOX_CLEAR',
  SearchBoxSubmit = 'SEARCH_BOX_SUBMIT'
}

/**
 * Input type representing transaction details for purchase events.
 * Contains the transaction identifier and total value of the purchase.
 */
export type TrTransactionInput = {
  totalValue?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['ID']['input'];
};

export type TranslationsResponse = {
  __typename?: 'TranslationsResponse';
  /** The unique identifier for caching purposes. */
  id: Scalars['ID']['output'];
  /** The key of the translation entry. */
  key: Scalars['String']['output'];
  /** The translated value. */
  value: Scalars['String']['output'];
};

export type XltnTranslatedString = {
  __typename?: 'XltnTranslatedString';
  language: Scalars['String']['output'];
  translation: Scalars['String']['output'];
};

export enum Event__PayloadType {
  All = 'ALL',
  Entity = 'ENTITY',
  Fields = 'FIELDS'
}

export type EventCartMutationVariables = Exact<{
  trackingId: Scalars['String']['input'];
  cartAction: TrCartActionEnum;
  currency: Scalars['String']['input'];
  product: TrProductInput;
  quantity: Scalars['Int']['input'];
  coveoToken: Scalars['String']['input'];
}>;


export type EventCartMutation = { __typename?: 'Mutation', eventCart: boolean };

export type EventDocumentPaginationMutationVariables = Exact<{
  language: Scalars['String']['input'];
  docSearchQueryId: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
  baseSiteId: Scalars['String']['input'];
  baseStoreId: Scalars['String']['input'];
}>;


export type EventDocumentPaginationMutation = { __typename?: 'Mutation', eventDocumentPagination: boolean };

export type EventDocumentSearchMutationVariables = Exact<{
  actionCause: TrSearchDocumentsEnum;
  queryText: Scalars['String']['input'];
  language: Scalars['String']['input'];
  responseTime: Scalars['Int']['input'];
  docSearchQueryId: Scalars['String']['input'];
  baseSiteId: Scalars['String']['input'];
  baseStoreId: Scalars['String']['input'];
}>;


export type EventDocumentSearchMutation = { __typename?: 'Mutation', eventDocumentSearch: boolean };

export type EventProductClickMutationVariables = Exact<{
  trackingId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  product: TrProductInput;
  position: Scalars['Int']['input'];
  responseId: Scalars['ID']['input'];
  coveoToken: Scalars['String']['input'];
}>;


export type EventProductClickMutation = { __typename?: 'Mutation', eventProductClick: boolean };

export type EventProductViewMutationVariables = Exact<{
  trackingId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  product: TrProductInput;
  coveoToken: Scalars['String']['input'];
}>;


export type EventProductViewMutation = { __typename?: 'Mutation', eventProductView: boolean };

export type EventPurchaseMutationVariables = Exact<{
  trackingId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  transaction: TrTransactionInput;
  products: Array<TrBuyedProductInput> | TrBuyedProductInput;
  coveoToken: Scalars['String']['input'];
}>;


export type EventPurchaseMutation = { __typename?: 'Mutation', eventPurchase: boolean };

export type CartAddMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  input: Array<CrtAddToCartInput> | CrtAddToCartInput;
  clearCart?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CartAddMutation = { __typename?: 'Mutation', cartAdd: { __typename?: 'CrtChangeCartResponse', wasSuccessful: boolean, cart?: { __typename?: 'CrtCart', id: string, cartId: string, cartType?: CartType | null, items: Array<{ __typename?: 'CrtCartEntry', id: string, entryNumber: number, quantity?: number | null, totalWeight?: string | null, product: { __typename?: 'PrdItem', id: string, productCode?: string | null, name?: string | null, EAN?: string | null, GTIN?: string | null, NDC?: string | null, volumePrices?: Array<{ __typename?: 'PrdPrice', id: string, formattedPrice?: string | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> | null, images?: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null } | null, uoms: Array<{ __typename?: 'PrdSalesUOM', id: string, unit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null } | null> }, totalPrice?: { __typename?: 'CmmMoney', formattedValue?: string | null } | null, selectedUom?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, code?: string | null } | null, listPrice?: { __typename?: 'PrdPrice', id: string, formattedPrice?: string | null, price?: { __typename?: 'CmmMoney', formattedValue?: string | null } | null } | null, customerPrice?: { __typename?: 'PrdPrice', id: string, formattedPrice?: string | null, price?: { __typename?: 'CmmMoney', formattedValue?: string | null } | null } | null } | null>, totals?: { __typename?: 'CrtCartTotals', id: string, subtotal: { __typename?: 'CmmMoney', formattedValue?: string | null }, total: { __typename?: 'CmmMoney', formattedValue?: string | null }, currency: { __typename?: 'CurCurrency', isoCode: string, name?: string | null }, totalWeight?: { __typename?: 'CrtTotalWeight', value?: number | null, uom?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null } | null } | null } | null, ruleWarnings?: Array<{ __typename: 'CrtMaxValueWarning', id: string, message: string, threshold: string } | { __typename: 'CrtMinQtyWarning', id: string, message: string, threshold: string } | { __typename: 'CrtMinValueWarning', id: string, message: string, threshold: string } | { __typename: 'CrtMinWeightWarning', id: string, message: string, threshold: string }> | null, ruleErrors?: Array<{ __typename: 'CrtMaxValueError', id: string, message: string, threshold: string } | { __typename: 'CrtMinQtyError', id: string, message: string, threshold: string } | { __typename: 'CrtMinValueError', id: string, message: string, threshold: string } | { __typename: 'CrtMinWeightError', id: string, message: string, threshold: string }> | null } | null, addToCartWarnings: Array<{ __typename: 'CrtDuplicateLineItemWarning', id: string, message: string }>, addToCartErrors: Array<{ __typename: 'CrtDuplicateLineItemError', id: string, message: string }> } };

export type MeQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
}>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'CusMe', id: string, firstName?: string | null, cartId?: string | null, baseStore?: { __typename?: 'BsBaseStore', id: string, isPurchaseOrderMandatory: boolean, isExcelDownload: boolean, isDeliveryDownload: boolean, isEDocumentDownload: boolean, isConfirmedQuantityShown: boolean, isDeliveredQuantityShown: boolean, isExpectedDeliveryDateShown: boolean, isB2BUnitsEnabled: boolean, purchaseHistoryTypes: Array<PurchaseHistoryTypeEnum | null>, isVehicleOptimization: boolean, vehicleOptimizationType?: BsVehicleOptimizationEnum | null, isEnabledTAndC: boolean, productAvailabilityActions: Array<{ __typename: 'BsProductAvailabilityAction', id: string, availabilityStatusAction?: BsAvailabilityStatusAction | null, availabilityStatusType?: BsAvailabilityStatusType | null } | null>, coveoConfig?: { __typename?: 'BsCoveoConfig', id: string, trackingId?: string | null } | null } | null } | null };

export type ServicesHealthCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type ServicesHealthCheckQuery = { __typename?: 'Query', servicesHealthCheck?: { __typename?: 'ServiceHealthResponse', appVersion: string, services?: Array<{ __typename?: 'ServiceHealthStatus', serviceName: string, isHealthy: boolean, statusCode?: number | null, message?: string | null }> | null } | null };

export type SendForgotPasswordEmailMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
}>;


export type SendForgotPasswordEmailMutation = { __typename?: 'Mutation', sendForgotPasswordEmail: { __typename?: 'SendForgotPasswordResponse', wasSuccessful: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordResponse', wasSuccessful: boolean, errors?: Array<{ __typename?: 'ResetPasswordError', errorCode?: string | null, message?: string | null, translationKey?: string | null } | null> | null } };

export type UpdatePasswordMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
  currentPassword: Scalars['String']['input'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'ResetPasswordResponse', wasSuccessful: boolean, errors?: Array<{ __typename?: 'ResetPasswordError', errorCode?: string | null, message?: string | null, translationKey?: string | null } | null> | null } };

export type GetBaseStoreDetailsQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
}>;


export type GetBaseStoreDetailsQuery = { __typename?: 'Query', baseStore?: { __typename?: 'BsBaseStore', id: string, baseStoreId: string, name: string, hasRestrictedProducts: boolean, isB2BUnitsEnabled: boolean, hasOtpLogin?: boolean | null, purchaseHistoryTypes: Array<PurchaseHistoryTypeEnum | null>, isPurchaseOrderMandatory: boolean, isVehicleOptimization: boolean, isDeliveryDownload: boolean, isEDocumentDownload: boolean, isExcelDownload: boolean, isExcelDownloadAccount: boolean, isEnabledTAndC: boolean, isConfirmedQuantityShown: boolean, isDeliveredQuantityShown: boolean, isExpectedDeliveryDateShown: boolean, isCatalogLinkVisible: boolean, isAccountStatementSection: boolean, isExtendedAccountStatementEnabled: boolean, isPaymentAdviceUploadEnabled: boolean, isBalanceSection: boolean, isDetailsSection: boolean, isEnableAssignments: boolean, isHideSoldToAndPayer: boolean, isSplitDebitAndCredit: boolean, isProductStockTagEnabled: boolean, isReturnRequestEnabled: boolean, isReturnOrderUploadEnabled: boolean, isBatchCodeEnabledForReturn: boolean, baseSite: { __typename?: 'BsBaseSite', id: string, baseSiteId: string, name: string }, shopImage?: { __typename?: 'BsMedia', catalogId?: string | null, catalogVersion?: string | null, code?: string | null, downloadUrl?: string | null, url?: string | null } | null, country?: { __typename?: 'CntCountry', name: string, isoCode: string } | null, currencies: Array<{ __typename?: 'CurCurrency', isoCode: string, symbol?: string | null, name?: string | null } | null>, defaultCurrency?: { __typename?: 'CurCurrency', isoCode: string, symbol?: string | null, name?: string | null } | null, availableLanguages?: Array<{ __typename?: 'BsAvailableLanguage', id: string, active?: boolean | null, isocode?: string | null, name?: string | null, nativeName?: string | null, localeIso?: string | null } | null> | null, defaultLanguage?: { __typename?: 'BsAvailableLanguage', id: string, active?: boolean | null, isocode?: string | null, name?: string | null, nativeName?: string | null, localeIso?: string | null } | null, productAvailabilityActions: Array<{ __typename?: 'BsProductAvailabilityAction', id: string, availabilityStatusType?: BsAvailabilityStatusType | null, availabilityStatusAction?: BsAvailabilityStatusAction | null } | null>, claim?: { __typename?: 'BsClaimConfiguration', hasClaimTypeReturn: boolean, hasClaimTypePriceDiff: boolean, hasClaimTypeRefusal: boolean, hasClaimTypeTTS: boolean, hasClaimTypeMissingDiscounts: boolean, hasClaimTypeTaxes: boolean, isDisableNestleReferenceMissingDiscounts: boolean, isDisableNestleReferencePriceDiff: boolean, isDisableNestleReferenceRefusal: boolean, isDisableNestleReferenceTTS: boolean, isDisableNestleReferenceReturn: boolean, isDisableNestleReferenceTaxes: boolean, isNestleReferenceValidationEnabled: boolean, isNotesForCreateClaimEnabled: boolean, isDownloadClaimDetailDocumentsEnabled: boolean, isDownloadClaimEnabled: boolean, isProductLevelClaimEnabled: boolean } | null, contactInformation?: { __typename?: 'BsContactInformation', address?: string | null, email?: string | null, telephone?: string | null, name?: string | null } | null, coveoConfig?: { __typename?: 'BsCoveoConfig', id: string, enableDocuments?: boolean | null, organizationID?: string | null, searchHub?: string | null, trackingId?: string | null, slotIDs?: { __typename?: 'BsSlotIds', entry?: Array<{ __typename?: 'BsSlotId', key?: string | null, value?: string | null } | null> | null } | null } | null } | null };

export type GetBaseStoresQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
}>;


export type GetBaseStoresQuery = { __typename?: 'Query', baseStores: Array<{ __typename?: 'BsBaseStore', id: string, baseStoreId: string, name: string, isFacetSearchEnabled?: boolean | null, isCatalogLinkVisible: boolean, hasRestrictedProducts: boolean, shopImage?: { __typename?: 'BsMedia', code?: string | null, url?: string | null, downloadUrl?: string | null } | null, baseSite: { __typename?: 'BsBaseSite', id: string, baseSiteId: string, name: string }, currencies: Array<{ __typename?: 'CurCurrency', active?: boolean | null, isoCode: string, name?: string | null, symbol?: string | null } | null>, defaultCurrency?: { __typename?: 'CurCurrency', active?: boolean | null, isoCode: string, name?: string | null, symbol?: string | null } | null, defaultLanguage?: { __typename?: 'BsAvailableLanguage', id: string, active?: boolean | null, isocode?: string | null, name?: string | null, nativeName?: string | null, localeIso?: string | null } | null, productAvailabilityActions: Array<{ __typename?: 'BsProductAvailabilityAction', availabilityStatusAction?: BsAvailabilityStatusAction | null, availabilityStatusType?: BsAvailabilityStatusType | null } | null> } | null> };

export type LanguagesQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
}>;


export type LanguagesQuery = { __typename?: 'Query', languages?: { __typename?: 'BsLanguages', id: string, languages?: Array<{ __typename?: 'BsAvailableLanguage', id: string, active?: boolean | null, isocode?: string | null, name?: string | null, nativeName?: string | null, localeIso?: string | null } | null> | null } | null };

export type CartDeleteEntryMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  input: Array<CrtRemoveCartEntryInput> | CrtRemoveCartEntryInput;
}>;


export type CartDeleteEntryMutation = { __typename?: 'Mutation', cartDeleteEntry: { __typename?: 'CrtChangeCartResponse', wasSuccessful: boolean, cart?: { __typename?: 'CrtCart', id: string, cartId: string, items: Array<{ __typename?: 'CrtCartEntry', id: string, entryNumber: number, quantity?: number | null, totalWeight?: string | null, product: { __typename?: 'PrdItem', id: string, productCode?: string | null, name?: string | null, EAN?: string | null, GTIN?: string | null, NDC?: string | null, volumePrices?: Array<{ __typename?: 'PrdPrice', id: string, formattedPrice?: string | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> | null, images?: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null } | null, uoms: Array<{ __typename?: 'PrdSalesUOM', id: string, unit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null } | null> }, totalPrice?: { __typename?: 'CmmMoney', formattedValue?: string | null } | null, selectedUom?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, code?: string | null } | null, listPrice?: { __typename?: 'PrdPrice', id: string, formattedPrice?: string | null, price?: { __typename?: 'CmmMoney', formattedValue?: string | null } | null } | null, customerPrice?: { __typename?: 'PrdPrice', id: string, formattedPrice?: string | null, price?: { __typename?: 'CmmMoney', formattedValue?: string | null } | null } | null } | null>, totals?: { __typename?: 'CrtCartTotals', id: string, subtotal: { __typename?: 'CmmMoney', formattedValue?: string | null }, total: { __typename?: 'CmmMoney', formattedValue?: string | null }, currency: { __typename?: 'CurCurrency', isoCode: string, name?: string | null }, totalWeight?: { __typename?: 'CrtTotalWeight', value?: number | null, uom?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null } | null } | null } | null, ruleWarnings?: Array<{ __typename: 'CrtMaxValueWarning', id: string, message: string, threshold: string } | { __typename: 'CrtMinQtyWarning', id: string, message: string, threshold: string } | { __typename: 'CrtMinValueWarning', id: string, message: string, threshold: string } | { __typename: 'CrtMinWeightWarning', id: string, message: string, threshold: string }> | null, ruleErrors?: Array<{ __typename: 'CrtMaxValueError', id: string, message: string, threshold: string } | { __typename: 'CrtMinQtyError', id: string, message: string, threshold: string } | { __typename: 'CrtMinValueError', id: string, message: string, threshold: string } | { __typename: 'CrtMinWeightError', id: string, message: string, threshold: string }> | null } | null } };

export type CartDeleteMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type CartDeleteMutation = { __typename?: 'Mutation', cartDelete: { __typename?: 'CrtDeleteResponse', id: string, wasSuccessful: boolean } };

export type CartRecommendedProductsQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type CartRecommendedProductsQuery = { __typename?: 'Query', cartRecommendedProducts: { __typename?: 'ProductReferencesResponse', id: string, items?: Array<{ __typename?: 'CrtProductReference', id: string, target?: { __typename?: 'PrdItem', EAN?: string | null, GTIN?: string | null, NDC?: string | null, availabilityStatus?: PrdColorStatus | null, isPurchasable?: boolean | null, isNewProduct?: boolean | null, manufacturer?: string | null, name?: string | null, productCode?: string | null, summary?: string | null, url?: string | null, description?: string | null, id: string, images?: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null } | null, promotions?: Array<{ __typename?: 'PrdPromotion', id: string, type: PrdPromotionTypeEnum, value: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } } | null> | null, stock?: { __typename?: 'PrdStock', id: string, status?: string | null, quantity?: string | null, fromData?: string | null, stockColor?: PrdColorStatus | null } | null, uoms: Array<{ __typename?: 'PrdSalesUOM', id: string, grossWeight?: number | null, netWeight?: number | null, unit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, grossWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, netWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null } | null>, volumePrices?: Array<{ __typename?: 'PrdPrice', id: string, minQuantity?: string | null, maxQuantity?: string | null, formattedPrice?: string | null, isCustomerPrice?: boolean | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> | null, freeGoods?: Array<{ __typename?: 'PrdFreeGoodsPromotion', id: string, isPromotionAvailable?: boolean | null, buyQuantity?: number | null, getQuantity?: number | null, unitOfFreeProduct?: string | null } | null> | null, futureStocks?: Array<{ __typename?: 'PrdStock', id: string, status?: string | null, quantity?: string | null, fromData?: string | null, stockColor?: PrdColorStatus | null } | null> | null } | null } | null> | null } };

export type CartValidateEntriesAndAddMutationVariables = Exact<{
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  orderEntries: Array<CrtValidateEntryInput> | CrtValidateEntryInput;
}>;


export type CartValidateEntriesAndAddMutation = { __typename?: 'Mutation', cartValidateEntriesAndAdd: { __typename?: 'CartValidateEntriesAndAddResponse', validation: { __typename?: 'CrtValidateEntriesResponse', id: string, result: string, errors?: Array<{ __typename?: 'CrtValidationError', id: string, productId: string, errorCode: string, row: number }> | null }, addToCartResult?: { __typename?: 'CrtChangeCartResponse', wasSuccessful: boolean, id: string } | null } };

export type CartUpdateMutationVariables = Exact<{
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  entries: Array<CrtUpdateCartEntryInput> | CrtUpdateCartEntryInput;
  language?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type CartUpdateMutation = { __typename?: 'Mutation', cartUpdate: { __typename?: 'CrtChangeCartResponse', wasSuccessful: boolean, cart?: { __typename?: 'CrtCart', id: string, cartId: string, items: Array<{ __typename?: 'CrtCartEntry', id: string, entryNumber: number, quantity?: number | null, totalWeight?: string | null, product: { __typename?: 'PrdItem', id: string, productCode?: string | null, name?: string | null, EAN?: string | null, GTIN?: string | null, NDC?: string | null, volumePrices?: Array<{ __typename?: 'PrdPrice', id: string, formattedPrice?: string | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> | null, images?: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null } | null, uoms: Array<{ __typename?: 'PrdSalesUOM', id: string, unit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null } | null> }, totalPrice?: { __typename?: 'CmmMoney', formattedValue?: string | null } | null, selectedUom?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, code?: string | null } | null, listPrice?: { __typename?: 'PrdPrice', id: string, formattedPrice?: string | null, price?: { __typename?: 'CmmMoney', formattedValue?: string | null } | null } | null, customerPrice?: { __typename?: 'PrdPrice', id: string, formattedPrice?: string | null, price?: { __typename?: 'CmmMoney', formattedValue?: string | null } | null } | null } | null>, totals?: { __typename?: 'CrtCartTotals', id: string, subtotal: { __typename?: 'CmmMoney', formattedValue?: string | null }, total: { __typename?: 'CmmMoney', formattedValue?: string | null }, currency: { __typename?: 'CurCurrency', isoCode: string, name?: string | null }, totalWeight?: { __typename?: 'CrtTotalWeight', value?: number | null, uom?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null } | null } | null } | null, ruleWarnings?: Array<{ __typename: 'CrtMaxValueWarning', id: string, message: string, threshold: string } | { __typename: 'CrtMinQtyWarning', id: string, message: string, threshold: string } | { __typename: 'CrtMinValueWarning', id: string, message: string, threshold: string } | { __typename: 'CrtMinWeightWarning', id: string, message: string, threshold: string }> | null, ruleErrors?: Array<{ __typename: 'CrtMaxValueError', id: string, message: string, threshold: string } | { __typename: 'CrtMinQtyError', id: string, message: string, threshold: string } | { __typename: 'CrtMinValueError', id: string, message: string, threshold: string } | { __typename: 'CrtMinWeightError', id: string, message: string, threshold: string }> | null } | null, addToCartWarnings: Array<{ __typename: 'CrtDuplicateLineItemWarning', id: string, message: string }>, addToCartErrors: Array<{ __typename: 'CrtDuplicateLineItemError', id: string, message: string }> } };

export type GetCategoriesQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  catalogId?: InputMaybe<Scalars['ID']['input']>;
  catalogVersionId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', getCategories?: { __typename?: 'CatGetCategoriesResponse', id: string, categories?: Array<{ __typename?: 'CatCategory', id: string, slug: string, name: string, categoryCode: string, image?: { __typename?: 'CatImage', url?: string | null, format?: string | null } | null, childCategories?: Array<{ __typename?: 'CatCategory', id: string, slug: string, name: string, categoryCode: string, image?: { __typename?: 'CatImage', url?: string | null, format?: string | null } | null, childCategories?: Array<{ __typename?: 'CatCategory', id: string, slug: string, name: string, categoryCode: string, image?: { __typename?: 'CatImage', url?: string | null, format?: string | null } | null }> | null }> | null } | null> | null } | null };

export type SearchDocumentsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  baseSiteId: Scalars['String']['input'];
  baseStoreId: Scalars['String']['input'];
  numberOfResults?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchDocumentsQuery = { __typename?: 'Query', searchDocuments: { __typename?: 'ShDocumentsSearchResponse', id: string, responseTime: number, searchQueryId: string, documents: Array<{ __typename?: 'ShDocumentItem', title?: string | null, description?: string | null, redirectUrl?: string | null, imageUrl?: string | null }> } };

export type SearchQueryVariables = Exact<{
  trackingId: Scalars['String']['input'];
  coveoToken: Scalars['String']['input'];
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  facets?: InputMaybe<Array<ShFacetInput> | ShFacetInput>;
  sort?: InputMaybe<ShSortOptionInput>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  country: Scalars['String']['input'];
  language: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchQuery = { __typename?: 'Query', search: { __typename?: 'ShSearchResults', id: string, responseId?: string | null, breadcrumbs?: Array<{ __typename?: 'PrdBreadcrumb', id: string, facetCode?: string | null, facetName?: string | null, facetCodeValue?: string | null, facetNameValue?: string | null } | null> | null, facets: Array<{ __typename?: 'ShFacet', type: string, facetId: string, field: string, displayName: string, numberOfValues?: number | null, delimitingCharacter?: string | null, hasMoreValuesAvailable: boolean, isFieldExpanded: boolean, values: Array<{ __typename?: 'ShFacetValue', state: ShFacetValueStateEnum, numberOfResults: number, value?: string | null, path: Array<string | null>, isLeafValue?: boolean | null, children?: Array<{ __typename?: 'ShFacetValue', state: ShFacetValueStateEnum, numberOfResults: number, value?: string | null, path: Array<string | null>, isLeafValue?: boolean | null, children?: Array<{ __typename?: 'ShFacetValue', state: ShFacetValueStateEnum, numberOfResults: number, value?: string | null, path: Array<string | null>, isLeafValue?: boolean | null, children?: Array<{ __typename?: 'ShFacetValue', state: ShFacetValueStateEnum, numberOfResults: number, value?: string | null, path: Array<string | null>, isLeafValue?: boolean | null } | null> | null } | null> | null } | null> | null } | null> } | { __typename?: 'ShFacetRange', type: string, facetId: string, field: string, displayName: string, min: string, max: string, values: Array<{ __typename?: 'ShFacetRangeValue', state: ShFacetValueStateEnum, numberOfResults: number, start?: string | null, end?: string | null, endInclusive: boolean } | null> } | null>, sort?: Array<{ __typename?: 'ShSortOption', id: string, optionCode: string, name: string, direction?: string | null, selected: boolean } | null> | null, products?: Array<{ __typename?: 'PrdItem', id: string, productCode?: string | null, name?: string | null, description?: string | null, isPurchasable?: boolean | null, manufacturer?: string | null, EAN?: string | null, GTIN?: string | null, NDC?: string | null, isNewProduct?: boolean | null, summary?: string | null, url?: string | null, additionalInformation?: string | null, availabilityStatus?: PrdColorStatus | null, stock?: { __typename?: 'PrdStock', id: string, status?: string | null, quantity?: string | null, fromData?: string | null, stockColor?: PrdColorStatus | null } | null, futureStocks?: Array<{ __typename?: 'PrdStock', id: string, status?: string | null, quantity?: string | null, fromData?: string | null, stockColor?: PrdColorStatus | null } | null> | null, volumePrices?: Array<{ __typename?: 'PrdPrice', id: string, minQuantity?: string | null, maxQuantity?: string | null, formattedPrice?: string | null, isCustomerPrice?: boolean | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null, priceType?: string | null } | null } | null> | null, images?: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null } | null, categories?: Array<{ __typename?: 'PrdCategories', id: string, categoryCode?: string | null, name?: string | null, url?: string | null, categoryImage?: { __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null } | null> | null, promotions?: Array<{ __typename?: 'PrdPromotion', id: string, type: PrdPromotionTypeEnum, value: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null, priceType?: string | null } } | null> | null, freeGoods?: Array<{ __typename?: 'PrdFreeGoodsPromotion', id: string, isPromotionAvailable?: boolean | null, buyQuantity?: number | null, getQuantity?: number | null, unitOfFreeProduct?: string | null } | null> | null, uoms: Array<{ __typename?: 'PrdSalesUOM', id: string, grossWeight?: number | null, netWeight?: number | null, unit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, grossWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, netWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null } | null> } | null> | null, pagination?: { __typename?: 'PrdPaginationDetails', id: string, pageSize: number, currentPage: number, totalPages: number, totalResults: number } | null, currentFilters?: { __typename?: 'PrdCurrentFilters', id: string, searchText: string, sort: string, filters: Array<{ __typename?: 'PrdFacetsParam', facetName?: string | null, facetValue?: string | null, displayValue?: string | null, isSelectedFromFacets?: boolean | null } | null> } | null } };

export type ReportsQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
}>;


export type ReportsQuery = { __typename?: 'Query', reports: { __typename?: 'MrMyReportsResponse', id: string, wasSuccessful: boolean, reports?: Array<{ __typename?: 'MrReportType', id: string, reportId: string, name: string } | null> | null, ruleErrors?: Array<{ __typename?: 'MrReportError', id: string, message: string, type?: string | null, reason?: string | null, subjectType?: string | null, subject?: string | null, errorCode?: string | null, language?: string | null, position?: number | null, exceptionMessage?: string | null } | null> | null } };

export type GetPreviousPurchasedProductQueryVariables = Exact<{
  baseSiteId: Scalars['String']['input'];
  cartId: Scalars['String']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPreviousPurchasedProductQuery = { __typename?: 'Query', purchaseHistoryProducts: { __typename?: 'PreviousPurchasedProductsResponse', id: string, items?: Array<{ __typename?: 'PrdItem', EAN?: string | null, GTIN?: string | null, NDC?: string | null, availabilityStatus?: PrdColorStatus | null, additionalInformation?: string | null, description?: string | null, id: string, isNewProduct?: boolean | null, isPurchasable?: boolean | null, manufacturer?: string | null, name?: string | null, productCode?: string | null, summary?: string | null, url?: string | null, freeGoods?: Array<{ __typename?: 'PrdFreeGoodsPromotion', id: string, isPromotionAvailable?: boolean | null, buyQuantity?: number | null, getQuantity?: number | null, unitOfFreeProduct?: string | null } | null> | null, categories?: Array<{ __typename?: 'PrdCategories', id: string, categoryCode?: string | null, name?: string | null, url?: string | null, categoryImage?: { __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null } | null> | null, futureStocks?: Array<{ __typename?: 'PrdStock', id: string, status?: string | null, quantity?: string | null, fromData?: string | null, stockColor?: PrdColorStatus | null } | null> | null, images?: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null } | null, promotions?: Array<{ __typename?: 'PrdPromotion', id: string, type: PrdPromotionTypeEnum, value: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } } | null> | null, stock?: { __typename?: 'PrdStock', id: string, status?: string | null, quantity?: string | null, fromData?: string | null, stockColor?: PrdColorStatus | null } | null, uoms: Array<{ __typename?: 'PrdSalesUOM', id: string, grossWeight?: number | null, netWeight?: number | null, unit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, grossWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, netWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null } | null>, volumePrices?: Array<{ __typename?: 'PrdPrice', id: string, minQuantity?: string | null, maxQuantity?: string | null, formattedPrice?: string | null, isCustomerPrice?: boolean | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> | null } | null> | null } };

export type ProductCatalogPageDetailsQueryVariables = Exact<{
  b2bUnitId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<InputMaybe<PrdFacetsParamInput>> | InputMaybe<PrdFacetsParamInput>>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQueryContext?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<PrdSortCodes>;
  currency?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductCatalogPageDetailsQuery = { __typename?: 'Query', productCatalogPageDetails?: { __typename?: 'ProductCatalogPageDetailsResponse', id: string, breadcrumbs?: Array<{ __typename?: 'PrdBreadcrumb', id: string, facetCode?: string | null, facetName?: string | null, facetCodeValue?: string | null, facetNameValue?: string | null } | null> | null, facets?: Array<{ __typename?: 'PrdFacets', id: string, name?: string | null, priority?: string | null, category?: boolean | null, multiSelect?: boolean | null, visible?: boolean | null, subCategories?: Array<{ __typename?: 'PrdFacetSubcategories', id: string, name?: string | null, count?: number | null, queryUrl?: string | null, queryValue?: string | null, isSelected?: boolean | null } | null> | null, range?: { __typename?: 'PrdFacetRange', id: string, code?: string | null, currencySymbol?: string | null, unitSymbol?: string | null, fromValue?: number | null, toValue?: number | null } | null } | null> | null, sort?: Array<{ __typename?: 'PrdSortOptions', id: string, optionCode?: PrdSortCodes | null, name: string, selected: boolean } | null> | null, products?: Array<{ __typename?: 'PrdItem', id: string, productCode?: string | null, name?: string | null, description?: string | null, isPurchasable?: boolean | null, manufacturer?: string | null, EAN?: string | null, GTIN?: string | null, NDC?: string | null, isNewProduct?: boolean | null, summary?: string | null, url?: string | null, additionalInformation?: string | null, availabilityStatus?: PrdColorStatus | null, stock?: { __typename?: 'PrdStock', id: string, status?: string | null, quantity?: string | null, fromData?: string | null, stockColor?: PrdColorStatus | null } | null, futureStocks?: Array<{ __typename?: 'PrdStock', id: string, status?: string | null, quantity?: string | null, fromData?: string | null, stockColor?: PrdColorStatus | null } | null> | null, volumePrices?: Array<{ __typename?: 'PrdPrice', id: string, minQuantity?: string | null, maxQuantity?: string | null, formattedPrice?: string | null, isCustomerPrice?: boolean | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null, priceType?: string | null } | null } | null> | null, images?: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null } | null, categories?: Array<{ __typename?: 'PrdCategories', id: string, categoryCode?: string | null, name?: string | null, url?: string | null, categoryImage?: { __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null } | null> | null, promotions?: Array<{ __typename?: 'PrdPromotion', id: string, type: PrdPromotionTypeEnum, value: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null, priceType?: string | null } } | null> | null, freeGoods?: Array<{ __typename?: 'PrdFreeGoodsPromotion', id: string, isPromotionAvailable?: boolean | null, buyQuantity?: number | null, getQuantity?: number | null, unitOfFreeProduct?: string | null } | null> | null, uoms: Array<{ __typename?: 'PrdSalesUOM', id: string, grossWeight?: number | null, netWeight?: number | null, unit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, grossWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, netWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null } | null> } | null> | null, pagination?: { __typename?: 'PrdPaginationDetails', id: string, pageSize: number, currentPage: number, totalPages: number, totalResults: number } | null, currentFilters?: { __typename?: 'PrdCurrentFilters', id: string, searchText: string, sort: string, filters: Array<{ __typename?: 'PrdFacetsParam', facetName?: string | null, facetValue?: string | null, displayValue?: string | null, isSelectedFromFacets?: boolean | null } | null> } | null } | null };

export type CusAddressesQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
}>;


export type CusAddressesQuery = { __typename?: 'Query', cusAddresses?: Array<{ __typename?: 'CusAddress', id: string, addressId: string, isDefault: boolean, isShippingAddress: boolean, isAddressBook: boolean, firstName: string, formattedAddress: string, line1: string, line2?: string | null, zip: string, town?: string | null, country?: { __typename?: 'CntCountry', name: string, isoCode: string } | null } | null> | null };

export type CoutDeliveryDatesQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
}>;


export type CoutDeliveryDatesQuery = { __typename?: 'Query', coutDeliveryDates: { __typename?: 'CoutDeliveryDatesResponse', date: string, noDeliveryDays: Array<CoutDaysEnum | null> } };

export type CoutSaveDeliveryVehicleMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  vehicleCode: Scalars['String']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
}>;


export type CoutSaveDeliveryVehicleMutation = { __typename?: 'Mutation', coutSaveDeliveryVehicle: { __typename?: 'CoutDeliveryVehicle', id: string, vehicles: Array<{ __typename?: 'CoutVehicle', id: string, vehicleId: string, description?: string | null } | null>, vehicleOptimization?: { __typename?: 'CoutDeliveryVehicleOptimization', id: string, activeVehicleCode?: string | null, vehicleType?: string | null, vehicleNumber?: number | null, weight?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null } | null, volume?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null } | null, footprint?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null } | null, fullPallet?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null } | null, fullLayer?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null } | null, fullCase?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null } | null } | null } };

export type CoutCustomerMessageMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;


export type CoutCustomerMessageMutation = { __typename?: 'Mutation', coutCustomerMessage: { __typename?: 'CoutCheckoutResponse', id: string, wasSuccessful: boolean } };

export type CartDeliveryAddressMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  addressId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type CartDeliveryAddressMutation = { __typename?: 'Mutation', cartDeliveryAddress: { __typename?: 'CrtChangeCartResponse', id: string, wasSuccessful: boolean } };

export type CoutUpdateDeliveryDateMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  deliveryDate: Scalars['String']['input'];
}>;


export type CoutUpdateDeliveryDateMutation = { __typename?: 'Mutation', coutUpdateDeliveryDate: { __typename?: 'CoutUpdateResponse', wasSuccessful: boolean } };

export type CoutSavePurchaseOrderNumberMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
}>;


export type CoutSavePurchaseOrderNumberMutation = { __typename?: 'Mutation', coutSavePurchaseOrderNumber: { __typename?: 'CoutUpdateResponse', wasSuccessful: boolean } };

export type CoutDeliveryVehiclesQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
}>;


export type CoutDeliveryVehiclesQuery = { __typename?: 'Query', coutDeliveryVehicles: { __typename?: 'CoutDeliveryVehicle', id: string, vehicles: Array<{ __typename?: 'CoutVehicle', id: string, vehicleId: string, description?: string | null } | null>, vehicleOptimization?: { __typename?: 'CoutDeliveryVehicleOptimization', id: string, activeVehicleCode?: string | null, vehicleType?: string | null, vehicleNumber?: number | null, weight?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null } | null, volume?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null } | null, footprint?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null } | null, fullPallet?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null } | null, fullLayer?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null } | null, fullCase?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null } | null } | null } };

export type GetBaseSiteQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
}>;


export type GetBaseSiteQuery = { __typename?: 'Query', site?: { __typename?: 'BasSite', id: string, baseSiteId: string, name?: string | null, locale?: string | null, stores?: Array<{ __typename?: 'BasStore', id: string, baseStoreId: string, name?: string | null, cmsSite?: { __typename?: 'BasCmsSite', id: string, cmsSiteId: string, name?: string | null } | null } | null> | null, defaultCurrency?: { __typename?: 'CurCurrency', isoCode: string, name?: string | null, active?: boolean | null, symbol?: string | null } | null, defaultLanguage?: { __typename?: 'BasLanguage', id: string, isocode: string, name: string, nativeName: string, active: boolean } | null } | null };

export type ShKeywordSuggestionsQueryVariables = Exact<{
  trackingId: Scalars['String']['input'];
  language: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  country: Scalars['String']['input'];
  q: Scalars['String']['input'];
  coveoToken: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ShKeywordSuggestionsQuery = { __typename?: 'Query', shKeywordSuggestions: { __typename?: 'ShKeywordSuggestResponse', id: string, texts: Array<string | null> } };

export type ShProductSuggestQueryVariables = Exact<{
  trackingId: Scalars['String']['input'];
  language: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  country: Scalars['String']['input'];
  q: Scalars['String']['input'];
  coveoToken: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ShProductSuggestQuery = { __typename?: 'Query', shProductSuggest: { __typename?: 'ShProductSuggestResponse', id: string, responseId: string, products: Array<{ __typename?: 'PrdItem', name?: string | null, productCode?: string | null, images?: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null } | null, volumePrices?: Array<{ __typename?: 'PrdPrice', id: string, formattedPrice?: string | null } | null> | null, uoms: Array<{ __typename?: 'PrdSalesUOM', id: string, grossWeight?: number | null, unit?: { __typename?: 'PrdUOM', id: string, name?: string | null } | null, grossWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null } | null } | null> } | null> } };

export type CoveoTokenMutationVariables = Exact<{
  b2bUnitId: Scalars['ID']['input'];
  hasBaseStoreRestrictedProducts: Scalars['Boolean']['input'];
  hasB2BUnitRestrictedProducts: Scalars['Boolean']['input'];
}>;


export type CoveoTokenMutation = { __typename?: 'Mutation', coveoToken: { __typename?: 'ShCoveoTokenResponse', id: string, token: string } };

export type GetStoreConfigQueryVariables = Exact<{
  baseSiteId: Scalars['String']['input'];
  language: Scalars['String']['input'];
  defaultLanguage: Scalars['String']['input'];
}>;


export type GetStoreConfigQuery = { __typename?: 'Query', scStoreConfig: { __typename?: 'ScStoreConfig', id: string, name?: string | null, siteLogoUrl?: string | null, useCoveoSearch: boolean, hasOtpLogin: boolean, feedbackType: Array<string>, feedbackReasons: Array<string>, colorTheme?: string | null, footerMenu: Array<{ __typename: 'ScNavLinkNode', id: string, title: string, link?: { __typename: 'ScNavUrlLink', url: string, id: string, label: string } | { __typename: 'ScNavUrlLinkExternal', url: string, id: string, label: string } | null }> } };

export type ClaimUploadDocumentsQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
}>;


export type ClaimUploadDocumentsQuery = { __typename?: 'Query', claimUploadDocuments: { __typename?: 'ClClaimUploadDocumentsResponse', id: string, errors?: Array<{ __typename?: 'ClClaimUploadError', id: string, type?: string | null, reason?: string | null, message?: string | null, subjectType?: string | null, subject?: string | null, errorCode?: string | null, language?: string | null, position?: number | null, exceptionMessage?: string | null }> | null, items?: Array<{ __typename?: 'ClClaimUploadItem', active?: boolean | null, format?: string | null, id: string, supportFormat?: Array<string> | null, title?: string | null, tooltip?: string | null, zmandatory?: boolean | null, claimTypeTaxes?: boolean | null, claimTypeTTS?: boolean | null, claimTypeReturn?: boolean | null, claimTypeRefusal?: boolean | null, claimTypePriceDiff?: boolean | null, claimTypeMissingDiscounts?: boolean | null, image?: { __typename?: 'ClClaimUploadImage', contentType?: string | null } | null }> | null } };

export type ClaimValidationQueryVariables = Exact<{
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  claimType: ClClaimTypeEnum;
  customerReference: Scalars['String']['input'];
  activityNumber?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClaimValidationQuery = { __typename?: 'Query', claimValidation: { __typename?: 'ClClaimValidationResponse', isValid: boolean, id: string, nestleReference?: string | null, payerList: Array<{ __typename?: 'ClClaimPayer', name?: string | null, payer?: string | null }>, ruleErrors: Array<{ __typename?: 'ClClaimError', id: string, message: string }> } };

export type CreateClaimMutationVariables = Exact<{
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  input: ClCreateClaimInput;
}>;


export type CreateClaimMutation = { __typename?: 'Mutation', createClaim: { __typename?: 'ClCreateClaimResponse', wasSuccessful: boolean, id: string, errors?: Array<{ __typename?: 'ClCreateClaimError', type?: string | null, reason?: string | null, message?: string | null, subjectType?: string | null, subject?: string | null, errorCode?: string | null, language?: string | null, position?: number | null, exceptionMessage?: string | null }> | null } };

export type SubmitContactUsSupportMutationVariables = Exact<{
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  supportForm: CuSupportFormInput;
  attachments?: InputMaybe<Array<CuAttachmentInput> | CuAttachmentInput>;
}>;


export type SubmitContactUsSupportMutation = { __typename?: 'Mutation', submitContactUsSupport: { __typename?: 'CuSupportResponse', id: string, wasSuccessful: boolean, message?: string | null, ruleErrors: Array<{ __typename?: 'CuError', message: string, id: string }> } };

export type ProductRecommendationsQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  trackingId: Scalars['String']['input'];
  coveoToken: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  country: Scalars['String']['input'];
  language: Scalars['String']['input'];
  slotId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<PrRecommendationSlotType>;
  strategy?: InputMaybe<PrRecommendationStrategy>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  cartProducts?: InputMaybe<Array<PrProductItemInput> | PrProductItemInput>;
  purchasedProducts?: InputMaybe<Array<PrProductItemInput> | PrProductItemInput>;
}>;


export type ProductRecommendationsQuery = { __typename?: 'Query', productRecommendations: { __typename?: 'PRProductRecommendationsResponse', id: string, responseId: string, title?: string | null, items: Array<{ __typename?: 'PrdItem', id: string, productCode?: string | null, name?: string | null, EAN?: string | null, GTIN?: string | null, NDC?: string | null, availabilityStatus?: PrdColorStatus | null, images?: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null } | null, uoms: Array<{ __typename?: 'PrdSalesUOM', id: string, grossWeight?: number | null, netWeight?: number | null, unit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, grossWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, netWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null } | null>, volumePrices?: Array<{ __typename?: 'PrdPrice', id: string, formattedPrice?: string | null, isCustomerPrice?: boolean | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> | null, stock?: { __typename?: 'PrdStock', status?: string | null, stockColor?: PrdColorStatus | null } | null, promotions?: Array<{ __typename?: 'PrdPromotion', id: string, value: { __typename?: 'CmmMoney', formattedValue?: string | null } } | null> | null, freeGoods?: Array<{ __typename?: 'PrdFreeGoodsPromotion', id: string, buyQuantity?: number | null, getQuantity?: number | null, isPromotionAvailable?: boolean | null } | null> | null } | null> } };

export type B2bUnitsQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
}>;


export type B2bUnitsQuery = { __typename?: 'Query', b2bUnits: Array<{ __typename?: 'BuB2bUnit', id: string, b2bUnitId: string, name: string, b2bNumber: string, address: string, hasRestrictedProducts: boolean } | null> };

export type DeliveryQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  deliveryId: Scalars['ID']['input'];
}>;


export type DeliveryQuery = { __typename?: 'Query', delivery?: { __typename?: 'OhDeliveryDetails', id: string, deliveryId: string, deliveryMessage?: string | null, pgaDate?: any | null, deliveryStatus?: string | null, shipmentStatus?: string | null, totalWeight?: number | null, totalWeightUnit?: string | null, totalVolume?: number | null, totalVolumeUnit?: string | null, shipToCustomer?: { __typename?: 'OhDeliveryShipToCustomer', id: string, number: string, name?: string | null, address?: { __typename?: 'OhAddress', id: string, addressId?: string | null, addressType?: string | null, description?: string | null, company?: string | null, name?: string | null, street?: string | null, houseNumber?: string | null, city?: string | null, zip?: string | null, region?: string | null, country?: { __typename?: 'CntCountry', name: string, isoCode: string } | null } | null } | null, items: Array<{ __typename?: 'OhDeliveryItem', id: string, productId: string, name: string, isProductAvailable: boolean, actualDeliveryQuantity?: string | null, batch?: string | null, status?: string | null, statusMessage?: string | null, isExistsInB2BHybris?: boolean | null, poNumber?: string | null, orderId?: string | null, invoiceId?: string | null, images: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null }, uom: { __typename?: 'PrdUOM', id: string, code?: string | null, name?: string | null } } | null> } | null };

export type InitiateExternalPaymentFieldsFragment = { __typename?: 'PayExInitiatePaymentResponse', id: string, wasSuccessful: boolean, fromRange?: number | null, toRange?: number | null, bankAccounts: Array<{ __typename?: 'PayExBankAccounts', id: string, accountNumber: string, description: string } | null>, differenceReasons: Array<{ __typename?: 'PayExDifferenceReasons', id: string, category?: PayExDiffCategoryReasons | null, code?: string | null, description?: string | null } | null>, docDetails: Array<{ __typename?: 'PayExDocDetails', id: string, amountPriceType?: string | null, docNumber?: string | null, docDate?: string | null, paidAmountPriceType?: string | null, payInFull?: boolean | null, reference?: string | null, amount?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null, priceType?: string | null } | null, paidAmount?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null, priceType?: string | null } | null, multipleReasons: Array<{ __typename?: 'PayExMultipleReason', id: string, comments?: string | null, deductedAmountPriceType?: string | null, deductedAmount?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null, priceType?: string | null } | null, reason?: { __typename?: 'PayExDifferenceReasons', id: string, category?: PayExDiffCategoryReasons | null, code?: string | null, description?: string | null } | null } | null> }>, paymentDetails: Array<{ __typename?: 'PayExPaymentDetails', id: string, comments?: string | null, currency?: string | null, depositDate?: string | null, depositNo?: string | null, paidAmountPriceType?: string | null, bankData: Array<{ __typename?: 'PayExBankAccounts', id: string, accountNumber: string, description: string } | null> }>, ruleWarnings: Array<{ __typename?: 'PayExUploadWarning', id: string, code?: string | null, message: string, subject?: string | null } | null>, ruleErrors: Array<{ __typename?: 'PayExUploadError', id: string, code?: string | null, message?: string | null, subject?: string | null } | null> } & { ' $fragmentName'?: 'InitiateExternalPaymentFieldsFragment' };

export type PaymentAdviceExcelDownloadMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  docDetails?: InputMaybe<Array<InputMaybe<PayExDocDetailsInput>> | InputMaybe<PayExDocDetailsInput>>;
}>;


export type PaymentAdviceExcelDownloadMutation = { __typename?: 'Mutation', paymentAdviceExcelDownload?: { __typename?: 'PayExPaymentAdviceExcelResponse', id: string, filename: string, base64Data: string, contentType?: string | null } | null };

export type UserAccountQueryVariables = Exact<{
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  filters?: InputMaybe<MaMyAccountFilters>;
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserAccountQuery = { __typename?: 'Query', userAccount: { __typename?: 'MaMyAccountResponse', excelFile?: string | null, accountDetails?: { __typename?: 'MaAccountDetails', id: string, creditBlock?: boolean | null, creditUtilized?: string | null, paymentTerms?: string | null, bankName?: string | null, accountNumber?: string | null, lastPayment?: string | null, creditExposure?: { __typename?: 'CmmMoney', currency?: string | null, formattedValue?: string | null, priceType?: string | null, value: string } | null, creditLimit?: { __typename?: 'CmmMoney', value: string, priceType?: string | null, formattedValue?: string | null, currency?: string | null } | null, effectiveCreditLimit?: { __typename?: 'CmmMoney', value: string, priceType?: string | null, formattedValue?: string | null, currency?: string | null } | null, lastPaymentReceived?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null, priceType?: string | null } | null } | null, accountBalance?: Array<{ __typename?: 'MaAccountBalance', id: string, text?: string | null, value?: string | null, currency?: string | null, formattedValue?: string | null, priceType?: string | null } | null> | null, accountDocuments?: Array<{ __typename?: 'MaAccountDocument', id: string, documentDate?: string | null, status?: string | null, assignment?: string | null, clearingDocument?: string | null, customerReference?: string | null, documentNumber?: string | null, documentType?: string | null, payer?: string | null, paymentDueDate?: string | null, soldTo?: string | null, type?: string | null, amount?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null, priceType?: string | null } | null } | null> | null } };

export type GetMyProfileQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
}>;


export type GetMyProfileQuery = { __typename?: 'Query', me?: { __typename?: 'CusMe', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null };

export type GetB2BUnitInfoQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
}>;


export type GetB2BUnitInfoQuery = { __typename?: 'Query', b2bUnitInfo?: { __typename?: 'BuB2bUnitInfo', id: string, name: string, address?: string | null, region?: string | null, telephone?: string | null, country?: { __typename?: 'CntCountry', name: string, isoCode: string } | null } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  input: CusUpdateProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile?: { __typename?: 'CusMe', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null };

export type OrderConfirmationMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  paymentDetails?: InputMaybe<OcPaymentDetailsInput>;
}>;


export type OrderConfirmationMutation = { __typename?: 'Mutation', orderConfirmation?: { __typename?: 'OcConfirmationResponse', id: string, wasSuccessful: boolean, orderId?: string | null, ruleErrors?: Array<{ __typename?: 'OcErrorMessage', message: string } | null> | null } | null };

export type OrderQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'OhOrderDetails', id: string, orderId: string, status?: string | null, statusCode?: string | null, poNumber?: string | null, requestedDeliveryDate: any, deliveryTrackingUrls: Array<string | null>, customerMessage?: string | null, rejectionReason?: string | null, deliveryAddress: { __typename?: 'OhAddress', id: string, addressId?: string | null, addressType?: string | null, description?: string | null, company?: string | null, name?: string | null, street?: string | null, houseNumber?: string | null, city?: string | null, zip?: string | null, region?: string | null, country?: { __typename?: 'CntCountry', name: string, isoCode: string } | null }, grossTotal?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, netTotal?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, taxTotal?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, items: Array<{ __typename?: 'OhOrderItem', id: string, productId: string, name: string, isProductAvailable: boolean, customerMaterialNumber?: string | null, orderedQuantity?: string | null, deliveredQuantity?: string | null, confirmedQuantity?: string | null, expDeliveryDate?: any | null, status: OhOrderItemStatusEnum, deliveryId?: string | null, invoiceId?: string | null, images: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null }, uom: { __typename?: 'PrdUOM', id: string, code?: string | null, name?: string | null }, unitPrice?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, totalPrice?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> } | null };

export type CreateOrderTemplateMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  input: OtCreateOrderTemplateInput;
}>;


export type CreateOrderTemplateMutation = { __typename?: 'Mutation', createOrderTemplate: { __typename?: 'OtCreateOrderTemplateResponse', id: string, orderTemplateCode: string, orderTemplateName: string, wasSuccessful: boolean, ruleErrors?: Array<{ __typename?: 'OtStandardRuleError', id?: string | null, message: string }> | null } };

export type DeleteOrderTemplateMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  orderTemplateCode: Scalars['ID']['input'];
}>;


export type DeleteOrderTemplateMutation = { __typename?: 'Mutation', deleteOrderTemplate: { __typename?: 'OtDeleteOrderTemplateResponse', id: string, wasSuccessful: boolean, ruleErrors?: Array<{ __typename?: 'OtStandardRuleError', id?: string | null, message: string }> | null } };

export type InitiateOrderTemplateDownloadMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
}>;


export type InitiateOrderTemplateDownloadMutation = { __typename?: 'Mutation', initiateOrderTemplateDownload: { __typename?: 'OhDownloadJob', id: string, status: OhDownloadStatus, createdAt: any } };

export type GetOrderTemplateDownloadStatusQueryVariables = Exact<{
  downloadId: Scalars['ID']['input'];
}>;


export type GetOrderTemplateDownloadStatusQuery = { __typename?: 'Query', getOrderTemplateDownloadStatus?: { __typename?: 'OhDownloadProgress', downloadId: string, status: OhDownloadStatus, progress: number, message?: string | null, error?: string | null } | null };

export type SearchOrderTemplatesQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  orderTemplateCode?: InputMaybe<Scalars['String']['input']>;
  orderTemplateName?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchOrderTemplatesQuery = { __typename?: 'Query', searchOrderTemplates: { __typename?: 'OtSearchOrderTemplatesResponse', id: string, orderTemplates: Array<{ __typename?: 'OtOrderTemplate', id: string, orderTemplateCode: string, orderTemplateName?: string | null, orderCreatedDate?: string | null, entries: Array<{ __typename?: 'OtOrderTemplateEntry', entryNumber: number, quantity: number, product: { __typename?: 'OtProduct', code: string, name: string, url?: string | null, images?: Array<{ __typename?: 'OtProductImage', altText: string, format: string, imageType: string, url: string } | null> | null }, zsalesUnit: { __typename?: 'OtSalesUnit', code: string, name: string } }> }> } };

export type UpdateOrderTemplateMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  input: OtUpdateOrderTemplateRequestBody;
}>;


export type UpdateOrderTemplateMutation = { __typename?: 'Mutation', updateOrderTemplate: { __typename?: 'OtUpdateOrderTemplateResponse', id: string, wasSuccessful: boolean, ruleErrors?: Array<{ __typename?: 'OtStandardRuleError', id?: string | null, message: string }> | null } };

export type ValidateEntriesAndUpdateOrderTemplateMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  input: OtUpdateOrderTemplateRequestBody;
}>;


export type ValidateEntriesAndUpdateOrderTemplateMutation = { __typename?: 'Mutation', validateEntriesAndUpdateOrderTemplate: { __typename?: 'OtValidateEntriesAndUpdateOrderTemplateResponse', validation: { __typename?: 'CrtValidateEntriesResponse', id: string, result: string, errors?: Array<{ __typename?: 'CrtValidationError', id: string, row: number, productId: string, errorCode: string }> | null }, updateOrderTemplateResult?: { __typename?: 'OtUpdateOrderTemplateResponse', id: string, wasSuccessful: boolean, ruleErrors?: Array<{ __typename?: 'OtStandardRuleError', id?: string | null, message: string }> | null } | null } };

export type OrderHistoryQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrderHistoryQuery = { __typename?: 'Query', orderHistory?: Array<{ __typename?: 'OhOrder', id: string, orderId: string, orderDate?: any | null, purchaseOrderNumber?: string | null, status?: string | null } | null> | null };

export type CardRemoveMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cardId: Scalars['ID']['input'];
}>;


export type CardRemoveMutation = { __typename?: 'Mutation', cardRemove: { __typename?: 'CardRemoveResponse', id: string, wasSuccessful: boolean } };

export type CardSelectMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  cardId: Scalars['ID']['input'];
}>;


export type CardSelectMutation = { __typename?: 'Mutation', cardSelect: { __typename?: 'CardSelectResponse', id: string, wasSuccessful: boolean } };

export type CardSetMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  input: PayCSaveCardInput;
  shouldSave: Scalars['Boolean']['input'];
}>;


export type CardSetMutation = { __typename?: 'Mutation', cardSet: { __typename?: 'PayCPaymentMethod', id: string, cardId: string, accountHolderName: string, cardNumber: string, defaultPayment: boolean, expiryMonth: string, expiryYear: string, saved: boolean, subscriptionId: string, billingAddress?: { __typename?: 'CusAddress', id: string, addressId: string, isDefault: boolean, isShippingAddress: boolean, isAddressBook: boolean, firstName: string, formattedAddress: string, line1: string, line2?: string | null, zip: string, phone?: string | null, town?: string | null, region?: string | null, email?: string | null } | null, cardType: { __typename?: 'PayCPaymentCardType', id: string, code: string, name: string } } };

export type PayCapturePaymentMutationVariables = Exact<{
  token: Scalars['String']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
}>;


export type PayCapturePaymentMutation = { __typename?: 'Mutation', payCapturePayment: { __typename?: 'PayPaymentResponse', wasSuccessful: boolean, cardDetails?: { __typename?: 'PayCardPaymentResponse', cardType?: string | null, cardTypeCode?: string | null, cardNumber?: string | null, cardExpiryMonth?: string | null, cardExpiryYear?: string | null, cardHolderName?: string | null } | null, transaction?: { __typename?: 'PayTransactionPaymentResponse', errorNo?: number | null, errorDesc?: string | null, warning?: string | null, cavv?: string | null, paResStatus?: string | null, eciFlag?: number | null, dsTransactionId?: string | null, threeDSVersion?: string | null } | null, ruleErrors?: Array<{ __typename?: 'PayAccessDatabaseError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayCreateRequestError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayDecryptDataError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayDeserializeResponsePacketError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayExpireSessionError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayExpireXiSecureCertificateError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayGetAccessTokenError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayGetXiSecureTokenError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayHandleCardinalResponseError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayHandleSessionError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayInterceptEcommError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayLoadCardinalConfigurationError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayLoadPaymentPageIframeError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayMissingResponsePacketError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayPaymentConfigError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayPaymentGenericError', id: string, message?: string | null } | { __typename?: 'PayPreventDuplicateSubmissionError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayProcessRequestError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayRequestPurchasedTypeError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayRetrieveResponseError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayValidateCardinalConfigurationError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayValidateMerchantGuidError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayValidateRequestPacketError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayValidateSignatureError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayXiSecureError', id: string, code?: string | null, message?: string | null } | null> | null } };

export type PayInitiate3DsMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  redirectUrl: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  cardData: PayCardDataInput;
  billingAddress: PayBillingAddressInput;
  shippingAddress: PayShippingAddressInput;
  clientDevice: PayClientDeviceInput;
}>;


export type PayInitiate3DsMutation = { __typename?: 'Mutation', payInitiate3DS: { __typename?: 'PayInitiate3DSResponse', wasSuccessful: boolean, token?: string | null, ruleErrors?: Array<{ __typename?: 'PayAccessDatabaseError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayCreateRequestError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayDecryptDataError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayDeserializeResponsePacketError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayExpireSessionError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayExpireXiSecureCertificateError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayGetAccessTokenError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayGetXiSecureTokenError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayHandleCardinalResponseError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayHandleSessionError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayInterceptEcommError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayLoadCardinalConfigurationError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayLoadPaymentPageIframeError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayMissingResponsePacketError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayPaymentConfigError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayPaymentGenericError', id: string, message?: string | null } | { __typename?: 'PayPreventDuplicateSubmissionError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayProcessRequestError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayRequestPurchasedTypeError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayRetrieveResponseError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayValidateCardinalConfigurationError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayValidateMerchantGuidError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayValidateRequestPacketError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayValidateSignatureError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayXiSecureError', id: string, code?: string | null, message?: string | null } | null> | null } };

export type PayInitiateMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
}>;


export type PayInitiateMutation = { __typename?: 'Mutation', payInitiate: { __typename?: 'PayInitiateResponse', wasSuccessful: boolean, token?: string | null, ruleErrors?: Array<{ __typename?: 'PayAccessDatabaseError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayCreateRequestError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayDecryptDataError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayDeserializeResponsePacketError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayExpireSessionError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayExpireXiSecureCertificateError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayGetAccessTokenError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayGetXiSecureTokenError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayHandleCardinalResponseError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayHandleSessionError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayInterceptEcommError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayLoadCardinalConfigurationError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayLoadPaymentPageIframeError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayMissingResponsePacketError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayPaymentConfigError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayPaymentGenericError', id: string, message?: string | null } | { __typename?: 'PayPreventDuplicateSubmissionError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayProcessRequestError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayRequestPurchasedTypeError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayRetrieveResponseError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayValidateCardinalConfigurationError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayValidateMerchantGuidError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayValidateRequestPacketError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayValidateSignatureError', id: string, code?: string | null, message?: string | null } | { __typename?: 'PayXiSecureError', id: string, code?: string | null, message?: string | null } | null> | null } };

export type PaymentConfigQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
}>;


export type PaymentConfigQuery = { __typename?: 'Query', paymentConfig: { __typename?: 'PayCPaymentConfigResponse', paymetricMerchantGUID: string, paymetric3DSEnabled: boolean, id: string, checkoutPaymentTypes: Array<PayCCheckoutPaymentType>, paymetricBaseUrl: string } };

export type PaymentTypeUpdateMutationVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  paymentType: PayPaymentTypeEnum;
}>;


export type PaymentTypeUpdateMutation = { __typename?: 'Mutation', paymentTypeUpdate: { __typename?: 'PayPaymentInfoResponse', wasSuccessful: boolean, payment?: { __typename?: 'PayCPaymentMethod', id: string, cardId: string, accountHolderName: string, cardNumber: string, defaultPayment: boolean, expiryMonth: string, expiryYear: string, saved: boolean, subscriptionId: string, billingAddress?: { __typename?: 'CusAddress', id: string, addressId: string, isDefault: boolean, isShippingAddress: boolean, isAddressBook: boolean, firstName: string, formattedAddress: string, line1: string, line2?: string | null, zip: string, phone?: string | null, town?: string | null, region?: string | null, email?: string | null, country?: { __typename?: 'CntCountry', name: string, isoCode: string } | null } | null, cardType: { __typename?: 'PayCPaymentCardType', id: string, code: string, name: string } } | null } };

export type CardsQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
}>;


export type CardsQuery = { __typename?: 'Query', cards: { __typename?: 'CardPaymentMethodsResponse', id: string, payments: Array<{ __typename?: 'PayCPaymentMethod', id: string, cardId: string, accountHolderName: string, cardNumber: string, defaultPayment: boolean, expiryMonth: string, expiryYear: string, saved: boolean, subscriptionId: string, billingAddress?: { __typename?: 'CusAddress', id: string, addressId: string, isDefault: boolean, isShippingAddress: boolean, isAddressBook: boolean, firstName: string, formattedAddress: string, line1: string, line2?: string | null, zip: string, phone?: string | null, town?: string | null, region?: string | null, email?: string | null } | null, cardType: { __typename?: 'PayCPaymentCardType', id: string, code: string, name: string } }> } };

export type ProductReferencesQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  productCode: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductReferencesQuery = { __typename?: 'Query', productReferences: { __typename?: 'ProductReferencesResponse', id: string, items?: Array<{ __typename?: 'CrtProductReference', id: string, referenceType?: string | null, target?: { __typename?: 'PrdItem', url?: string | null, summary?: string | null, productCode?: string | null, name?: string | null, manufacturer?: string | null, isPurchasable?: boolean | null, isNewProduct?: boolean | null, id: string, description?: string | null, availabilityStatus?: PrdColorStatus | null, additionalInformation?: string | null, NDC?: string | null, GTIN?: string | null, EAN?: string | null, volumePrices?: Array<{ __typename?: 'PrdPrice', id: string, minQuantity?: string | null, maxQuantity?: string | null, formattedPrice?: string | null, isCustomerPrice?: boolean | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> | null, uoms: Array<{ __typename?: 'PrdSalesUOM', id: string, grossWeight?: number | null, netWeight?: number | null, unit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, grossWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, netWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null } | null>, stock?: { __typename?: 'PrdStock', id: string, status?: string | null, quantity?: string | null, fromData?: string | null, stockColor?: PrdColorStatus | null } | null, promotions?: Array<{ __typename?: 'PrdPromotion', id: string, type: PrdPromotionTypeEnum, value: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } } | null> | null, images?: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null } | null, freeGoods?: Array<{ __typename?: 'PrdFreeGoodsPromotion', id: string, isPromotionAvailable?: boolean | null, buyQuantity?: number | null, getQuantity?: number | null, unitOfFreeProduct?: string | null } | null> | null, categories?: Array<{ __typename?: 'PrdCategories', id: string, categoryCode?: string | null, name?: string | null, url?: string | null, categoryImage?: { __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null } | null> | null } | null } | null> | null } };

export type ProductDetailsQueryVariables = Exact<{
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  productCode: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductDetailsQuery = { __typename?: 'Query', productDetails: { __typename?: 'PrdItem', url?: string | null, summary?: string | null, productCode?: string | null, name?: string | null, manufacturer?: string | null, isPurchasable?: boolean | null, isNewProduct?: boolean | null, id: string, description?: string | null, GTIN?: string | null, EAN?: string | null, NDC?: string | null, additionalInformation?: string | null, availabilityStatus?: PrdColorStatus | null, volumePrices?: Array<{ __typename?: 'PrdPrice', id: string, formattedPrice?: string | null, isCustomerPrice?: boolean | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> | null, uoms: Array<{ __typename?: 'PrdSalesUOM', id: string, grossWeight?: number | null, netWeight?: number | null, unit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, grossWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, netWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null } | null>, stock?: { __typename?: 'PrdStock', id: string, status?: string | null, quantity?: string | null, fromData?: string | null, stockColor?: PrdColorStatus | null } | null, promotions?: Array<{ __typename?: 'PrdPromotion', id: string, type: PrdPromotionTypeEnum, value: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } } | null> | null, images?: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null } | null, freeGoods?: Array<{ __typename?: 'PrdFreeGoodsPromotion', id: string, isPromotionAvailable?: boolean | null, buyQuantity?: number | null, getQuantity?: number | null, unitOfFreeProduct?: string | null } | null> | null, categories?: Array<{ __typename?: 'PrdCategories', id: string, categoryCode?: string | null, name?: string | null, url?: string | null, categoryImage?: { __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null } | null> | null, breadcrumbs?: Array<{ __typename?: 'PrdBreadcrumb', id: string, facetCode?: string | null, facetName?: string | null, facetCodeValue?: string | null, facetNameValue?: string | null } | null> | null } };

export type AllB2BUnitsQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
}>;


export type AllB2BUnitsQuery = { __typename?: 'Query', allB2bUnits: Array<{ __typename?: 'BuB2bUnit', id: string, b2bUnitId: string, name: string, b2bNumber: string, address: string } | null> };

export type BillingDocsQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  filters?: InputMaybe<OhBillingDocumentFilters>;
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type BillingDocsQuery = { __typename?: 'Query', billingDocs: { __typename?: 'OhOrderHistoryResponse', excelFile?: string | null, documents: Array<{ __typename?: 'OhBillingDocument', id: string, documentId: string, date?: any | null, customerId?: string | null, paymentDueDate?: any | null, referenceNumber?: string | null, status?: string | null, statusCode?: string | null, total?: { __typename?: 'CmmMoney', currency?: string | null, formattedValue?: string | null, value: string } | null } | { __typename?: 'OhDelivery' } | { __typename?: 'OhOrder' } | null> } };

export type DownloadDocumentQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  type: OhDocumentTypeDownloadEnum;
  documentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DownloadDocumentQuery = { __typename?: 'Query', downloadDocument?: { __typename?: 'OhDocumentDownloadResponse', base64Data: string, contentType?: string | null, filename: string } | null };

export type InvoiceDetailsQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
  b2bCustomerId?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvoiceDetailsQuery = { __typename?: 'Query', invoice?: { __typename?: 'OhInvoiceDetails', id: string, invoiceId: string, payer?: { __typename?: 'OhInvoicePayer', id: string, payerId?: string | null, name?: string | null, address: { __typename?: 'OhAddress', id: string, addressId?: string | null, addressType?: string | null, description?: string | null, company?: string | null, name?: string | null, street?: string | null, houseNumber?: string | null, city?: string | null, zip?: string | null, region?: string | null, country?: { __typename?: 'CntCountry', name: string, isoCode: string } | null } } | null, payment?: { __typename?: 'OhInvoicePayment', id: string, terms?: string | null, dueDate?: any | null } | null, grossTotal?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, netTotal?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, taxTotal?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, items: Array<{ __typename?: 'OhInvoiceItem', id: string, productId: string, name: string, isProductAvailable: boolean, quantity?: string | null, deliveredQuantity?: string | null, orderId?: string | null, deliveryId?: string | null, images: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null }, uom: { __typename?: 'PrdUOM', id: string, name?: string | null, code?: string | null }, unitPrice?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, totalPrice?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> } | null };

export type OrderDetailsQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderDetailsQuery = { __typename?: 'Query', order?: { __typename?: 'OhOrderDetails', id: string, orderId: string, status?: string | null, poNumber?: string | null, requestedDeliveryDate: any, deliveryTrackingUrls: Array<string | null>, customerMessage?: string | null, rejectionReason?: string | null, statusCode?: string | null, deliveryAddress: { __typename?: 'OhAddress', id: string, addressId?: string | null, addressType?: string | null, company?: string | null, name?: string | null, street?: string | null, houseNumber?: string | null, city?: string | null, zip?: string | null, region?: string | null, country?: { __typename?: 'CntCountry', name: string, isoCode: string } | null }, grossTotal?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, netTotal?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, taxTotal?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, items: Array<{ __typename?: 'OhOrderItem', id: string, productId: string, name: string, isProductAvailable: boolean, customerMaterialNumber?: string | null, orderedQuantity?: string | null, deliveredQuantity?: string | null, expDeliveryDate?: any | null, status: OhOrderItemStatusEnum, deliveryId?: string | null, invoiceId?: string | null, images: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null }, uom: { __typename?: 'PrdUOM', id: string, name?: string | null, code?: string | null }, unitPrice?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, totalPrice?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> } | null };

export type ShipToPartyQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
}>;


export type ShipToPartyQuery = { __typename?: 'Query', shipToParty: Array<{ __typename?: 'ByShipToParty', id: string, name: string, value: string } | null> };

export type OrderHistoryV2QueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  filters?: InputMaybe<OhOrderHistoryFilters>;
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderHistoryV2Query = { __typename?: 'Query', orderHistoryV2: { __typename?: 'OhOrderHistoryResponse', excelFile?: string | null, documents: Array<{ __typename?: 'OhBillingDocument' } | { __typename?: 'OhDelivery', id: string, deliveryId: string, documentType?: string | null, eta?: string | null, pgiDate?: any | null, purchaseOrderNumber?: string | null, salesOrder?: string | null, shipToCustomer?: string | null, shipment?: string | null, status?: string | null } | { __typename?: 'OhOrder', id: string, orderId: string, orderDate?: any | null, rddDate?: any | null, b2bCustomer?: string | null, orderType?: string | null, purchaseOrderNumber?: string | null, status?: string | null, statusCode?: string | null, total?: { __typename?: 'CmmMoney', currency?: string | null, formattedValue?: string | null, value: string } | null } | null> } };

export type GetReportQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
}>;


export type GetReportQuery = { __typename?: 'Query', getReport: { __typename?: 'MrGetReportResponse', id: string, wasSuccessful: boolean, report?: { __typename?: 'MrReportType', id: string, reportId: string, name: string, workspaceId?: string | null, datasetId?: string | null, identity?: string | null, powerbiRole?: string | null, embedurl?: string | null, tokenId?: string | null, token?: string | null, tokenExpiry?: any | null } | null, ruleErrors?: Array<{ __typename?: 'MrReportError', id: string, message: string, type?: string | null, reason?: string | null, subjectType?: string | null, subject?: string | null, errorCode?: string | null, language?: string | null, position?: number | null, exceptionMessage?: string | null } | null> | null } };

export type ClSearchQueryVariables = Exact<{
  b2bUnitId: Scalars['ID']['input'];
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  filters: ClSearchFilters;
}>;


export type ClSearchQuery = { __typename?: 'Query', clSearch: { __typename?: 'ClSearchResponse', id: string, base64Data?: string | null, claims: Array<{ __typename?: 'ClClaim', id: string, claimId: string, date?: any | null, customerClaimReference?: string | null, activityNumber?: string | null, description?: string | null, amount?: number | null, approvedAmount?: number | null, status?: string | null, creditMemo?: string | null, hasPdfFile?: boolean | null, currency?: { __typename?: 'CurCurrency', isoCode: string } | null }> } };

export type ClaimDocumentsZipQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  claimId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClaimDocumentsZipQuery = { __typename?: 'Query', claimDocumentsZip: { __typename?: 'ClDocumentsDownloadResponse', id: string, filename: string, base64Data: string } };

export type SearchPaymentDocumentsQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  baseStoreId: Scalars['ID']['input'];
  b2bUnitId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PayExPaymentDocumentsFilters>;
}>;


export type SearchPaymentDocumentsQuery = { __typename?: 'Query', searchPaymentDocuments: { __typename?: 'PayExPaymentDocumentsList', id: string, paymentAdviceList: Array<{ __typename?: 'PayExPaymentAdvice', id: string, paymentAdviceNumber: string, closeureDate?: any | null, closeureTime?: string | null, dateReceived?: any | null, timeReceived?: string | null, status?: string | null, amount?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> } };

export type OrderSimulationQueryVariables = Exact<{
  baseSiteId: Scalars['ID']['input'];
  cartId: Scalars['ID']['input'];
  fields?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderSimulationQuery = { __typename?: 'Query', orderSimulation?: { __typename?: 'OsSimulationResponse', id: string, orderId: string, requestedDeliveryDate?: string | null, purchaseOrderNumber?: string | null, customerMessage?: string | null, paymentType?: PaymentTypeEnum | null, deliveryAddress?: { __typename?: 'CusAddress', id: string, addressId: string, isDefault: boolean, isShippingAddress: boolean, isAddressBook: boolean, firstName: string, formattedAddress: string, line1: string, line2?: string | null, zip: string, phone?: string | null, town?: string | null, region?: string | null, country?: { __typename?: 'CntCountry', name: string, isoCode: string } | null } | null, vehicleResult?: { __typename?: 'OsVehicleOptimizationResult', id: string, vehicleType?: string | null, vehicleNumber?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null, loadLead?: CoutLoadLeadEnum | null } | null, weight?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null, loadLead?: CoutLoadLeadEnum | null } | null, volume?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null, loadLead?: CoutLoadLeadEnum | null } | null, footprint?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null, loadLead?: CoutLoadLeadEnum | null } | null, fullPallet?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null, loadLead?: CoutLoadLeadEnum | null } | null, fullLayer?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null, loadLead?: CoutLoadLeadEnum | null } | null, fullCase?: { __typename?: 'CoutVehicleAvailableUOM', id: string, value?: number | null, percentage?: number | null, uom?: string | null, loadLead?: CoutLoadLeadEnum | null } | null } | null, entries?: Array<{ __typename?: 'CrtCartEntry', id: string, quantity?: number | null, totalWeight?: string | null, entryNumber: number, product: { __typename?: 'PrdItem', id: string, productCode?: string | null, name?: string | null, description?: string | null, EAN?: string | null, GTIN?: string | null, NDC?: string | null, isNewProduct?: boolean | null, url?: string | null, availabilityStatus?: PrdColorStatus | null, volumePrices?: Array<{ __typename?: 'PrdPrice', id: string, formattedPrice?: string | null, isCustomerPrice?: boolean | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null> | null, images?: { __typename?: 'PrdImagesByFormat', thumbnail?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, zoom?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null, product?: Array<{ __typename?: 'PrdImages', id: string, imageType?: string | null, format?: string | null, url?: string | null, altText?: string | null, index?: number | null } | null> | null } | null, breadcrumbs?: Array<{ __typename?: 'PrdBreadcrumb', id: string, facetCode?: string | null, facetName?: string | null, facetCodeValue?: string | null, facetNameValue?: string | null } | null> | null, uoms: Array<{ __typename?: 'PrdSalesUOM', id: string, grossWeight?: number | null, netWeight?: number | null, unit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, grossWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null, netWeightUnit?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null } | null> }, totalPrice?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, listPrice?: { __typename?: 'PrdPrice', id: string, minQuantity?: string | null, maxQuantity?: string | null, formattedPrice?: string | null, isCustomerPrice?: boolean | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null, customerPrice?: { __typename?: 'PrdPrice', id: string, minQuantity?: string | null, maxQuantity?: string | null, formattedPrice?: string | null, isCustomerPrice?: boolean | null, uom?: string | null, price?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null } | null, basePrice?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, selectedUom?: { __typename?: 'PrdUOM', id: string, displayValue?: string | null, name?: string | null, code?: string | null } | null } | null> | null, totalPrice: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null }, totalPriceWithTax?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, totalTax?: { __typename?: 'CmmMoney', value: string, currency?: string | null, formattedValue?: string | null } | null, ruleErrors: Array<{ __typename?: 'OsError', id: string, messageId?: string | null, messageText?: string | null, messageNumber?: string | null } | null>, ruleWarning: Array<{ __typename?: 'OsWarning', id: string, messageId?: string | null, messageText?: string | null, messageNumber?: string | null } | null>, paymentInfo?: { __typename?: 'PayCPaymentMethod', id: string, accountHolderName: string, cardNumber: string, cardId: string, defaultPayment: boolean, expiryMonth: string, expiryYear: string, saved: boolean, subscriptionId: string, cardType: { __typename?: 'PayCPaymentCardType', id: string, code: string, name: string }, billingAddress?: { __typename?: 'CusAddress', id: string, addressId: string, isDefault: boolean, isShippingAddress: boolean, isAddressBook: boolean, firstName: string, formattedAddress: string, line1: string, line2?: string | null, zip: string, phone?: string | null, town?: string | null, region?: string | null, email?: string | null, country?: { __typename?: 'CntCountry', name: string, isoCode: string } | null } | null } | null } | null };

export const InitiateExternalPaymentFieldsFragmentDoc = gql`
    fragment InitiateExternalPaymentFields on PayExInitiatePaymentResponse {
  id
  wasSuccessful
  bankAccounts {
    id
    accountNumber
    description
  }
  differenceReasons {
    id
    category
    code
    description
  }
  docDetails {
    id
    amount {
      value
      currency
      formattedValue
      priceType
    }
    amountPriceType
    docNumber
    docDate
    paidAmount {
      value
      currency
      formattedValue
      priceType
    }
    paidAmountPriceType
    payInFull
    reference
    multipleReasons {
      id
      comments
      deductedAmount {
        value
        currency
        formattedValue
        priceType
      }
      deductedAmountPriceType
      reason {
        id
        category
        code
        description
      }
    }
  }
  fromRange
  toRange
  paymentDetails {
    id
    bankData {
      id
      accountNumber
      description
    }
    comments
    currency
    depositDate
    depositNo
    paidAmountPriceType
  }
  ruleWarnings {
    id
    code
    message
    subject
  }
  ruleErrors {
    id
    code
    message
    subject
  }
}
    ` as unknown as DocumentNode<InitiateExternalPaymentFieldsFragment, unknown>;
export const EventCartDocument = gql`
    mutation EventCart($trackingId: String!, $cartAction: TrCartActionEnum!, $currency: String!, $product: TrProductInput!, $quantity: Int!, $coveoToken: String!) {
  eventCart(
    trackingId: $trackingId
    cartAction: $cartAction
    currency: $currency
    product: $product
    quantity: $quantity
    coveoToken: $coveoToken
  )
}
    ` as unknown as DocumentNode<EventCartMutation, EventCartMutationVariables>;
export const EventDocumentPaginationDocument = gql`
    mutation EventDocumentPagination($language: String!, $docSearchQueryId: String!, $pageNumber: Int!, $baseSiteId: String!, $baseStoreId: String!) {
  eventDocumentPagination(
    language: $language
    docSearchQueryId: $docSearchQueryId
    pageNumber: $pageNumber
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
  )
}
    ` as unknown as DocumentNode<EventDocumentPaginationMutation, EventDocumentPaginationMutationVariables>;
export const EventDocumentSearchDocument = gql`
    mutation EventDocumentSearch($actionCause: TrSearchDocumentsEnum!, $queryText: String!, $language: String!, $responseTime: Int!, $docSearchQueryId: String!, $baseSiteId: String!, $baseStoreId: String!) {
  eventDocumentSearch(
    actionCause: $actionCause
    queryText: $queryText
    language: $language
    responseTime: $responseTime
    docSearchQueryId: $docSearchQueryId
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
  )
}
    ` as unknown as DocumentNode<EventDocumentSearchMutation, EventDocumentSearchMutationVariables>;
export const EventProductClickDocument = gql`
    mutation EventProductClick($trackingId: String!, $currency: String!, $product: TrProductInput!, $position: Int!, $responseId: ID!, $coveoToken: String!) {
  eventProductClick(
    trackingId: $trackingId
    currency: $currency
    product: $product
    position: $position
    responseId: $responseId
    coveoToken: $coveoToken
  )
}
    ` as unknown as DocumentNode<EventProductClickMutation, EventProductClickMutationVariables>;
export const EventProductViewDocument = gql`
    mutation EventProductView($trackingId: String!, $currency: String!, $product: TrProductInput!, $coveoToken: String!) {
  eventProductView(
    trackingId: $trackingId
    currency: $currency
    product: $product
    coveoToken: $coveoToken
  )
}
    ` as unknown as DocumentNode<EventProductViewMutation, EventProductViewMutationVariables>;
export const EventPurchaseDocument = gql`
    mutation EventPurchase($trackingId: String!, $currency: String!, $transaction: TrTransactionInput!, $products: [TrBuyedProductInput!]!, $coveoToken: String!) {
  eventPurchase(
    trackingId: $trackingId
    currency: $currency
    transaction: $transaction
    products: $products
    coveoToken: $coveoToken
  )
}
    ` as unknown as DocumentNode<EventPurchaseMutation, EventPurchaseMutationVariables>;
export const CartAddDocument = gql`
    mutation CartAdd($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $input: [CrtAddToCartInput!]!, $clearCart: Boolean) {
  cartAdd(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    input: $input
    clearCart: $clearCart
  ) {
    wasSuccessful
    cart {
      id
      cartId
      cartType
      items {
        id
        entryNumber
        product {
          id
          productCode
          name
          volumePrices {
            id
            price {
              value
              currency
              formattedValue
            }
            formattedPrice
            uom
          }
          images {
            thumbnail {
              id
              imageType
              format
              url
              altText
              index
            }
            zoom {
              id
              imageType
              format
              url
              altText
              index
            }
            product {
              id
              imageType
              format
              url
              altText
              index
            }
          }
          EAN
          GTIN
          NDC
          uoms {
            id
            unit {
              id
              displayValue
              name
              code
            }
          }
        }
        quantity
        totalPrice {
          formattedValue
        }
        selectedUom {
          id
          displayValue
          code
        }
        totalWeight
        listPrice {
          id
          price {
            formattedValue
          }
          formattedPrice
        }
        customerPrice {
          id
          price {
            formattedValue
          }
          formattedPrice
        }
      }
      totals {
        id
        subtotal {
          formattedValue
        }
        total {
          formattedValue
        }
        currency {
          isoCode
          name
        }
        totalWeight {
          value
          uom {
            id
            displayValue
          }
        }
      }
      ruleWarnings {
        __typename
        ... on CrtMinWeightWarning {
          id
          message
          threshold
        }
        ... on CrtMinValueWarning {
          id
          message
          threshold
        }
        ... on CrtMaxValueWarning {
          id
          message
          threshold
        }
        ... on CrtMinQtyWarning {
          id
          message
          threshold
        }
      }
      ruleErrors {
        __typename
        ... on CrtMinWeightError {
          id
          message
          threshold
        }
        ... on CrtMinValueError {
          id
          message
          threshold
        }
        ... on CrtMaxValueError {
          id
          message
          threshold
        }
        ... on CrtMinQtyError {
          id
          message
          threshold
        }
      }
    }
    addToCartWarnings {
      __typename
      ... on CrtDuplicateLineItemWarning {
        id
        message
      }
    }
    addToCartErrors {
      __typename
      ... on CrtDuplicateLineItemError {
        id
        message
      }
    }
  }
}
    ` as unknown as DocumentNode<CartAddMutation, CartAddMutationVariables>;
export const MeDocument = gql`
    query Me($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!) {
  me(baseSiteId: $baseSiteId, baseStoreId: $baseStoreId, b2bUnitId: $b2bUnitId) {
    id
    firstName
    cartId
    baseStore {
      id
      isPurchaseOrderMandatory
      isExcelDownload
      isDeliveryDownload
      isEDocumentDownload
      isConfirmedQuantityShown
      isDeliveredQuantityShown
      isExpectedDeliveryDateShown
      productAvailabilityActions {
        id
        availabilityStatusAction
        availabilityStatusType
        __typename
      }
      isB2BUnitsEnabled
      purchaseHistoryTypes
      isVehicleOptimization
      vehicleOptimizationType
      isEnabledTAndC
      coveoConfig {
        id
        trackingId
      }
    }
  }
}
    ` as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const ServicesHealthCheckDocument = gql`
    query ServicesHealthCheck {
  servicesHealthCheck {
    appVersion
    services {
      serviceName
      isHealthy
      statusCode
      message
    }
  }
}
    ` as unknown as DocumentNode<ServicesHealthCheckQuery, ServicesHealthCheckQueryVariables>;
export const SendForgotPasswordEmailDocument = gql`
    mutation SendForgotPasswordEmail($baseSiteId: ID!, $userId: String!) {
  sendForgotPasswordEmail(baseSiteId: $baseSiteId, userId: $userId) {
    wasSuccessful
  }
}
    ` as unknown as DocumentNode<SendForgotPasswordEmailMutation, SendForgotPasswordEmailMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($baseSiteId: ID!, $token: String!, $newPassword: String!) {
  resetPassword(baseSiteId: $baseSiteId, token: $token, newPassword: $newPassword) {
    wasSuccessful
    errors {
      errorCode
      message
      translationKey
    }
  }
}
    ` as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($baseSiteId: ID!, $newPassword: String!, $currentPassword: String!) {
  updatePassword(
    baseSiteId: $baseSiteId
    newPassword: $newPassword
    currentPassword: $currentPassword
  ) {
    wasSuccessful
    errors {
      errorCode
      message
      translationKey
    }
  }
}
    ` as unknown as DocumentNode<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const GetBaseStoreDetailsDocument = gql`
    query GetBaseStoreDetails($baseSiteId: ID!, $baseStoreId: ID!) {
  baseStore(baseSiteId: $baseSiteId, baseStoreId: $baseStoreId) {
    id
    baseStoreId
    name
    hasRestrictedProducts
    baseSite {
      id
      baseSiteId
      name
    }
    shopImage {
      catalogId
      catalogVersion
      code
      downloadUrl
      url
    }
    country {
      name
      isoCode
    }
    currencies {
      isoCode
      symbol
      name
    }
    defaultCurrency {
      isoCode
      symbol
      name
    }
    availableLanguages {
      id
      active
      isocode
      name
      nativeName
      localeIso
    }
    defaultLanguage {
      id
      active
      isocode
      name
      nativeName
      localeIso
    }
    productAvailabilityActions {
      id
      availabilityStatusType
      availabilityStatusAction
    }
    isB2BUnitsEnabled
    hasOtpLogin
    purchaseHistoryTypes
    isPurchaseOrderMandatory
    isVehicleOptimization
    isDeliveryDownload
    isEDocumentDownload
    isExcelDownload
    isExcelDownloadAccount
    isEnabledTAndC
    isConfirmedQuantityShown
    isDeliveredQuantityShown
    isExpectedDeliveryDateShown
    isCatalogLinkVisible
    isAccountStatementSection
    isExtendedAccountStatementEnabled
    isPaymentAdviceUploadEnabled
    isBalanceSection
    isDetailsSection
    isEnableAssignments
    isHideSoldToAndPayer
    isSplitDebitAndCredit
    isProductStockTagEnabled
    isReturnRequestEnabled
    isReturnOrderUploadEnabled
    isBatchCodeEnabledForReturn
    claim {
      hasClaimTypeReturn
      hasClaimTypePriceDiff
      hasClaimTypeRefusal
      hasClaimTypeTTS
      hasClaimTypeMissingDiscounts
      hasClaimTypeTaxes
      isDisableNestleReferenceMissingDiscounts
      isDisableNestleReferencePriceDiff
      isDisableNestleReferenceRefusal
      isDisableNestleReferenceTTS
      isDisableNestleReferenceReturn
      isDisableNestleReferenceTaxes
      isNestleReferenceValidationEnabled
      isNotesForCreateClaimEnabled
      isDownloadClaimDetailDocumentsEnabled
      isDownloadClaimEnabled
      isProductLevelClaimEnabled
    }
    contactInformation {
      address
      email
      telephone
      name
    }
    coveoConfig {
      id
      enableDocuments
      organizationID
      searchHub
      slotIDs {
        entry {
          key
          value
        }
      }
      trackingId
    }
  }
}
    ` as unknown as DocumentNode<GetBaseStoreDetailsQuery, GetBaseStoreDetailsQueryVariables>;
export const GetBaseStoresDocument = gql`
    query GetBaseStores($baseSiteId: ID!) {
  baseStores(baseSiteId: $baseSiteId) {
    id
    baseStoreId
    name
    isFacetSearchEnabled
    shopImage {
      code
      url
      downloadUrl
    }
    baseSite {
      id
      baseSiteId
      name
    }
    currencies {
      active
      isoCode
      name
      symbol
    }
    defaultCurrency {
      active
      isoCode
      name
      symbol
    }
    defaultLanguage {
      id
      active
      isocode
      name
      nativeName
      localeIso
    }
    productAvailabilityActions {
      availabilityStatusAction
      availabilityStatusType
    }
    isCatalogLinkVisible
    hasRestrictedProducts
  }
}
    ` as unknown as DocumentNode<GetBaseStoresQuery, GetBaseStoresQueryVariables>;
export const LanguagesDocument = gql`
    query Languages($baseSiteId: ID!) {
  languages(baseSiteId: $baseSiteId) {
    languages {
      id
      active
      isocode
      name
      nativeName
      localeIso
    }
    id
  }
}
    ` as unknown as DocumentNode<LanguagesQuery, LanguagesQueryVariables>;
export const CartDeleteEntryDocument = gql`
    mutation CartDeleteEntry($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $currency: String, $input: [CrtRemoveCartEntryInput!]!) {
  cartDeleteEntry(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    currency: $currency
    input: $input
  ) {
    wasSuccessful
    cart {
      id
      cartId
      items {
        id
        entryNumber
        product {
          id
          productCode
          name
          volumePrices {
            id
            price {
              value
              currency
              formattedValue
            }
            formattedPrice
            uom
          }
          images {
            thumbnail {
              id
              imageType
              format
              url
              altText
              index
            }
            zoom {
              id
              imageType
              format
              url
              altText
              index
            }
            product {
              id
              imageType
              format
              url
              altText
              index
            }
          }
          EAN
          GTIN
          NDC
          uoms {
            id
            unit {
              id
              displayValue
              name
              code
            }
          }
        }
        quantity
        totalPrice {
          formattedValue
        }
        selectedUom {
          id
          displayValue
          code
        }
        totalWeight
        listPrice {
          id
          price {
            formattedValue
          }
          formattedPrice
        }
        customerPrice {
          id
          price {
            formattedValue
          }
          formattedPrice
        }
      }
      totals {
        id
        subtotal {
          formattedValue
        }
        total {
          formattedValue
        }
        currency {
          isoCode
          name
        }
        totalWeight {
          value
          uom {
            id
            displayValue
          }
        }
      }
      ruleWarnings {
        __typename
        ... on CrtMinWeightWarning {
          id
          message
          threshold
        }
        ... on CrtMinValueWarning {
          id
          message
          threshold
        }
        ... on CrtMaxValueWarning {
          id
          message
          threshold
        }
        ... on CrtMinQtyWarning {
          id
          message
          threshold
        }
      }
      ruleErrors {
        __typename
        ... on CrtMinWeightError {
          id
          message
          threshold
        }
        ... on CrtMinValueError {
          id
          message
          threshold
        }
        ... on CrtMaxValueError {
          id
          message
          threshold
        }
        ... on CrtMinQtyError {
          id
          message
          threshold
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<CartDeleteEntryMutation, CartDeleteEntryMutationVariables>;
export const CartDeleteDocument = gql`
    mutation CartDelete($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $currency: String) {
  cartDelete(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    currency: $currency
  ) {
    id
    wasSuccessful
  }
}
    ` as unknown as DocumentNode<CartDeleteMutation, CartDeleteMutationVariables>;
export const CartRecommendedProductsDocument = gql`
    query CartRecommendedProducts($baseSiteId: ID!, $cartId: ID!, $fields: String, $limit: String, $currency: String, $language: String) {
  cartRecommendedProducts(
    baseSiteId: $baseSiteId
    cartId: $cartId
    fields: $fields
    limit: $limit
    currency: $currency
    language: $language
  ) {
    id
    items {
      id
      target {
        EAN
        GTIN
        NDC
        availabilityStatus
        images {
          thumbnail {
            id
            imageType
            format
            url
            altText
            index
          }
          zoom {
            id
            imageType
            format
            url
            altText
            index
          }
          product {
            id
            imageType
            format
            url
            altText
            index
          }
        }
        isPurchasable
        isNewProduct
        manufacturer
        name
        productCode
        promotions {
          id
          type
          value {
            value
            currency
            formattedValue
          }
        }
        stock {
          id
          status
          quantity
          fromData
          stockColor
        }
        summary
        uoms {
          id
          grossWeight
          netWeight
          unit {
            id
            displayValue
            name
            code
          }
          grossWeightUnit {
            id
            displayValue
            name
            code
          }
          netWeightUnit {
            id
            displayValue
            name
            code
          }
        }
        url
        volumePrices {
          id
          price {
            value
            currency
            formattedValue
          }
          minQuantity
          maxQuantity
          formattedPrice
          isCustomerPrice
          uom
        }
        description
        freeGoods {
          id
          isPromotionAvailable
          buyQuantity
          getQuantity
          unitOfFreeProduct
        }
        futureStocks {
          id
          status
          quantity
          fromData
          stockColor
        }
        id
      }
    }
  }
}
    ` as unknown as DocumentNode<CartRecommendedProductsQuery, CartRecommendedProductsQueryVariables>;
export const CartValidateEntriesAndAddDocument = gql`
    mutation CartValidateEntriesAndAdd($b2bUnitId: ID!, $baseSiteId: ID!, $baseStoreId: ID!, $orderEntries: [CrtValidateEntryInput!]!) {
  cartValidateEntriesAndAdd(
    b2bUnitId: $b2bUnitId
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    orderEntries: $orderEntries
  ) {
    validation {
      id
      result
      errors {
        id
        productId
        errorCode
        row
      }
    }
    addToCartResult {
      wasSuccessful
      id
    }
  }
}
    ` as unknown as DocumentNode<CartValidateEntriesAndAddMutation, CartValidateEntriesAndAddMutationVariables>;
export const CartUpdateDocument = gql`
    mutation CartUpdate($b2bUnitId: ID!, $baseSiteId: ID!, $baseStoreId: ID!, $entries: [CrtUpdateCartEntryInput!]!, $language: String, $currency: String) {
  cartUpdate(
    b2bUnitId: $b2bUnitId
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    entries: $entries
    language: $language
    currency: $currency
  ) {
    wasSuccessful
    cart {
      id
      cartId
      items {
        id
        entryNumber
        product {
          id
          productCode
          name
          volumePrices {
            id
            price {
              value
              currency
              formattedValue
            }
            formattedPrice
            uom
          }
          images {
            thumbnail {
              id
              imageType
              format
              url
              altText
              index
            }
            zoom {
              id
              imageType
              format
              url
              altText
              index
            }
            product {
              id
              imageType
              format
              url
              altText
              index
            }
          }
          EAN
          GTIN
          NDC
          uoms {
            id
            unit {
              id
              displayValue
              name
              code
            }
          }
        }
        quantity
        totalPrice {
          formattedValue
        }
        selectedUom {
          id
          displayValue
          code
        }
        totalWeight
        listPrice {
          id
          price {
            formattedValue
          }
          formattedPrice
        }
        customerPrice {
          id
          price {
            formattedValue
          }
          formattedPrice
        }
      }
      totals {
        id
        subtotal {
          formattedValue
        }
        total {
          formattedValue
        }
        currency {
          isoCode
          name
        }
        totalWeight {
          value
          uom {
            id
            displayValue
          }
        }
      }
      ruleWarnings {
        __typename
        ... on CrtMinWeightWarning {
          id
          message
          threshold
        }
        ... on CrtMinValueWarning {
          id
          message
          threshold
        }
        ... on CrtMaxValueWarning {
          id
          message
          threshold
        }
        ... on CrtMinQtyWarning {
          id
          message
          threshold
        }
      }
      ruleErrors {
        __typename
        ... on CrtMinWeightError {
          id
          message
          threshold
        }
        ... on CrtMinValueError {
          id
          message
          threshold
        }
        ... on CrtMaxValueError {
          id
          message
          threshold
        }
        ... on CrtMinQtyError {
          id
          message
          threshold
        }
      }
    }
    addToCartWarnings {
      __typename
      ... on CrtDuplicateLineItemWarning {
        id
        message
      }
    }
    addToCartErrors {
      __typename
      ... on CrtDuplicateLineItemError {
        id
        message
      }
    }
  }
}
    ` as unknown as DocumentNode<CartUpdateMutation, CartUpdateMutationVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories($baseSiteId: ID!, $baseStoreId: ID!, $catalogId: ID, $catalogVersionId: ID, $categoryId: ID, $language: String, $fields: String) {
  getCategories(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    catalogId: $catalogId
    catalogVersionId: $catalogVersionId
    categoryId: $categoryId
    language: $language
    fields: $fields
  ) {
    id
    categories {
      id
      slug
      name
      categoryCode
      image {
        url
        format
      }
      childCategories {
        id
        slug
        name
        categoryCode
        image {
          url
          format
        }
        childCategories {
          id
          slug
          name
          categoryCode
          image {
            url
            format
          }
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const SearchDocumentsDocument = gql`
    query SearchDocuments($query: String!, $baseSiteId: String!, $baseStoreId: String!, $numberOfResults: Int) {
  searchDocuments(
    query: $query
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    numberOfResults: $numberOfResults
  ) {
    id
    documents {
      title
      description
      redirectUrl
      imageUrl
    }
    responseTime
    searchQueryId
  }
}
    ` as unknown as DocumentNode<SearchDocumentsQuery, SearchDocumentsQueryVariables>;
export const SearchDocument = gql`
    query Search($trackingId: String!, $coveoToken: String!, $b2bUnitId: ID!, $baseSiteId: ID!, $baseStoreId: ID!, $facets: [ShFacetInput!], $sort: ShSortOptionInput, $currentPage: Int, $country: String!, $language: String!, $currency: String!, $searchText: String) {
  search(
    trackingId: $trackingId
    coveoToken: $coveoToken
    b2bUnitId: $b2bUnitId
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    facets: $facets
    sort: $sort
    currentPage: $currentPage
    country: $country
    language: $language
    currency: $currency
    searchText: $searchText
  ) {
    id
    responseId
    breadcrumbs {
      id
      facetCode
      facetName
      facetCodeValue
      facetNameValue
    }
    facets {
      ... on ShFacet {
        type
        facetId
        field
        displayName
        values {
          state
          numberOfResults
          value
          path
          isLeafValue
          children {
            state
            numberOfResults
            value
            path
            isLeafValue
            children {
              state
              numberOfResults
              value
              path
              isLeafValue
              children {
                state
                numberOfResults
                value
                path
                isLeafValue
              }
            }
          }
        }
        numberOfValues
        delimitingCharacter
        hasMoreValuesAvailable
        isFieldExpanded
      }
      ... on ShFacetRange {
        type
        facetId
        field
        displayName
        min
        max
        values {
          state
          numberOfResults
          start
          end
          endInclusive
        }
      }
    }
    sort {
      id
      optionCode
      name
      direction
      selected
    }
    products {
      id
      productCode
      name
      description
      isPurchasable
      stock {
        id
        status
        quantity
        fromData
        stockColor
      }
      futureStocks {
        id
        status
        quantity
        fromData
        stockColor
      }
      manufacturer
      volumePrices {
        id
        price {
          value
          currency
          formattedValue
          priceType
        }
        minQuantity
        maxQuantity
        formattedPrice
        isCustomerPrice
        uom
      }
      images {
        thumbnail {
          id
          imageType
          format
          url
          altText
          index
        }
        zoom {
          id
          imageType
          format
          url
          altText
          index
        }
        product {
          id
          imageType
          format
          url
          altText
          index
        }
      }
      categories {
        id
        categoryCode
        name
        url
        categoryImage {
          id
          imageType
          format
          url
          altText
          index
        }
      }
      EAN
      GTIN
      NDC
      promotions {
        id
        type
        value {
          value
          currency
          formattedValue
          priceType
        }
      }
      freeGoods {
        id
        isPromotionAvailable
        buyQuantity
        getQuantity
        unitOfFreeProduct
      }
      isNewProduct
      summary
      url
      additionalInformation
      availabilityStatus
      uoms {
        id
        unit {
          id
          displayValue
          name
          code
        }
        grossWeight
        netWeight
        grossWeightUnit {
          id
          displayValue
          name
          code
        }
        netWeightUnit {
          id
          displayValue
          name
          code
        }
      }
    }
    pagination {
      id
      pageSize
      currentPage
      totalPages
      totalResults
    }
    currentFilters {
      id
      searchText
      sort
      filters {
        facetName
        facetValue
        displayValue
        isSelectedFromFacets
      }
    }
  }
}
    ` as unknown as DocumentNode<SearchQuery, SearchQueryVariables>;
export const ReportsDocument = gql`
    query Reports($baseSiteId: ID!, $baseStoreId: ID!) {
  reports(baseSiteId: $baseSiteId, baseStoreId: $baseStoreId) {
    id
    wasSuccessful
    reports {
      id
      reportId
      name
    }
    ruleErrors {
      id
      message
      type
      reason
      subjectType
      subject
      errorCode
      language
      position
      exceptionMessage
    }
  }
}
    ` as unknown as DocumentNode<ReportsQuery, ReportsQueryVariables>;
export const GetPreviousPurchasedProductDocument = gql`
    query GetPreviousPurchasedProduct($baseSiteId: String!, $cartId: String!, $fields: String, $limit: String, $productCode: String, $language: String, $currency: String) {
  purchaseHistoryProducts(
    baseSiteId: $baseSiteId
    cartId: $cartId
    fields: $fields
    limit: $limit
    productCode: $productCode
    language: $language
    currency: $currency
  ) {
    id
    items {
      EAN
      GTIN
      NDC
      availabilityStatus
      additionalInformation
      description
      freeGoods {
        id
        isPromotionAvailable
        buyQuantity
        getQuantity
        unitOfFreeProduct
      }
      categories {
        id
        categoryCode
        name
        url
        categoryImage {
          id
          imageType
          format
          url
          altText
          index
        }
      }
      futureStocks {
        id
        status
        quantity
        fromData
        stockColor
      }
      id
      images {
        thumbnail {
          id
          imageType
          format
          url
          altText
          index
        }
        zoom {
          id
          imageType
          format
          url
          altText
          index
        }
        product {
          id
          imageType
          format
          url
          altText
          index
        }
      }
      isNewProduct
      isPurchasable
      manufacturer
      name
      productCode
      promotions {
        id
        type
        value {
          value
          currency
          formattedValue
        }
      }
      stock {
        id
        status
        quantity
        fromData
        stockColor
      }
      summary
      uoms {
        id
        grossWeight
        netWeight
        unit {
          id
          displayValue
          name
          code
        }
        grossWeightUnit {
          id
          displayValue
          name
          code
        }
        netWeightUnit {
          id
          displayValue
          name
          code
        }
      }
      url
      volumePrices {
        id
        price {
          value
          currency
          formattedValue
        }
        minQuantity
        maxQuantity
        formattedPrice
        isCustomerPrice
        uom
      }
    }
  }
}
    ` as unknown as DocumentNode<GetPreviousPurchasedProductQuery, GetPreviousPurchasedProductQueryVariables>;
export const ProductCatalogPageDetailsDocument = gql`
    query ProductCatalogPageDetails($b2bUnitId: ID!, $baseStoreId: ID!, $baseSiteId: ID!, $searchText: String, $facets: [PrdFacetsParamInput], $currentPage: Int, $fields: String, $pageSize: Int, $searchQueryContext: String, $sort: PrdSortCodes, $currency: String, $language: String) {
  productCatalogPageDetails(
    b2bUnitId: $b2bUnitId
    baseStoreId: $baseStoreId
    baseSiteId: $baseSiteId
    searchText: $searchText
    facets: $facets
    currentPage: $currentPage
    fields: $fields
    pageSize: $pageSize
    searchQueryContext: $searchQueryContext
    sort: $sort
    currency: $currency
    language: $language
  ) {
    id
    breadcrumbs {
      id
      facetCode
      facetName
      facetCodeValue
      facetNameValue
    }
    facets {
      id
      name
      priority
      category
      multiSelect
      visible
      subCategories {
        id
        name
        count
        queryUrl
        queryValue
        isSelected
      }
      range {
        id
        code
        currencySymbol
        unitSymbol
        fromValue
        toValue
      }
    }
    sort {
      id
      optionCode
      name
      selected
    }
    products {
      id
      productCode
      name
      description
      isPurchasable
      stock {
        id
        status
        quantity
        fromData
        stockColor
      }
      futureStocks {
        id
        status
        quantity
        fromData
        stockColor
      }
      manufacturer
      volumePrices {
        id
        price {
          value
          currency
          formattedValue
          priceType
        }
        minQuantity
        maxQuantity
        formattedPrice
        isCustomerPrice
        uom
      }
      images {
        thumbnail {
          id
          imageType
          format
          url
          altText
          index
        }
        zoom {
          id
          imageType
          format
          url
          altText
          index
        }
        product {
          id
          imageType
          format
          url
          altText
          index
        }
      }
      categories {
        id
        categoryCode
        name
        url
        categoryImage {
          id
          imageType
          format
          url
          altText
          index
        }
      }
      EAN
      GTIN
      NDC
      promotions {
        id
        type
        value {
          value
          currency
          formattedValue
          priceType
        }
      }
      freeGoods {
        id
        isPromotionAvailable
        buyQuantity
        getQuantity
        unitOfFreeProduct
      }
      isNewProduct
      summary
      url
      additionalInformation
      availabilityStatus
      uoms {
        id
        unit {
          id
          displayValue
          name
          code
        }
        grossWeight
        netWeight
        grossWeightUnit {
          id
          displayValue
          name
          code
        }
        netWeightUnit {
          id
          displayValue
          name
          code
        }
      }
    }
    pagination {
      id
      pageSize
      currentPage
      totalPages
      totalResults
    }
    currentFilters {
      id
      searchText
      sort
      filters {
        facetName
        facetValue
        displayValue
        isSelectedFromFacets
      }
    }
  }
}
    ` as unknown as DocumentNode<ProductCatalogPageDetailsQuery, ProductCatalogPageDetailsQueryVariables>;
export const CusAddressesDocument = gql`
    query CusAddresses($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!) {
  cusAddresses(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
  ) {
    id
    addressId
    isDefault
    isShippingAddress
    isAddressBook
    firstName
    formattedAddress
    line1
    line2
    zip
    town
    country {
      name
      isoCode
    }
  }
}
    ` as unknown as DocumentNode<CusAddressesQuery, CusAddressesQueryVariables>;
export const CoutDeliveryDatesDocument = gql`
    query CoutDeliveryDates($baseSiteId: ID!, $cartId: ID!) {
  coutDeliveryDates(baseSiteId: $baseSiteId, cartId: $cartId) {
    date
    noDeliveryDays
  }
}
    ` as unknown as DocumentNode<CoutDeliveryDatesQuery, CoutDeliveryDatesQueryVariables>;
export const CoutSaveDeliveryVehicleDocument = gql`
    mutation CoutSaveDeliveryVehicle($baseSiteId: ID!, $cartId: ID!, $vehicleCode: String!, $fields: String) {
  coutSaveDeliveryVehicle(
    baseSiteId: $baseSiteId
    cartId: $cartId
    vehicleCode: $vehicleCode
    fields: $fields
  ) {
    id
    vehicles {
      id
      vehicleId
      description
    }
    vehicleOptimization {
      id
      activeVehicleCode
      vehicleType
      vehicleNumber
      weight {
        id
        value
        percentage
        uom
      }
      volume {
        id
        value
        percentage
        uom
      }
      footprint {
        id
        value
        percentage
        uom
      }
      fullPallet {
        id
        value
        percentage
        uom
      }
      fullLayer {
        id
        value
        percentage
        uom
      }
      fullCase {
        id
        value
        percentage
        uom
      }
    }
  }
}
    ` as unknown as DocumentNode<CoutSaveDeliveryVehicleMutation, CoutSaveDeliveryVehicleMutationVariables>;
export const CoutCustomerMessageDocument = gql`
    mutation CoutCustomerMessage($baseSiteId: ID!, $cartId: ID!, $message: String!) {
  coutCustomerMessage(baseSiteId: $baseSiteId, cartId: $cartId, message: $message) {
    id
    wasSuccessful
  }
}
    ` as unknown as DocumentNode<CoutCustomerMessageMutation, CoutCustomerMessageMutationVariables>;
export const CartDeliveryAddressDocument = gql`
    mutation CartDeliveryAddress($baseSiteId: ID!, $cartId: ID!, $addressId: ID!, $fields: String, $language: String, $currency: String) {
  cartDeliveryAddress(
    baseSiteId: $baseSiteId
    cartId: $cartId
    addressId: $addressId
    fields: $fields
    language: $language
    currency: $currency
  ) {
    id
    wasSuccessful
  }
}
    ` as unknown as DocumentNode<CartDeliveryAddressMutation, CartDeliveryAddressMutationVariables>;
export const CoutUpdateDeliveryDateDocument = gql`
    mutation CoutUpdateDeliveryDate($baseSiteId: ID!, $cartId: ID!, $deliveryDate: String!) {
  coutUpdateDeliveryDate(
    baseSiteId: $baseSiteId
    cartId: $cartId
    deliveryDate: $deliveryDate
  ) {
    wasSuccessful
  }
}
    ` as unknown as DocumentNode<CoutUpdateDeliveryDateMutation, CoutUpdateDeliveryDateMutationVariables>;
export const CoutSavePurchaseOrderNumberDocument = gql`
    mutation CoutSavePurchaseOrderNumber($baseSiteId: ID!, $cartId: ID!, $purchaseOrderNumber: String!) {
  coutSavePurchaseOrderNumber(
    baseSiteId: $baseSiteId
    cartId: $cartId
    purchaseOrderNumber: $purchaseOrderNumber
  ) {
    wasSuccessful
  }
}
    ` as unknown as DocumentNode<CoutSavePurchaseOrderNumberMutation, CoutSavePurchaseOrderNumberMutationVariables>;
export const CoutDeliveryVehiclesDocument = gql`
    query CoutDeliveryVehicles($baseSiteId: ID!, $cartId: ID!, $fields: String) {
  coutDeliveryVehicles(baseSiteId: $baseSiteId, cartId: $cartId, fields: $fields) {
    id
    vehicles {
      id
      vehicleId
      description
    }
    vehicleOptimization {
      id
      activeVehicleCode
      vehicleType
      vehicleNumber
      weight {
        id
        value
        percentage
        uom
      }
      volume {
        id
        value
        percentage
        uom
      }
      footprint {
        id
        value
        percentage
        uom
      }
      fullPallet {
        id
        value
        percentage
        uom
      }
      fullLayer {
        id
        value
        percentage
        uom
      }
      fullCase {
        id
        value
        percentage
        uom
      }
    }
  }
}
    ` as unknown as DocumentNode<CoutDeliveryVehiclesQuery, CoutDeliveryVehiclesQueryVariables>;
export const GetBaseSiteDocument = gql`
    query GetBaseSite($baseSiteId: ID!) {
  site(baseSiteId: $baseSiteId) {
    id
    baseSiteId
    name
    locale
    stores {
      id
      baseStoreId
      name
      cmsSite {
        id
        cmsSiteId
        name
      }
    }
    defaultCurrency {
      isoCode
      name
      active
      symbol
    }
    defaultLanguage {
      id
      isocode
      name
      nativeName
      active
    }
  }
}
    ` as unknown as DocumentNode<GetBaseSiteQuery, GetBaseSiteQueryVariables>;
export const ShKeywordSuggestionsDocument = gql`
    query ShKeywordSuggestions($trackingId: String!, $language: String!, $currency: String!, $country: String!, $q: String!, $coveoToken: String!, $limit: Int) {
  shKeywordSuggestions(
    trackingId: $trackingId
    language: $language
    currency: $currency
    country: $country
    q: $q
    coveoToken: $coveoToken
    limit: $limit
  ) {
    id
    texts
  }
}
    ` as unknown as DocumentNode<ShKeywordSuggestionsQuery, ShKeywordSuggestionsQueryVariables>;
export const ShProductSuggestDocument = gql`
    query ShProductSuggest($trackingId: String!, $language: String!, $currency: String!, $country: String!, $q: String!, $coveoToken: String!, $limit: Int) {
  shProductSuggest(
    trackingId: $trackingId
    language: $language
    currency: $currency
    country: $country
    q: $q
    coveoToken: $coveoToken
    limit: $limit
  ) {
    id
    responseId
    products {
      name
      images {
        thumbnail {
          id
          imageType
          format
          url
          altText
          index
        }
        zoom {
          id
          imageType
          format
          url
          altText
          index
        }
        product {
          id
          imageType
          format
          url
          altText
          index
        }
      }
      volumePrices {
        id
        formattedPrice
      }
      productCode
      uoms {
        id
        unit {
          id
          name
        }
        grossWeight
        grossWeightUnit {
          id
          displayValue
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<ShProductSuggestQuery, ShProductSuggestQueryVariables>;
export const CoveoTokenDocument = gql`
    mutation CoveoToken($b2bUnitId: ID!, $hasBaseStoreRestrictedProducts: Boolean!, $hasB2BUnitRestrictedProducts: Boolean!) {
  coveoToken(
    b2bUnitId: $b2bUnitId
    hasBaseStoreRestrictedProducts: $hasBaseStoreRestrictedProducts
    hasB2BUnitRestrictedProducts: $hasB2BUnitRestrictedProducts
  ) {
    id
    token
  }
}
    ` as unknown as DocumentNode<CoveoTokenMutation, CoveoTokenMutationVariables>;
export const GetStoreConfigDocument = gql`
    query GetStoreConfig($baseSiteId: String!, $language: String!, $defaultLanguage: String!) {
  scStoreConfig(
    baseSiteId: $baseSiteId
    language: $language
    defaultLanguage: $defaultLanguage
  ) {
    id
    name
    siteLogoUrl
    useCoveoSearch
    hasOtpLogin
    feedbackType
    feedbackReasons
    colorTheme
    footerMenu {
      __typename
      ... on ScNavLinkNode {
        id
        title
        link {
          __typename
          id
          label
          ... on ScNavUrlLink {
            url
          }
          ... on ScNavUrlLinkExternal {
            url
          }
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetStoreConfigQuery, GetStoreConfigQueryVariables>;
export const ClaimUploadDocumentsDocument = gql`
    query ClaimUploadDocuments($baseSiteId: ID!, $baseStoreId: ID!) {
  claimUploadDocuments(baseSiteId: $baseSiteId, baseStoreId: $baseStoreId) {
    errors {
      id
      type
      reason
      message
      subjectType
      subject
      errorCode
      language
      position
      exceptionMessage
    }
    id
    items {
      active
      format
      id
      image {
        contentType
      }
      supportFormat
      title
      tooltip
      zmandatory
      claimTypeTaxes
      claimTypeTTS
      claimTypeReturn
      claimTypeRefusal
      claimTypePriceDiff
      claimTypeMissingDiscounts
    }
  }
}
    ` as unknown as DocumentNode<ClaimUploadDocumentsQuery, ClaimUploadDocumentsQueryVariables>;
export const ClaimValidationDocument = gql`
    query ClaimValidation($b2bUnitId: ID!, $baseSiteId: ID!, $baseStoreId: ID!, $claimType: ClClaimTypeEnum!, $customerReference: String!, $activityNumber: String, $fields: String) {
  claimValidation(
    b2bUnitId: $b2bUnitId
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    claimType: $claimType
    customerReference: $customerReference
    activityNumber: $activityNumber
    fields: $fields
  ) {
    isValid
    id
    nestleReference
    payerList {
      name
      payer
    }
    ruleErrors {
      id
      message
    }
  }
}
    ` as unknown as DocumentNode<ClaimValidationQuery, ClaimValidationQueryVariables>;
export const CreateClaimDocument = gql`
    mutation CreateClaim($b2bUnitId: ID!, $baseSiteId: ID!, $baseStoreId: ID!, $input: ClCreateClaimInput!) {
  createClaim(
    b2bUnitId: $b2bUnitId
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    input: $input
  ) {
    wasSuccessful
    id
    errors {
      type
      reason
      message
      subjectType
      subject
      errorCode
      language
      position
      exceptionMessage
    }
  }
}
    ` as unknown as DocumentNode<CreateClaimMutation, CreateClaimMutationVariables>;
export const SubmitContactUsSupportDocument = gql`
    mutation SubmitContactUsSupport($b2bUnitId: ID!, $baseSiteId: ID!, $baseStoreId: ID!, $supportForm: CuSupportFormInput!, $attachments: [CuAttachmentInput!]) {
  submitContactUsSupport(
    b2bUnitId: $b2bUnitId
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    supportForm: $supportForm
    attachments: $attachments
  ) {
    id
    wasSuccessful
    message
    ruleErrors {
      message
      id
    }
  }
}
    ` as unknown as DocumentNode<SubmitContactUsSupportMutation, SubmitContactUsSupportMutationVariables>;
export const ProductRecommendationsDocument = gql`
    query ProductRecommendations($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $trackingId: String!, $coveoToken: String!, $currency: String!, $country: String!, $language: String!, $slotId: ID, $page: PRRecommendationSlotType, $strategy: PRRecommendationStrategy, $productId: ID, $cartProducts: [PRProductItemInput!], $purchasedProducts: [PRProductItemInput!]) {
  productRecommendations(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    trackingId: $trackingId
    coveoToken: $coveoToken
    currency: $currency
    country: $country
    language: $language
    slotId: $slotId
    page: $page
    strategy: $strategy
    productId: $productId
    cartProducts: $cartProducts
    purchasedProducts: $purchasedProducts
  ) {
    id
    responseId
    title
    items {
      id
      productCode
      name
      EAN
      GTIN
      NDC
      images {
        thumbnail {
          id
          imageType
          format
          url
          altText
          index
        }
        zoom {
          id
          imageType
          format
          url
          altText
          index
        }
        product {
          id
          imageType
          format
          url
          altText
          index
        }
      }
      uoms {
        id
        unit {
          id
          displayValue
          name
          code
        }
        grossWeight
        netWeight
        grossWeightUnit {
          id
          displayValue
          name
          code
        }
        netWeightUnit {
          id
          displayValue
          name
          code
        }
      }
      volumePrices {
        id
        price {
          value
          currency
          formattedValue
        }
        formattedPrice
        isCustomerPrice
        uom
      }
      stock {
        status
        stockColor
      }
      promotions {
        id
        value {
          formattedValue
        }
      }
      availabilityStatus
      freeGoods {
        id
        buyQuantity
        getQuantity
        isPromotionAvailable
      }
    }
  }
}
    ` as unknown as DocumentNode<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>;
export const B2bUnitsDocument = gql`
    query B2bUnits($baseSiteId: ID!, $baseStoreId: ID!) {
  b2bUnits(baseSiteId: $baseSiteId, baseStoreId: $baseStoreId) {
    id
    b2bUnitId
    name
    b2bNumber
    address
    hasRestrictedProducts
  }
}
    ` as unknown as DocumentNode<B2bUnitsQuery, B2bUnitsQueryVariables>;
export const DeliveryDocument = gql`
    query Delivery($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $currency: String, $language: String, $deliveryId: ID!) {
  delivery(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    currency: $currency
    language: $language
    deliveryId: $deliveryId
  ) {
    id
    deliveryId
    deliveryMessage
    shipToCustomer {
      id
      number
      name
      address {
        id
        addressId
        addressType
        description
        company
        name
        street
        houseNumber
        city
        zip
        region
        country {
          name
          isoCode
        }
      }
    }
    pgaDate
    deliveryStatus
    shipmentStatus
    items {
      id
      productId
      name
      isProductAvailable
      images {
        thumbnail {
          id
          imageType
          format
          url
          altText
          index
        }
        zoom {
          id
          imageType
          format
          url
          altText
          index
        }
        product {
          id
          imageType
          format
          url
          altText
          index
        }
      }
      actualDeliveryQuantity
      batch
      status
      statusMessage
      isExistsInB2BHybris
      poNumber
      orderId
      invoiceId
      uom {
        id
        code
        name
      }
    }
    totalWeight
    totalWeightUnit
    totalVolume
    totalVolumeUnit
  }
}
    ` as unknown as DocumentNode<DeliveryQuery, DeliveryQueryVariables>;
export const PaymentAdviceExcelDownloadDocument = gql`
    mutation PaymentAdviceExcelDownload($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $docDetails: [PayExDocDetailsInput]) {
  paymentAdviceExcelDownload(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    docDetails: $docDetails
  ) {
    id
    filename
    base64Data
    contentType
  }
}
    ` as unknown as DocumentNode<PaymentAdviceExcelDownloadMutation, PaymentAdviceExcelDownloadMutationVariables>;
export const UserAccountDocument = gql`
    query UserAccount($b2bUnitId: ID!, $baseSiteId: ID!, $baseStoreId: ID!, $filters: MaMyAccountFilters, $language: String) {
  userAccount(
    b2bUnitId: $b2bUnitId
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    filters: $filters
    language: $language
  ) {
    accountDetails {
      id
      creditBlock
      creditExposure {
        currency
        formattedValue
        priceType
        value
      }
      creditLimit {
        value
        priceType
        formattedValue
        currency
      }
      creditUtilized
      effectiveCreditLimit {
        value
        priceType
        formattedValue
        currency
      }
      paymentTerms
      bankName
      accountNumber
      lastPayment
      lastPaymentReceived {
        value
        currency
        formattedValue
        priceType
      }
    }
    accountBalance {
      id
      text
      value
      currency
      formattedValue
      priceType
    }
    accountDocuments {
      id
      documentDate
      status
      amount {
        value
        currency
        formattedValue
        priceType
      }
      assignment
      clearingDocument
      customerReference
      documentNumber
      documentType
      payer
      paymentDueDate
      soldTo
      type
    }
    excelFile
  }
}
    ` as unknown as DocumentNode<UserAccountQuery, UserAccountQueryVariables>;
export const GetMyProfileDocument = gql`
    query GetMyProfile($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!) {
  me(baseSiteId: $baseSiteId, baseStoreId: $baseStoreId, b2bUnitId: $b2bUnitId) {
    id
    title
    firstName
    lastName
    email
    phone
  }
}
    ` as unknown as DocumentNode<GetMyProfileQuery, GetMyProfileQueryVariables>;
export const GetB2BUnitInfoDocument = gql`
    query GetB2BUnitInfo($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!) {
  b2bUnitInfo(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
  ) {
    id
    name
    address
    region
    country {
      name
      isoCode
    }
    telephone
  }
}
    ` as unknown as DocumentNode<GetB2BUnitInfoQuery, GetB2BUnitInfoQueryVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($baseSiteId: ID!, $input: CusUpdateProfileInput!) {
  updateUserProfile(baseSiteId: $baseSiteId, input: $input) {
    id
    title
    firstName
    lastName
    email
    phone
  }
}
    ` as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const OrderConfirmationDocument = gql`
    mutation OrderConfirmation($baseSiteId: ID!, $cartId: ID!, $paymentDetails: OcPaymentDetailsInput) {
  orderConfirmation(
    baseSiteId: $baseSiteId
    cartId: $cartId
    paymentDetails: $paymentDetails
  ) {
    id
    wasSuccessful
    ruleErrors {
      message
    }
    orderId
  }
}
    ` as unknown as DocumentNode<OrderConfirmationMutation, OrderConfirmationMutationVariables>;
export const OrderDocument = gql`
    query Order($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $orderId: ID!, $currency: String, $language: String) {
  order(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    orderId: $orderId
    currency: $currency
    language: $language
  ) {
    id
    orderId
    status
    statusCode
    poNumber
    requestedDeliveryDate
    deliveryTrackingUrls
    deliveryAddress {
      id
      addressId
      addressType
      description
      company
      name
      street
      houseNumber
      city
      zip
      region
      country {
        name
        isoCode
      }
    }
    customerMessage
    grossTotal {
      value
      currency
      formattedValue
    }
    netTotal {
      value
      currency
      formattedValue
    }
    taxTotal {
      value
      currency
      formattedValue
    }
    rejectionReason
    items {
      id
      productId
      name
      isProductAvailable
      images {
        thumbnail {
          id
          imageType
          format
          url
          altText
          index
        }
        zoom {
          id
          imageType
          format
          url
          altText
          index
        }
        product {
          id
          imageType
          format
          url
          altText
          index
        }
      }
      customerMaterialNumber
      uom {
        id
        code
        name
      }
      unitPrice {
        value
        currency
        formattedValue
      }
      totalPrice {
        value
        currency
        formattedValue
      }
      orderedQuantity
      deliveredQuantity
      confirmedQuantity
      expDeliveryDate
      status
      deliveryId
      invoiceId
    }
  }
}
    ` as unknown as DocumentNode<OrderQuery, OrderQueryVariables>;
export const CreateOrderTemplateDocument = gql`
    mutation CreateOrderTemplate($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $input: OtCreateOrderTemplateInput!) {
  createOrderTemplate(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    input: $input
  ) {
    id
    orderTemplateCode
    orderTemplateName
    wasSuccessful
    ruleErrors {
      id
      message
    }
  }
}
    ` as unknown as DocumentNode<CreateOrderTemplateMutation, CreateOrderTemplateMutationVariables>;
export const DeleteOrderTemplateDocument = gql`
    mutation DeleteOrderTemplate($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $orderTemplateCode: ID!) {
  deleteOrderTemplate(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    orderTemplateCode: $orderTemplateCode
  ) {
    id
    wasSuccessful
    ruleErrors {
      id
      message
    }
  }
}
    ` as unknown as DocumentNode<DeleteOrderTemplateMutation, DeleteOrderTemplateMutationVariables>;
export const InitiateOrderTemplateDownloadDocument = gql`
    mutation InitiateOrderTemplateDownload($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!) {
  initiateOrderTemplateDownload(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
  ) {
    id
    status
    createdAt
  }
}
    ` as unknown as DocumentNode<InitiateOrderTemplateDownloadMutation, InitiateOrderTemplateDownloadMutationVariables>;
export const GetOrderTemplateDownloadStatusDocument = gql`
    query GetOrderTemplateDownloadStatus($downloadId: ID!) {
  getOrderTemplateDownloadStatus(downloadId: $downloadId) {
    downloadId
    status
    progress
    message
    error
  }
}
    ` as unknown as DocumentNode<GetOrderTemplateDownloadStatusQuery, GetOrderTemplateDownloadStatusQueryVariables>;
export const SearchOrderTemplatesDocument = gql`
    query SearchOrderTemplates($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $orderTemplateCode: String, $orderTemplateName: String, $fromDate: String, $toDate: String) {
  searchOrderTemplates(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    orderTemplateCode: $orderTemplateCode
    orderTemplateName: $orderTemplateName
    fromDate: $fromDate
    toDate: $toDate
  ) {
    id
    orderTemplates {
      id
      orderTemplateCode
      orderTemplateName
      orderCreatedDate
      entries {
        entryNumber
        quantity
        product {
          code
          name
          url
          images {
            altText
            format
            imageType
            url
          }
        }
        zsalesUnit {
          code
          name
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<SearchOrderTemplatesQuery, SearchOrderTemplatesQueryVariables>;
export const UpdateOrderTemplateDocument = gql`
    mutation UpdateOrderTemplate($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $input: OtUpdateOrderTemplateRequestBody!) {
  updateOrderTemplate(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    input: $input
  ) {
    id
    wasSuccessful
    ruleErrors {
      id
      message
    }
  }
}
    ` as unknown as DocumentNode<UpdateOrderTemplateMutation, UpdateOrderTemplateMutationVariables>;
export const ValidateEntriesAndUpdateOrderTemplateDocument = gql`
    mutation ValidateEntriesAndUpdateOrderTemplate($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $input: OtUpdateOrderTemplateRequestBody!) {
  validateEntriesAndUpdateOrderTemplate(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    input: $input
  ) {
    validation {
      id
      result
      errors {
        id
        row
        productId
        errorCode
      }
    }
    updateOrderTemplateResult {
      id
      wasSuccessful
      ruleErrors {
        id
        message
        ... on OtStandardRuleError {
          id
          message
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<ValidateEntriesAndUpdateOrderTemplateMutation, ValidateEntriesAndUpdateOrderTemplateMutationVariables>;
export const OrderHistoryDocument = gql`
    query OrderHistory($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $limit: Int) {
  orderHistory(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    limit: $limit
  ) {
    id
    orderId
    orderDate
    purchaseOrderNumber
    status
  }
}
    ` as unknown as DocumentNode<OrderHistoryQuery, OrderHistoryQueryVariables>;
export const CardRemoveDocument = gql`
    mutation CardRemove($baseSiteId: ID!, $cardId: ID!) {
  cardRemove(baseSiteId: $baseSiteId, cardId: $cardId) {
    id
    wasSuccessful
  }
}
    ` as unknown as DocumentNode<CardRemoveMutation, CardRemoveMutationVariables>;
export const CardSelectDocument = gql`
    mutation CardSelect($baseSiteId: ID!, $cartId: ID!, $cardId: ID!) {
  cardSelect(baseSiteId: $baseSiteId, cartId: $cartId, cardId: $cardId) {
    id
    wasSuccessful
  }
}
    ` as unknown as DocumentNode<CardSelectMutation, CardSelectMutationVariables>;
export const CardSetDocument = gql`
    mutation CardSet($baseSiteId: ID!, $baseStoreId: ID!, $cartId: ID!, $input: PayCSaveCardInput!, $shouldSave: Boolean!) {
  cardSet(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    cartId: $cartId
    input: $input
    shouldSave: $shouldSave
  ) {
    id
    cardId
    accountHolderName
    billingAddress {
      id
      addressId
      isDefault
      isShippingAddress
      isAddressBook
      firstName
      formattedAddress
      line1
      line2
      zip
      phone
      town
      region
      email
    }
    cardNumber
    cardType {
      id
      code
      name
    }
    defaultPayment
    expiryMonth
    expiryYear
    saved
    subscriptionId
  }
}
    ` as unknown as DocumentNode<CardSetMutation, CardSetMutationVariables>;
export const PayCapturePaymentDocument = gql`
    mutation PayCapturePayment($token: String!, $baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!) {
  payCapturePayment(
    token: $token
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
  ) {
    wasSuccessful
    cardDetails {
      cardType
      cardTypeCode
      cardNumber
      cardExpiryMonth
      cardExpiryYear
      cardHolderName
    }
    transaction {
      errorNo
      errorDesc
      warning
      cavv
      paResStatus
      eciFlag
      dsTransactionId
      threeDSVersion
    }
    ruleErrors {
      ... on PayPaymentGenericError {
        id
        message
      }
      ... on PayProcessRequestError {
        id
        code
        message
      }
      ... on PayCreateRequestError {
        id
        code
        message
      }
      ... on PayRetrieveResponseError {
        id
        code
        message
      }
      ... on PayMissingResponsePacketError {
        id
        code
        message
      }
      ... on PayDeserializeResponsePacketError {
        id
        code
        message
      }
      ... on PayInterceptEcommError {
        id
        code
        message
      }
      ... on PayValidateMerchantGuidError {
        id
        code
        message
      }
      ... on PayValidateSignatureError {
        id
        code
        message
      }
      ... on PayValidateRequestPacketError {
        id
        code
        message
      }
      ... on PayExpireSessionError {
        id
        code
        message
      }
      ... on PayHandleSessionError {
        id
        code
        message
      }
      ... on PayDecryptDataError {
        id
        code
        message
      }
      ... on PayGetAccessTokenError {
        id
        code
        message
      }
      ... on PayRequestPurchasedTypeError {
        id
        code
        message
      }
      ... on PayXiSecureError {
        id
        code
        message
      }
      ... on PayGetXiSecureTokenError {
        id
        code
        message
      }
      ... on PayExpireXiSecureCertificateError {
        id
        code
        message
      }
      ... on PayAccessDatabaseError {
        id
        code
        message
      }
      ... on PayPreventDuplicateSubmissionError {
        id
        code
        message
      }
      ... on PayHandleCardinalResponseError {
        id
        code
        message
      }
      ... on PayLoadCardinalConfigurationError {
        id
        code
        message
      }
      ... on PayValidateCardinalConfigurationError {
        id
        code
        message
      }
      ... on PayLoadPaymentPageIframeError {
        id
        code
        message
      }
      ... on PayPaymentConfigError {
        id
        code
        message
      }
    }
  }
}
    ` as unknown as DocumentNode<PayCapturePaymentMutation, PayCapturePaymentMutationVariables>;
export const PayInitiate3DsDocument = gql`
    mutation PayInitiate3DS($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $redirectUrl: String!, $amount: Float!, $currency: String!, $orderNumber: String!, $cardData: PayCardDataInput!, $billingAddress: PayBillingAddressInput!, $shippingAddress: PayShippingAddressInput!, $clientDevice: PayClientDeviceInput!) {
  payInitiate3DS(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    redirectUrl: $redirectUrl
    amount: $amount
    currency: $currency
    orderNumber: $orderNumber
    cardData: $cardData
    billingAddress: $billingAddress
    shippingAddress: $shippingAddress
    clientDevice: $clientDevice
  ) {
    wasSuccessful
    token
    ruleErrors {
      ... on PayPaymentGenericError {
        id
        message
      }
      ... on PayProcessRequestError {
        id
        code
        message
      }
      ... on PayCreateRequestError {
        id
        code
        message
      }
      ... on PayRetrieveResponseError {
        id
        code
        message
      }
      ... on PayMissingResponsePacketError {
        id
        code
        message
      }
      ... on PayDeserializeResponsePacketError {
        id
        code
        message
      }
      ... on PayInterceptEcommError {
        id
        code
        message
      }
      ... on PayValidateMerchantGuidError {
        id
        code
        message
      }
      ... on PayValidateSignatureError {
        id
        code
        message
      }
      ... on PayValidateRequestPacketError {
        id
        code
        message
      }
      ... on PayExpireSessionError {
        id
        code
        message
      }
      ... on PayHandleSessionError {
        id
        code
        message
      }
      ... on PayDecryptDataError {
        id
        code
        message
      }
      ... on PayGetAccessTokenError {
        id
        code
        message
      }
      ... on PayRequestPurchasedTypeError {
        id
        code
        message
      }
      ... on PayXiSecureError {
        id
        code
        message
      }
      ... on PayGetXiSecureTokenError {
        id
        code
        message
      }
      ... on PayExpireXiSecureCertificateError {
        id
        code
        message
      }
      ... on PayAccessDatabaseError {
        id
        code
        message
      }
      ... on PayPreventDuplicateSubmissionError {
        id
        code
        message
      }
      ... on PayHandleCardinalResponseError {
        id
        code
        message
      }
      ... on PayLoadCardinalConfigurationError {
        id
        code
        message
      }
      ... on PayValidateCardinalConfigurationError {
        id
        code
        message
      }
      ... on PayLoadPaymentPageIframeError {
        id
        code
        message
      }
      ... on PayPaymentConfigError {
        id
        code
        message
      }
    }
  }
}
    ` as unknown as DocumentNode<PayInitiate3DsMutation, PayInitiate3DsMutationVariables>;
export const PayInitiateDocument = gql`
    mutation PayInitiate($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!) {
  payInitiate(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
  ) {
    wasSuccessful
    token
    ruleErrors {
      ... on PayPaymentGenericError {
        id
        message
      }
      ... on PayProcessRequestError {
        id
        code
        message
      }
      ... on PayCreateRequestError {
        id
        code
        message
      }
      ... on PayRetrieveResponseError {
        id
        code
        message
      }
      ... on PayMissingResponsePacketError {
        id
        code
        message
      }
      ... on PayDeserializeResponsePacketError {
        id
        code
        message
      }
      ... on PayInterceptEcommError {
        id
        code
        message
      }
      ... on PayValidateMerchantGuidError {
        id
        code
        message
      }
      ... on PayValidateSignatureError {
        id
        code
        message
      }
      ... on PayValidateRequestPacketError {
        id
        code
        message
      }
      ... on PayExpireSessionError {
        id
        code
        message
      }
      ... on PayHandleSessionError {
        id
        code
        message
      }
      ... on PayDecryptDataError {
        id
        code
        message
      }
      ... on PayGetAccessTokenError {
        id
        code
        message
      }
      ... on PayRequestPurchasedTypeError {
        id
        code
        message
      }
      ... on PayXiSecureError {
        id
        code
        message
      }
      ... on PayGetXiSecureTokenError {
        id
        code
        message
      }
      ... on PayExpireXiSecureCertificateError {
        id
        code
        message
      }
      ... on PayAccessDatabaseError {
        id
        code
        message
      }
      ... on PayPreventDuplicateSubmissionError {
        id
        code
        message
      }
      ... on PayHandleCardinalResponseError {
        id
        code
        message
      }
      ... on PayLoadCardinalConfigurationError {
        id
        code
        message
      }
      ... on PayValidateCardinalConfigurationError {
        id
        code
        message
      }
      ... on PayLoadPaymentPageIframeError {
        id
        code
        message
      }
      ... on PayPaymentConfigError {
        id
        code
        message
      }
    }
  }
}
    ` as unknown as DocumentNode<PayInitiateMutation, PayInitiateMutationVariables>;
export const PaymentConfigDocument = gql`
    query PaymentConfig($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!) {
  paymentConfig(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
  ) {
    paymetricMerchantGUID
    paymetric3DSEnabled
    id
    checkoutPaymentTypes
    paymetricBaseUrl
  }
}
    ` as unknown as DocumentNode<PaymentConfigQuery, PaymentConfigQueryVariables>;
export const PaymentTypeUpdateDocument = gql`
    mutation PaymentTypeUpdate($baseSiteId: ID!, $cartId: ID!, $paymentType: PayPaymentTypeEnum!) {
  paymentTypeUpdate(
    baseSiteId: $baseSiteId
    cartId: $cartId
    paymentType: $paymentType
  ) {
    wasSuccessful
    payment {
      id
      cardId
      accountHolderName
      billingAddress {
        id
        addressId
        isDefault
        isShippingAddress
        isAddressBook
        firstName
        formattedAddress
        line1
        line2
        zip
        phone
        town
        region
        country {
          name
          isoCode
        }
        email
      }
      cardNumber
      cardType {
        id
        code
        name
      }
      defaultPayment
      expiryMonth
      expiryYear
      saved
      subscriptionId
    }
  }
}
    ` as unknown as DocumentNode<PaymentTypeUpdateMutation, PaymentTypeUpdateMutationVariables>;
export const CardsDocument = gql`
    query Cards($baseSiteId: ID!) {
  cards(baseSiteId: $baseSiteId) {
    id
    payments {
      id
      cardId
      accountHolderName
      billingAddress {
        id
        addressId
        isDefault
        isShippingAddress
        isAddressBook
        firstName
        formattedAddress
        line1
        line2
        zip
        phone
        town
        region
        email
      }
      cardNumber
      cardType {
        id
        code
        name
      }
      defaultPayment
      expiryMonth
      expiryYear
      saved
      subscriptionId
    }
  }
}
    ` as unknown as DocumentNode<CardsQuery, CardsQueryVariables>;
export const ProductReferencesDocument = gql`
    query ProductReferences($baseSiteId: ID!, $cartId: ID!, $productCode: ID!, $language: String, $currency: String) {
  productReferences(
    baseSiteId: $baseSiteId
    cartId: $cartId
    productCode: $productCode
    language: $language
    currency: $currency
  ) {
    id
    items {
      id
      referenceType
      target {
        volumePrices {
          id
          price {
            value
            currency
            formattedValue
          }
          minQuantity
          maxQuantity
          formattedPrice
          isCustomerPrice
          uom
        }
        url
        uoms {
          id
          unit {
            id
            displayValue
            name
            code
          }
          grossWeight
          netWeight
          grossWeightUnit {
            id
            displayValue
            name
            code
          }
          netWeightUnit {
            id
            displayValue
            name
            code
          }
        }
        summary
        stock {
          id
          status
          quantity
          fromData
          stockColor
        }
        promotions {
          id
          type
          value {
            value
            currency
            formattedValue
          }
        }
        productCode
        name
        manufacturer
        isPurchasable
        isNewProduct
        images {
          thumbnail {
            id
            imageType
            format
            url
            altText
            index
          }
          zoom {
            id
            imageType
            format
            url
            altText
            index
          }
          product {
            id
            imageType
            format
            url
            altText
            index
          }
        }
        id
        freeGoods {
          id
          isPromotionAvailable
          buyQuantity
          getQuantity
          unitOfFreeProduct
        }
        description
        categories {
          id
          categoryCode
          name
          url
          categoryImage {
            id
            imageType
            format
            url
            altText
            index
          }
        }
        availabilityStatus
        additionalInformation
        NDC
        GTIN
        EAN
      }
    }
  }
}
    ` as unknown as DocumentNode<ProductReferencesQuery, ProductReferencesQueryVariables>;
export const ProductDetailsDocument = gql`
    query ProductDetails($b2bUnitId: ID!, $baseSiteId: ID!, $baseStoreId: ID!, $productCode: ID!, $language: String, $currency: String) {
  productDetails(
    b2bUnitId: $b2bUnitId
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    productCode: $productCode
    language: $language
    currency: $currency
  ) {
    volumePrices {
      id
      price {
        value
        currency
        formattedValue
      }
      formattedPrice
      isCustomerPrice
      uom
    }
    url
    uoms {
      id
      unit {
        id
        displayValue
        name
        code
      }
      grossWeight
      netWeight
      grossWeightUnit {
        id
        displayValue
        name
        code
      }
      netWeightUnit {
        id
        displayValue
        name
        code
      }
    }
    summary
    stock {
      id
      status
      quantity
      fromData
      stockColor
    }
    promotions {
      id
      type
      value {
        value
        currency
        formattedValue
      }
    }
    productCode
    name
    manufacturer
    isPurchasable
    isNewProduct
    images {
      thumbnail {
        id
        imageType
        format
        url
        altText
        index
      }
      zoom {
        id
        imageType
        format
        url
        altText
        index
      }
      product {
        id
        imageType
        format
        url
        altText
        index
      }
    }
    id
    freeGoods {
      id
      isPromotionAvailable
      buyQuantity
      getQuantity
      unitOfFreeProduct
    }
    description
    categories {
      id
      categoryCode
      name
      url
      categoryImage {
        id
        imageType
        format
        url
        altText
        index
      }
    }
    breadcrumbs {
      id
      facetCode
      facetName
      facetCodeValue
      facetNameValue
    }
    GTIN
    EAN
    NDC
    additionalInformation
    availabilityStatus
  }
}
    ` as unknown as DocumentNode<ProductDetailsQuery, ProductDetailsQueryVariables>;
export const AllB2BUnitsDocument = gql`
    query AllB2BUnits($baseSiteId: ID!, $baseStoreId: ID!) {
  allB2bUnits(baseSiteId: $baseSiteId, baseStoreId: $baseStoreId) {
    id
    b2bUnitId
    name
    b2bNumber
    address
  }
}
    ` as unknown as DocumentNode<AllB2BUnitsQuery, AllB2BUnitsQueryVariables>;
export const BillingDocsDocument = gql`
    query BillingDocs($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $filters: OhBillingDocumentFilters, $language: String) {
  billingDocs(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    filters: $filters
    language: $language
  ) {
    documents {
      ... on OhBillingDocument {
        id
        documentId
        date
        customerId
        paymentDueDate
        referenceNumber
        status
        statusCode
        total {
          currency
          formattedValue
          value
        }
      }
    }
    excelFile
  }
}
    ` as unknown as DocumentNode<BillingDocsQuery, BillingDocsQueryVariables>;
export const DownloadDocumentDocument = gql`
    query DownloadDocument($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $type: OhDocumentTypeDownloadEnum!, $documentIds: [ID!]!) {
  downloadDocument(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    type: $type
    documentIds: $documentIds
  ) {
    base64Data
    contentType
    filename
  }
}
    ` as unknown as DocumentNode<DownloadDocumentQuery, DownloadDocumentQueryVariables>;
export const InvoiceDetailsDocument = gql`
    query InvoiceDetails($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $invoiceId: ID!, $b2bCustomerId: ID, $language: String, $currency: String) {
  invoice(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    invoiceId: $invoiceId
    b2bCustomerId: $b2bCustomerId
    currency: $currency
    language: $language
  ) {
    id
    invoiceId
    payer {
      id
      payerId
      name
      address {
        id
        addressId
        addressType
        description
        company
        name
        street
        houseNumber
        city
        zip
        region
        country {
          name
          isoCode
        }
      }
    }
    payment {
      id
      terms
      dueDate
    }
    grossTotal {
      value
      currency
      formattedValue
    }
    netTotal {
      value
      currency
      formattedValue
    }
    taxTotal {
      value
      currency
      formattedValue
    }
    items {
      id
      productId
      name
      isProductAvailable
      images {
        thumbnail {
          id
          imageType
          format
          url
          altText
          index
        }
        zoom {
          id
          imageType
          format
          url
          altText
          index
        }
        product {
          id
          imageType
          format
          url
          altText
          index
        }
      }
      uom {
        id
        name
        code
      }
      unitPrice {
        value
        currency
        formattedValue
      }
      totalPrice {
        value
        currency
        formattedValue
      }
      quantity
      deliveredQuantity
      orderId
      deliveryId
    }
  }
}
    ` as unknown as DocumentNode<InvoiceDetailsQuery, InvoiceDetailsQueryVariables>;
export const OrderDetailsDocument = gql`
    query OrderDetails($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $orderId: ID!, $language: String, $currency: String) {
  order(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    orderId: $orderId
    currency: $currency
    language: $language
  ) {
    id
    orderId
    status
    poNumber
    requestedDeliveryDate
    deliveryTrackingUrls
    deliveryAddress {
      id
      addressId
      addressType
      company
      name
      street
      houseNumber
      city
      zip
      region
      country {
        name
        isoCode
      }
    }
    customerMessage
    grossTotal {
      value
      currency
      formattedValue
    }
    netTotal {
      value
      currency
      formattedValue
    }
    taxTotal {
      value
      currency
      formattedValue
    }
    rejectionReason
    items {
      id
      productId
      name
      isProductAvailable
      images {
        thumbnail {
          id
          imageType
          format
          url
          altText
          index
        }
        zoom {
          id
          imageType
          format
          url
          altText
          index
        }
        product {
          id
          imageType
          format
          url
          altText
          index
        }
      }
      customerMaterialNumber
      uom {
        id
        name
        code
      }
      unitPrice {
        value
        currency
        formattedValue
      }
      totalPrice {
        value
        currency
        formattedValue
      }
      orderedQuantity
      deliveredQuantity
      expDeliveryDate
      status
      deliveryId
      invoiceId
    }
    statusCode
  }
}
    ` as unknown as DocumentNode<OrderDetailsQuery, OrderDetailsQueryVariables>;
export const ShipToPartyDocument = gql`
    query ShipToParty($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!) {
  shipToParty(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
  ) {
    id
    name
    value
  }
}
    ` as unknown as DocumentNode<ShipToPartyQuery, ShipToPartyQueryVariables>;
export const OrderHistoryV2Document = gql`
    query OrderHistoryV2($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $filters: OhOrderHistoryFilters, $language: String) {
  orderHistoryV2(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    filters: $filters
    language: $language
  ) {
    documents {
      ... on OhOrder {
        id
        orderId
        orderDate
        rddDate
        b2bCustomer
        orderType
        purchaseOrderNumber
        status
        statusCode
        total {
          currency
          formattedValue
          value
        }
      }
      ... on OhDelivery {
        id
        deliveryId
        documentType
        eta
        pgiDate
        purchaseOrderNumber
        salesOrder
        shipToCustomer
        shipment
        status
      }
    }
    excelFile
  }
}
    ` as unknown as DocumentNode<OrderHistoryV2Query, OrderHistoryV2QueryVariables>;
export const GetReportDocument = gql`
    query GetReport($baseSiteId: ID!, $baseStoreId: ID!, $reportId: ID!) {
  getReport(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    reportId: $reportId
  ) {
    id
    wasSuccessful
    report {
      id
      reportId
      name
      workspaceId
      datasetId
      identity
      powerbiRole
      embedurl
      tokenId
      token
      tokenExpiry
    }
    ruleErrors {
      id
      message
      type
      reason
      subjectType
      subject
      errorCode
      language
      position
      exceptionMessage
    }
  }
}
    ` as unknown as DocumentNode<GetReportQuery, GetReportQueryVariables>;
export const ClSearchDocument = gql`
    query ClSearch($b2bUnitId: ID!, $baseSiteId: ID!, $baseStoreId: ID!, $filters: ClSearchFilters!) {
  clSearch(
    b2bUnitId: $b2bUnitId
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    filters: $filters
  ) {
    id
    base64Data
    claims {
      id
      claimId
      date
      customerClaimReference
      activityNumber
      description
      amount
      approvedAmount
      currency {
        isoCode
      }
      status
      creditMemo
      hasPdfFile
    }
  }
}
    ` as unknown as DocumentNode<ClSearchQuery, ClSearchQueryVariables>;
export const ClaimDocumentsZipDocument = gql`
    query ClaimDocumentsZip($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $claimId: ID!, $fields: String) {
  claimDocumentsZip(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    claimId: $claimId
    fields: $fields
  ) {
    id
    filename
    base64Data
  }
}
    ` as unknown as DocumentNode<ClaimDocumentsZipQuery, ClaimDocumentsZipQueryVariables>;
export const SearchPaymentDocumentsDocument = gql`
    query SearchPaymentDocuments($baseSiteId: ID!, $baseStoreId: ID!, $b2bUnitId: ID!, $fields: String, $language: String, $currency: String, $filters: PayExPaymentDocumentsFilters) {
  searchPaymentDocuments(
    baseSiteId: $baseSiteId
    baseStoreId: $baseStoreId
    b2bUnitId: $b2bUnitId
    fields: $fields
    language: $language
    currency: $currency
    filters: $filters
  ) {
    id
    paymentAdviceList {
      id
      paymentAdviceNumber
      amount {
        value
        currency
        formattedValue
      }
      closeureDate
      closeureTime
      dateReceived
      timeReceived
      status
    }
  }
}
    ` as unknown as DocumentNode<SearchPaymentDocumentsQuery, SearchPaymentDocumentsQueryVariables>;
export const OrderSimulationDocument = gql`
    query OrderSimulation($baseSiteId: ID!, $cartId: ID!, $fields: String, $language: String, $currency: String) {
  orderSimulation(
    baseSiteId: $baseSiteId
    cartId: $cartId
    fields: $fields
    language: $language
    currency: $currency
  ) {
    id
    orderId
    deliveryAddress {
      id
      addressId
      isDefault
      isShippingAddress
      isAddressBook
      firstName
      formattedAddress
      line1
      line2
      zip
      phone
      town
      region
      country {
        name
        isoCode
      }
    }
    requestedDeliveryDate
    vehicleResult {
      id
      vehicleType
      vehicleNumber {
        id
        value
        percentage
        uom
        loadLead
      }
      weight {
        id
        value
        percentage
        uom
        loadLead
      }
      volume {
        id
        value
        percentage
        uom
        loadLead
      }
      footprint {
        id
        value
        percentage
        uom
        loadLead
      }
      fullPallet {
        id
        value
        percentage
        uom
        loadLead
      }
      fullLayer {
        id
        value
        percentage
        uom
        loadLead
      }
      fullCase {
        id
        value
        percentage
        uom
        loadLead
      }
    }
    purchaseOrderNumber
    customerMessage
    entries {
      id
      product {
        id
        productCode
        name
        description
        volumePrices {
          id
          price {
            value
            currency
            formattedValue
          }
          formattedPrice
          isCustomerPrice
          uom
        }
        images {
          thumbnail {
            id
            imageType
            format
            url
            altText
            index
          }
          zoom {
            id
            imageType
            format
            url
            altText
            index
          }
          product {
            id
            imageType
            format
            url
            altText
            index
          }
        }
        EAN
        GTIN
        NDC
        isNewProduct
        url
        breadcrumbs {
          id
          facetCode
          facetName
          facetCodeValue
          facetNameValue
        }
        availabilityStatus
        uoms {
          id
          unit {
            id
            displayValue
            name
            code
          }
          grossWeight
          netWeight
          grossWeightUnit {
            id
            displayValue
            name
            code
          }
          netWeightUnit {
            id
            displayValue
            name
            code
          }
        }
      }
      quantity
      totalPrice {
        value
        currency
        formattedValue
      }
      listPrice {
        id
        price {
          value
          currency
          formattedValue
        }
        minQuantity
        maxQuantity
        formattedPrice
        isCustomerPrice
        uom
      }
      customerPrice {
        id
        price {
          value
          currency
          formattedValue
        }
        minQuantity
        maxQuantity
        formattedPrice
        isCustomerPrice
        uom
      }
      basePrice {
        value
        currency
        formattedValue
      }
      selectedUom {
        id
        displayValue
        name
        code
      }
      totalWeight
      entryNumber
    }
    paymentType
    totalPrice {
      value
      currency
      formattedValue
    }
    totalPriceWithTax {
      value
      currency
      formattedValue
    }
    totalTax {
      value
      currency
      formattedValue
    }
    ruleErrors {
      id
      messageId
      messageText
      messageNumber
    }
    ruleWarning {
      id
      messageId
      messageText
      messageNumber
    }
    paymentInfo {
      id
      accountHolderName
      cardNumber
      cardId
      cardType {
        id
        code
        name
      }
      defaultPayment
      expiryMonth
      expiryYear
      saved
      subscriptionId
      billingAddress {
        id
        addressId
        isDefault
        isShippingAddress
        isAddressBook
        firstName
        formattedAddress
        line1
        line2
        zip
        phone
        town
        region
        country {
          name
          isoCode
        }
        email
      }
    }
  }
}
    ` as unknown as DocumentNode<OrderSimulationQuery, OrderSimulationQueryVariables>;